/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(63);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addLunaClass = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = __webpack_require__(25);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addLunaClass = function addLunaClass(props) {
  return _extends({}, props, {
    className: (0, _classnames2.default)(props.className, 'ln-c-icon')
  });
};

exports.addLunaClass = addLunaClass;

exports.default = /* istanbul ignore next */function (Component) {
  return (
    /* istanbul ignore next */(0, _recompose.compose)((0, _recompose.setDisplayName)(Component.displayName || Component.name || 'Icon'), (0, _recompose.mapProps)(addLunaClass))(Component)
  );
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(93)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__environment_browser_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environment_hash_router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__environment_express_router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__environment_hapi_router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_link__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fragment__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__environment_browser_router__["a"]; });
/* unused harmony reexport routerForExpress */
/* unused harmony reexport routerForHapi */
/* unused harmony reexport routerForHash */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__components_link__["a"]; });
/* unused harmony reexport PersistentQueryLink */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__components_fragment__["a"]; });
/* unused harmony reexport push */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["e"]; });
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport block */
/* unused harmony reexport unblock */
/* unused harmony reexport replaceRoutes */
/* unused harmony reexport LOCATION_CHANGED */
/* unused harmony reexport PUSH */
/* unused harmony reexport REPLACE */
/* unused harmony reexport GO */
/* unused harmony reexport GO_FORWARD */
/* unused harmony reexport GO_BACK */
/* unused harmony reexport POP */
/* unused harmony reexport BLOCK */
/* unused harmony reexport UNBLOCK */
/* unused harmony reexport REPLACE_ROUTES */
/* unused harmony reexport DID_REPLACE_ROUTES */














/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Card = __webpack_require__(133);

Object.defineProperty(exports, 'Card', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_PathUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





/* harmony default export */ __webpack_exports__["a"] = (function (href) {
  if (typeof href === 'string') {
    var _parsePath = Object(__WEBPACK_IMPORTED_MODULE_0_history_PathUtils__["parsePath"])(href),
        _parsePath$search = _parsePath.search,
        _search = _parsePath$search === undefined ? '' : _parsePath$search,
        other = _objectWithoutProperties(_parsePath, ['search']);

    var _query = _search && __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(_search);

    return _query ? _extends({}, other, { query: _query, search: _search }) : _extends({}, other);
  }

  var search = href.search,
      query = href.query;


  var resolvedSearch = search || query && Object.keys(query).length && '?' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(query) || '';
  var resolvedQuery = query || __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(search || '');

  return _extends({}, href, {
    search: resolvedSearch,
    query: resolvedQuery
  });
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 8 */
/***/ (function(module, exports) {

var sections=[{text:"Your data at a glance",link:"/your-data-at-a-glance",cta:"Find out more",className:"data_glance"},{text:"Privacy policy",heading:"Our privacy policy",link:"/privacy-policy",cta:"Find out more",className:"privacy_policy"},{text:"Cookie policy",heading:"Our cookie policy",link:"/cookie-policy",cta:"Find out more",className:"cookie_policy"},{text:"How to keep your data safe",link:"/how-to-keep-your-data-safe",cta:"Find out more",className:"data_safety"},{text:"Your rights",link:"/your-rights",cta:"Find out more",className:"your_rights"},{text:"FAQ",link:"/faq",cta:"Find out more",className:"faq"}];module.exports={sections:sections,routerBase:"",marketingPermissionsUrl:"https://permissions.sainsburys.co.uk/"};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      onClick = _ref.onClick,
      type = _ref.type,
      title = _ref.title,
      containerElement = _ref.containerElement,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'disabled', 'fullWidth', 'onClick', 'type', 'title', 'containerElement']);

  var props = _extends({}, rest, {
    className: (0, _classnames2.default)('ln-c-button', className, {
      'is-disabled': disabled,
      'ln-c-button--full': fullWidth
    }),
    role: 'button',
    title: title,
    onClick: onClick
  });

  if (containerElement === 'button') {
    props = _extends({}, props, {
      disabled: disabled,
      'aria-disabled': disabled || undefined,
      type: type
    });
  }

  return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, props, children) : _react2.default.createElement(containerElement, props, children);
};

Button.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['button', 'submit']),
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  title: _propTypes2.default.string
};

Button.defaultProps = {
  className: undefined,
  disabled: false,
  fullWidth: false,
  type: 'button',
  containerElement: 'button',
  title: undefined
};

exports.default = Button;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOCATION_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GO_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GO_FORWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UNBLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REPLACE_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DID_REPLACE_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isNavigationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isNavigationActionWithPayload; });


var LOCATION_CHANGED = 'ROUTER_LOCATION_CHANGED';

var PUSH = 'ROUTER_PUSH';
var REPLACE = 'ROUTER_REPLACE';
var GO = 'ROUTER_GO';
var GO_BACK = 'ROUTER_GO_BACK';
var GO_FORWARD = 'ROUTER_GO_FORWARD';
var POP = 'ROUTER_POP';
var BLOCK = 'ROUTER_BLOCK';
var UNBLOCK = 'ROUTER_UNBLOCK';
var REPLACE_ROUTES = 'ROUTER_REPLACE_ROUTES';
var DID_REPLACE_ROUTES = 'ROUTER_DID_REPLACE_ROUTES';

var actionsWithPayload = [PUSH, REPLACE, GO, POP];
var actions = [].concat(actionsWithPayload, [GO_FORWARD, GO_BACK, POP, BLOCK, UNBLOCK]);

var isNavigationAction = function isNavigationAction(action) {
  return actions.indexOf(action.type) !== -1;
};

var isNavigationActionWithPayload = function isNavigationActionWithPayload(action) {
  return actionsWithPayload.indexOf(action.type) !== -1;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middleware__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enhancer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_create_installer__ = __webpack_require__(83);






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__util_create_installer__["a" /* default */])({ reducer: __WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */], middleware: __WEBPACK_IMPORTED_MODULE_1__middleware__["a" /* default */], enhancer: __WEBPACK_IMPORTED_MODULE_2__enhancer__["a" /* default */] }));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return replace; });
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export block */
/* unused harmony export unblock */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locationDidChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initializeCurrentLocation; });
/* unused harmony export replaceRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return didReplaceRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_flatten_routes__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var push = function push(href) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["h" /* PUSH */],
    payload: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])(href), { options: options })
  };
};

var replace = function replace(href) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["i" /* REPLACE */],
    payload: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])(href), { options: options })
  };
};

var go = function go(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* GO */],
    payload: index
  };
};

var goBack = function goBack() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* GO_BACK */] };
};
var goForward = function goForward() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* GO_FORWARD */] };
};

var block = function block(historyShouldBlock) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BLOCK */],
    payload: historyShouldBlock
  };
};

var unblock = function unblock() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__types__["k" /* UNBLOCK */] };
};

var locationDidChange = function locationDidChange(location) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* LOCATION_CHANGED */],
    payload: location
  };
};

var initializeCurrentLocation = function initializeCurrentLocation(location) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* LOCATION_CHANGED */],
    payload: location
  };
};

var replaceRoutes = function replaceRoutes(routes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["j" /* REPLACE_ROUTES */],
    payload: {
      routes: Object(__WEBPACK_IMPORTED_MODULE_2__util_flatten_routes__["a" /* default */])(routes),
      options: {
        updateRoutes: true
      }
    }
  };
};

var didReplaceRoutes = function didReplaceRoutes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* DID_REPLACE_ROUTES */]
  };
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(73);
var objectAssign = __webpack_require__(13);
var decodeComponent = __webpack_require__(74);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(78);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(79);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (oldQuery, newQuery) {
  var mergedQuery = _extends({}, oldQuery, newQuery);
  var search = '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(mergedQuery);

  return {
    query: mergedQuery,
    search: search
  };
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(33);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Grid = undefined;

var _GridWrapper = __webpack_require__(139);

var _GridWrapper2 = _interopRequireDefault(_GridWrapper);

var _GridItem = __webpack_require__(140);

var _GridItem2 = _interopRequireDefault(_GridItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Grid = {
  Wrapper: _GridWrapper2.default,
  Item: _GridItem2.default
};

exports.Grid = Grid;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccordionItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_accordion__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_accordion__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionItem=function(_React$Component){_inherits(AccordionItem,_React$Component);function AccordionItem(props){_classCallCheck(this,AccordionItem);var _this=_possibleConstructorReturn(this,(AccordionItem.__proto__||Object.getPrototypeOf(AccordionItem)).call(this,props));_this.state={isOpen:false};return _this;}_createClass(AccordionItem,[{key:"toggle",value:function toggle(){this.setState({isOpen:!this.state.isOpen});}},{key:"render",value:function render(){var _props=this.props,children=_props.children,title=_props.title;var isOpen=this.state.isOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_accordion__["Accordion"],{standalone:false,title:title,open:isOpen,titleElement:"h3"},children);}}]);return AccordionItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AccordionItem);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResponsiveHeader */
/* unused harmony export PlainHeader */
/* unused harmony export Tab */
/* unused harmony export Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_icons___ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_icons____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luna_react_icons___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_Tabs_scss__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_Tabs_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scss_Tabs_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResponsiveHeader=function ResponsiveHeader(_ref){var _ref$active=_ref.active,active=_ref$active===undefined?0:_ref$active,_ref$setActive=_ref.setActive,setActive=_ref$setActive===undefined?function(){}:_ref$setActive,_ref$items=_ref.items,items=_ref$items===undefined?[]:_ref$items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab_header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab_button tab_button--left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_icons___["ArrowLeft"],{onClick:function onClick(){return setActive(active-1);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab_slider"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{transition:"transform 0.5s ease-in-out",transform:"translateX(-"+active*200+"px)"}},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tab,{key:index,onSelect:function onSelect(){return setActive(index);},isActive:active===index,content:item.title});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab_button tab_button--right"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_icons___["ArrowRight"],{onClick:function onClick(){return setActive(active+1);}})));};var PlainHeader=function PlainHeader(_ref2){var _ref2$active=_ref2.active,active=_ref2$active===undefined?0:_ref2$active,setActive=_ref2.setActive,_ref2$items=_ref2.items,items=_ref2$items===undefined?[]:_ref2$items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab_header"},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tab,{key:index,onSelect:function onSelect(){return setActive(index);},isActive:active===index,content:item.title});}));};var Tab=function Tab(_ref3){var content=_ref3.content,onSelect=_ref3.onSelect,_ref3$isActive=_ref3.isActive,isActive=_ref3$isActive===undefined?false:_ref3$isActive;var classNames=__WEBPACK_IMPORTED_MODULE_1_classnames___default()("header_item",{"is-active":isActive});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:onSelect,className:classNames,role:"tab","aria-selected":isActive},content);};var Tabs=function(_React$Component){_inherits(Tabs,_React$Component);function Tabs(props){_classCallCheck(this,Tabs);var _this=_possibleConstructorReturn(this,(Tabs.__proto__||Object.getPrototypeOf(Tabs)).call(this,props));_this.state={active:0,responsive:false};_this.delta=200;_this.setActive=_this.setActive.bind(_this);_this.handleViewportChange=_this.handleViewportChange.bind(_this);var _props$items=props.items,items=_props$items===undefined?[]:_props$items;_this.defaultBreakpoint=250*items.length;//TODO: better implementation for this.
var _props$showArrowsAt=props.showArrowsAt,showArrowsAt=_props$showArrowsAt===undefined?_this.defaultBreakpoint:_props$showArrowsAt;_this.viewportChangeHandler=window.matchMedia("(max-width: "+Math.max(showArrowsAt,_this.defaultBreakpoint)+"px)");return _this;}_createClass(Tabs,[{key:"setActive",value:function setActive(index){var items=this.props.items;var tabIndex=Math.max(0,Math.min(index,items.length-1));this.setState({active:tabIndex});}},{key:"handleViewportChange",value:function handleViewportChange(event){var newState={responsive:false};if(event.matches){newState={responsive:true};}else{}this.setState(newState);}},{key:"componentDidMount",value:function componentDidMount(){this.handleViewportChange(this.viewportChangeHandler);this.viewportChangeHandler.addListener(this.handleViewportChange);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.viewportChangeHandler.removeListener(this.handleViewportChange);}},{key:"render",value:function render(){var _props$items2=this.props.items,items=_props$items2===undefined?[]:_props$items2;var _state=this.state,_state$active=_state.active,active=_state$active===undefined?0:_state$active,responsive=_state.responsive;var selectedContent=items[active]||{};var _selectedContent$titl=selectedContent.title,title=_selectedContent$titl===undefined?"":_selectedContent$titl,content=selectedContent.content,_selectedContent$imag=selectedContent.image,image=_selectedContent$imag===undefined?null:_selectedContent$imag;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tab__wrapper"},responsive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveHeader,{setActive:this.setActive,active:active,items:items}),!responsive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlainHeader,{setActive:this.setActive,active:active,items:items}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Wrapper,{className:"tab_content"},image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"tab_image__wrapper",size:{md:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:title,className:"tab_image",src:image})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"tab_content",size:image?{md:"1/2"}:"1"},content)));}}]);return Tabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(59);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(33);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(72);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12), __webpack_require__(71)(module)))

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var filterObject = function filterObject(target, predicate) {
  return Object.keys(target).reduce(function (acc, key) {
    return predicate(key) ? _extends({}, acc, _defineProperty({}, key, target[key])) : acc;
  }, {});
};

var mapObject = function mapObject(target, transformKey, transformValue) {
  return Object.keys(target).reduce(function (acc, key) {
    var newKey = transformKey ? transformKey(key) : key;
    var newValue = transformValue ? transformValue(target[key]) : target[key];
    return _extends({}, acc, _defineProperty({}, newKey, newValue));
  }, {});
};

var onlyRoutes = function onlyRoutes(routes) {
  return filterObject(routes, function (key) {
    return key.indexOf('/') === 0;
  });
};

var withoutRoutes = function withoutRoutes(routes) {
  return filterObject(routes, function (key) {
    return key.indexOf('/') !== 0;
  });
};

var flattenRoutes = function flattenRoutes(routes) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Object.keys(routes).forEach(function (key) {
    var baseRoute = key === '/' ? '' : key;
    flattenRoutes(mapObject(onlyRoutes(routes[key]), function (routeKey) {
      return '' + baseRoute + routeKey;
    }, function (routeValue) {
      return _extends({}, routeValue, {
        parent: _extends({}, withoutRoutes(routes[key]), {
          route: key
        })
      });
    }), acc);
  });

  __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()(acc, mapObject(routes, null, withoutRoutes));

  return acc;
};

/* harmony default export */ __webpack_exports__["a"] = (flattenRoutes);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MatchCache */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ROUTE_FALLBACK = '@ROUTE_FALLBACK';

var MatchCache = function () {
  function MatchCache() {
    _classCallCheck(this, MatchCache);

    this._data = {};
  }

  _createClass(MatchCache, [{
    key: 'add',
    value: function add(parentId, route) {
      this._data[parentId] = route || ROUTE_FALLBACK;
    }
  }, {
    key: 'get',
    value: function get(parentId) {
      return this._data[parentId] || null;
    }
  }, {
    key: 'clear',
    value: function clear() {
      this._data = {};
    }
  }]);

  return MatchCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (new MatchCache());

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.10.0
var slice = [].slice;

(function(root, factory) {
  if (('function' === "function") && (__webpack_require__(85) != null)) {
    return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined" && exports !== null) {
    return module.exports = factory();
  } else {
    return root.UrlPattern = factory();
  }
})(this, function() {
  var P, UrlPattern, astNodeContainsSegmentsForProvidedParams, astNodeToNames, astNodeToRegexString, baseAstNodeToRegexString, concatMap, defaultOptions, escapeForRegex, getParam, keysAndValuesToObject, newParser, regexGroupCount, stringConcatMap, stringify;
  escapeForRegex = function(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
  concatMap = function(array, f) {
    var i, length, results;
    results = [];
    i = -1;
    length = array.length;
    while (++i < length) {
      results = results.concat(f(array[i]));
    }
    return results;
  };
  stringConcatMap = function(array, f) {
    var i, length, result;
    result = '';
    i = -1;
    length = array.length;
    while (++i < length) {
      result += f(array[i]);
    }
    return result;
  };
  regexGroupCount = function(regex) {
    return (new RegExp(regex.toString() + '|')).exec('').length - 1;
  };
  keysAndValuesToObject = function(keys, values) {
    var i, key, length, object, value;
    object = {};
    i = -1;
    length = keys.length;
    while (++i < length) {
      key = keys[i];
      value = values[i];
      if (value == null) {
        continue;
      }
      if (object[key] != null) {
        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }
        object[key].push(value);
      } else {
        object[key] = value;
      }
    }
    return object;
  };
  P = {};
  P.Result = function(value, rest) {
    this.value = value;
    this.rest = rest;
  };
  P.Tagged = function(tag, value) {
    this.tag = tag;
    this.value = value;
  };
  P.tag = function(tag, parser) {
    return function(input) {
      var result, tagged;
      result = parser(input);
      if (result == null) {
        return;
      }
      tagged = new P.Tagged(tag, result.value);
      return new P.Result(tagged, result.rest);
    };
  };
  P.regex = function(regex) {
    return function(input) {
      var matches, result;
      matches = regex.exec(input);
      if (matches == null) {
        return;
      }
      result = matches[0];
      return new P.Result(result, input.slice(result.length));
    };
  };
  P.sequence = function() {
    var parsers;
    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return function(input) {
      var i, length, parser, rest, result, values;
      i = -1;
      length = parsers.length;
      values = [];
      rest = input;
      while (++i < length) {
        parser = parsers[i];
        result = parser(rest);
        if (result == null) {
          return;
        }
        values.push(result.value);
        rest = result.rest;
      }
      return new P.Result(values, rest);
    };
  };
  P.pick = function() {
    var indexes, parsers;
    indexes = arguments[0], parsers = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    return function(input) {
      var array, result;
      result = P.sequence.apply(P, parsers)(input);
      if (result == null) {
        return;
      }
      array = result.value;
      result.value = array[indexes];
      return result;
    };
  };
  P.string = function(string) {
    var length;
    length = string.length;
    return function(input) {
      if (input.slice(0, length) === string) {
        return new P.Result(string, input.slice(length));
      }
    };
  };
  P.lazy = function(fn) {
    var cached;
    cached = null;
    return function(input) {
      if (cached == null) {
        cached = fn();
      }
      return cached(input);
    };
  };
  P.baseMany = function(parser, end, stringResult, atLeastOneResultRequired, input) {
    var endResult, parserResult, rest, results;
    rest = input;
    results = stringResult ? '' : [];
    while (true) {
      if (end != null) {
        endResult = end(rest);
        if (endResult != null) {
          break;
        }
      }
      parserResult = parser(rest);
      if (parserResult == null) {
        break;
      }
      if (stringResult) {
        results += parserResult.value;
      } else {
        results.push(parserResult.value);
      }
      rest = parserResult.rest;
    }
    if (atLeastOneResultRequired && results.length === 0) {
      return;
    }
    return new P.Result(results, rest);
  };
  P.many1 = function(parser) {
    return function(input) {
      return P.baseMany(parser, null, false, true, input);
    };
  };
  P.concatMany1Till = function(parser, end) {
    return function(input) {
      return P.baseMany(parser, end, true, true, input);
    };
  };
  P.firstChoice = function() {
    var parsers;
    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return function(input) {
      var i, length, parser, result;
      i = -1;
      length = parsers.length;
      while (++i < length) {
        parser = parsers[i];
        result = parser(input);
        if (result != null) {
          return result;
        }
      }
    };
  };
  newParser = function(options) {
    var U;
    U = {};
    U.wildcard = P.tag('wildcard', P.string(options.wildcardChar));
    U.optional = P.tag('optional', P.pick(1, P.string(options.optionalSegmentStartChar), P.lazy(function() {
      return U.pattern;
    }), P.string(options.optionalSegmentEndChar)));
    U.name = P.regex(new RegExp("^[" + options.segmentNameCharset + "]+"));
    U.named = P.tag('named', P.pick(1, P.string(options.segmentNameStartChar), P.lazy(function() {
      return U.name;
    })));
    U.escapedChar = P.pick(1, P.string(options.escapeChar), P.regex(/^./));
    U["static"] = P.tag('static', P.concatMany1Till(P.firstChoice(P.lazy(function() {
      return U.escapedChar;
    }), P.regex(/^./)), P.firstChoice(P.string(options.segmentNameStartChar), P.string(options.optionalSegmentStartChar), P.string(options.optionalSegmentEndChar), U.wildcard)));
    U.token = P.lazy(function() {
      return P.firstChoice(U.wildcard, U.optional, U.named, U["static"]);
    });
    U.pattern = P.many1(P.lazy(function() {
      return U.token;
    }));
    return U;
  };
  defaultOptions = {
    escapeChar: '\\',
    segmentNameStartChar: ':',
    segmentValueCharset: 'a-zA-Z0-9-_~ %',
    segmentNameCharset: 'a-zA-Z0-9',
    optionalSegmentStartChar: '(',
    optionalSegmentEndChar: ')',
    wildcardChar: '*'
  };
  baseAstNodeToRegexString = function(astNode, segmentValueCharset) {
    if (Array.isArray(astNode)) {
      return stringConcatMap(astNode, function(node) {
        return baseAstNodeToRegexString(node, segmentValueCharset);
      });
    }
    switch (astNode.tag) {
      case 'wildcard':
        return '(.*?)';
      case 'named':
        return "([" + segmentValueCharset + "]+)";
      case 'static':
        return escapeForRegex(astNode.value);
      case 'optional':
        return '(?:' + baseAstNodeToRegexString(astNode.value, segmentValueCharset) + ')?';
    }
  };
  astNodeToRegexString = function(astNode, segmentValueCharset) {
    if (segmentValueCharset == null) {
      segmentValueCharset = defaultOptions.segmentValueCharset;
    }
    return '^' + baseAstNodeToRegexString(astNode, segmentValueCharset) + '$';
  };
  astNodeToNames = function(astNode) {
    if (Array.isArray(astNode)) {
      return concatMap(astNode, astNodeToNames);
    }
    switch (astNode.tag) {
      case 'wildcard':
        return ['_'];
      case 'named':
        return [astNode.value];
      case 'static':
        return [];
      case 'optional':
        return astNodeToNames(astNode.value);
    }
  };
  getParam = function(params, key, nextIndexes, sideEffects) {
    var index, maxIndex, result, value;
    if (sideEffects == null) {
      sideEffects = false;
    }
    value = params[key];
    if (value == null) {
      if (sideEffects) {
        throw new Error("no values provided for key `" + key + "`");
      } else {
        return;
      }
    }
    index = nextIndexes[key] || 0;
    maxIndex = Array.isArray(value) ? value.length - 1 : 0;
    if (index > maxIndex) {
      if (sideEffects) {
        throw new Error("too few values provided for key `" + key + "`");
      } else {
        return;
      }
    }
    result = Array.isArray(value) ? value[index] : value;
    if (sideEffects) {
      nextIndexes[key] = index + 1;
    }
    return result;
  };
  astNodeContainsSegmentsForProvidedParams = function(astNode, params, nextIndexes) {
    var i, length;
    if (Array.isArray(astNode)) {
      i = -1;
      length = astNode.length;
      while (++i < length) {
        if (astNodeContainsSegmentsForProvidedParams(astNode[i], params, nextIndexes)) {
          return true;
        }
      }
      return false;
    }
    switch (astNode.tag) {
      case 'wildcard':
        return getParam(params, '_', nextIndexes, false) != null;
      case 'named':
        return getParam(params, astNode.value, nextIndexes, false) != null;
      case 'static':
        return false;
      case 'optional':
        return astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes);
    }
  };
  stringify = function(astNode, params, nextIndexes) {
    if (Array.isArray(astNode)) {
      return stringConcatMap(astNode, function(node) {
        return stringify(node, params, nextIndexes);
      });
    }
    switch (astNode.tag) {
      case 'wildcard':
        return getParam(params, '_', nextIndexes, true);
      case 'named':
        return getParam(params, astNode.value, nextIndexes, true);
      case 'static':
        return astNode.value;
      case 'optional':
        if (astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes)) {
          return stringify(astNode.value, params, nextIndexes);
        } else {
          return '';
        }
    }
  };
  UrlPattern = function(arg1, arg2) {
    var groupCount, options, parsed, parser, withoutWhitespace;
    if (arg1 instanceof UrlPattern) {
      this.isRegex = arg1.isRegex;
      this.regex = arg1.regex;
      this.ast = arg1.ast;
      this.names = arg1.names;
      return;
    }
    this.isRegex = arg1 instanceof RegExp;
    if (!(('string' === typeof arg1) || this.isRegex)) {
      throw new TypeError('argument must be a regex or a string');
    }
    if (this.isRegex) {
      this.regex = arg1;
      if (arg2 != null) {
        if (!Array.isArray(arg2)) {
          throw new Error('if first argument is a regex the second argument may be an array of group names but you provided something else');
        }
        groupCount = regexGroupCount(this.regex);
        if (arg2.length !== groupCount) {
          throw new Error("regex contains " + groupCount + " groups but array of group names contains " + arg2.length);
        }
        this.names = arg2;
      }
      return;
    }
    if (arg1 === '') {
      throw new Error('argument must not be the empty string');
    }
    withoutWhitespace = arg1.replace(/\s+/g, '');
    if (withoutWhitespace !== arg1) {
      throw new Error('argument must not contain whitespace');
    }
    options = {
      escapeChar: (arg2 != null ? arg2.escapeChar : void 0) || defaultOptions.escapeChar,
      segmentNameStartChar: (arg2 != null ? arg2.segmentNameStartChar : void 0) || defaultOptions.segmentNameStartChar,
      segmentNameCharset: (arg2 != null ? arg2.segmentNameCharset : void 0) || defaultOptions.segmentNameCharset,
      segmentValueCharset: (arg2 != null ? arg2.segmentValueCharset : void 0) || defaultOptions.segmentValueCharset,
      optionalSegmentStartChar: (arg2 != null ? arg2.optionalSegmentStartChar : void 0) || defaultOptions.optionalSegmentStartChar,
      optionalSegmentEndChar: (arg2 != null ? arg2.optionalSegmentEndChar : void 0) || defaultOptions.optionalSegmentEndChar,
      wildcardChar: (arg2 != null ? arg2.wildcardChar : void 0) || defaultOptions.wildcardChar
    };
    parser = newParser(options);
    parsed = parser.pattern(arg1);
    if (parsed == null) {
      throw new Error("couldn't parse pattern");
    }
    if (parsed.rest !== '') {
      throw new Error("could only partially parse pattern");
    }
    this.ast = parsed.value;
    this.regex = new RegExp(astNodeToRegexString(this.ast, options.segmentValueCharset));
    this.names = astNodeToNames(this.ast);
  };
  UrlPattern.prototype.match = function(url) {
    var groups, match;
    match = this.regex.exec(url);
    if (match == null) {
      return null;
    }
    groups = match.slice(1);
    if (this.names) {
      return keysAndValuesToObject(this.names, groups);
    } else {
      return groups;
    }
  };
  UrlPattern.prototype.stringify = function(params) {
    if (params == null) {
      params = {};
    }
    if (this.isRegex) {
      throw new Error("can't stringify patterns generated from a regex");
    }
    if (params !== Object(params)) {
      throw new Error("argument must be an object or undefined");
    }
    return stringify(this.ast, params, {});
  };
  UrlPattern.escapeForRegex = escapeForRegex;
  UrlPattern.concatMap = concatMap;
  UrlPattern.stringConcatMap = stringConcatMap;
  UrlPattern.regexGroupCount = regexGroupCount;
  UrlPattern.keysAndValuesToObject = keysAndValuesToObject;
  UrlPattern.P = P;
  UrlPattern.newParser = newParser;
  UrlPattern.defaultOptions = defaultOptions;
  UrlPattern.astNodeToRegexString = astNodeToRegexString;
  UrlPattern.astNodeToNames = astNodeToNames;
  UrlPattern.getParam = getParam;
  UrlPattern.astNodeContainsSegmentsForProvidedParams = astNodeContainsSegmentsForProvidedParams;
  UrlPattern.stringify = stringify;
  return UrlPattern;
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (errorMsg) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsString = args.reduce(function (str, arg) {
      return '' + (str && str + ', ') + arg;
    }, '');
    throw new Error((errorMsg && errorMsg + ' ') + ' ' + (argsString && 'Was called with arguments ' + argsString + '.'));
  };
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(11);

var _LocationUtils = __webpack_require__(21);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(44);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(24);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(101);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(115);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(116);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRight = function ArrowRight(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '10',
      height: '18',
      viewBox: '0 0 10 18'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M7.586 9L.293 16.293a1 1 0 0 0 1.414 1.414l8-8a1 1 0 0 0 0-1.414l-8-8A1 1 0 1 0 .293 1.707L7.586 9z'
    })
  );
};

exports.icon = ArrowRight;
exports.default = (0, _hoc2.default)(ArrowRight);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Accordion */
/* unused harmony export Breadcrumbs */
/* unused harmony export Button */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrimaryButton; });
/* unused harmony export SecondaryButton */
/* unused harmony export TextButton */
/* unused harmony export CancelButton */
/* unused harmony export CloseButton */
/* unused harmony export SearchButton */
/* unused harmony export ButtonGroup */
/* unused harmony export Card */
/* unused harmony export ColleagueLayout */
/* unused harmony export MainSection */
/* unused harmony export Form */
/* unused harmony export FormGroup */
/* unused harmony export TextInputField */
/* unused harmony export PasswordField */
/* unused harmony export SelectField */
/* unused harmony export CheckboxField */
/* unused harmony export RadioButtonField */
/* unused harmony export TextAreaField */
/* unused harmony export SearchField */
/* unused harmony export Fieldset */
/* unused harmony export Legend */
/* unused harmony export withClear */
/* unused harmony export Flag */
/* unused harmony export Grid */
/* unused harmony export Header */
/* unused harmony export InputAction */
/* unused harmony export InputControl */
/* unused harmony export InputGroup */
/* unused harmony export InputIcon */
/* unused harmony export Checkbox */
/* unused harmony export Password */
/* unused harmony export RadioButton */
/* unused harmony export Select */
/* unused harmony export TextArea */
/* unused harmony export TextInput */
/* unused harmony export SearchInput */
/* unused harmony export List */
/* unused harmony export ListItem */
/* unused harmony export LoadingIndicator */
/* unused harmony export LoadingIcon */
/* unused harmony export Modal */
/* unused harmony export Navigation */
/* unused harmony export MenuButton */
/* unused harmony export Notification */
/* unused harmony export Search */
/* unused harmony export Section */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SiteWrap; });
/* unused harmony export StatusCard */
/* unused harmony export Table */
/* unused harmony export Tabs */
/* unused harmony export TabList */
/* unused harmony export TabLink */
/* unused harmony export TabPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueid__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var getUniqueId = (function (prefix) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueid___default()(prefix);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var addLunaClass = function addLunaClass(props) {
  return _extends({}, props, {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(props.className, 'ln-c-icon')
  });
};

var iconHandler = ( /* istanbul ignore next */function (Component$$1) {
  return (
    /* istanbul ignore next */Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])(Component$$1.displayName || Component$$1.name || 'Icon'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["mapProps"])(addLunaClass))(Component$$1)
  );
});

var ArrowDown = function ArrowDown(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    _extends({
      width: '18',
      height: '10',
      viewBox: '0 0 18 10'
    }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M9 7.586L1.707.293A1 1 0 0 0 .293 1.707l8 8a1 1 0 0 0 1.414 0l8-8A1 1 0 1 0 16.293.293L9 7.586z'
    })
  );
};

var ArrowDown$1 = iconHandler(ArrowDown);

var includes = (function (arr, searchElement) {
  if (!Array.isArray(arr)) {
    return false;
  }
  return arr.indexOf(searchElement) !== -1;
});

var filterProps = (function (props, filterList) {
  return Object.keys(props).reduce(function (newProps, prop) {
    var _babelHelpers$extends;

    if (includes(filterList, prop)) {
      return newProps;
    }
    return _extends({}, newProps, (_babelHelpers$extends = {}, _babelHelpers$extends[prop] = props[prop], _babelHelpers$extends));
  }, {});
});

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      titleElement = _ref.titleElement,
      open = _ref.open,
      standalone = _ref.standalone,
      ids = _ref.ids,
      handleClick = _ref.handleClick,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'title', 'titleElement', 'open', 'standalone', 'ids', 'handleClick']);

  var Heading = titleElement;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, filterProps(rest, ['setOpenState', 'defaultOpen']), {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-accordion', className, open && 'is-open', standalone && 'ln-c-accordion--standalone')
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'ln-c-accordion__head' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          className: 'ln-c-accordion__toggle',
          type: 'button',
          onClick: function onClick() {
            return handleClick(open);
          },
          'aria-hidden': true
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ArrowDown$1, { className: 'ln-c-accordion__icon' })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Heading,
        { className: 'ln-c-accordion__title', id: ids.title },
        title
      )
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      {
        className: 'ln-c-accordion__body',
        role: 'region',
        'aria-labelledby': ids.title
      },
      open && children
    )
  );
};

Accordion.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  titleElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  standalone: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ids: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
  }).isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

Accordion.defaultProps = {
  className: undefined,
  titleElement: 'h4',
  open: false,
  standalone: false
};

var handleClick = function handleClick(_ref) {
  var setOpenState = _ref.setOpenState;
  return function (currentState) {
    return setOpenState(!currentState);
  };
};

var createIds = function createIds(_ref2) {
  var ids = _ref2.ids;
  return ids || {
    ids: {
      title: getUniqueId('ln-accordion-')
    }
  };
};

var AccordionWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Accordion'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('open', 'setOpenState', function (_ref3) {
  var defaultOpen = _ref3.defaultOpen;
  return !!defaultOpen;
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])({ handleClick: handleClick }), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withPropsOnChange"])(function () {
  return false;
}, createIds))(Accordion);

var ListItem = function ListItem(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      type = _ref.type,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'type']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'li',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, (_classnames = {}, _classnames['ln-o-' + type + '-list__item'] = type, _classnames))
    }),
    children
  );
};

ListItem.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['bare', 'inline', 'matrix'])
};

ListItem.defaultProps = {
  className: undefined,
  type: undefined
};

var List = function List(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      type = _ref.type,
      spaced = _ref.spaced,
      items = _ref.items,
      ordered = _ref.ordered,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'type', 'spaced', 'items', 'ordered']);

  var ListElement = ordered ? 'ol' : 'ul';
  var keys = [];

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    ListElement,
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, (_classnames = {}, _classnames['ln-o-' + type + '-list'] = type, _classnames['ln-o-' + type + '-list--spaced'] = type && spaced, _classnames))
    }),
    items ? items.map(function (item, index) {
      var key = 'listItem-' + (!includes(keys, item.toString()) ? item : index);
      keys.push(item.toString());

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        ListItem,
        {
          key: key,
          type: type
        },
        item
      );
    }) : children
  );
};

List.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  items: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node),
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['bare', 'inline', 'matrix']),
  spaced: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ordered: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

List.defaultProps = {
  className: undefined,
  children: false,
  items: undefined,
  type: undefined,
  spaced: false,
  ordered: false
};

var BreadcrumbsWrapper = function BreadcrumbsWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'nav',
    _extends({}, rest, { className: 'ln-c-breadcrumbs' + (className ? ' ' + className : '') }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      List,
      {
        type: 'inline',
        spaced: true
      },
      children
    )
  );
};

BreadcrumbsWrapper.displayName = 'Breadcrumbs.Wrapper';

BreadcrumbsWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

BreadcrumbsWrapper.defaultProps = {
  className: undefined
};

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'active']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    ListItem,
    _extends({}, rest, {
      type: 'inline',
      className: 'ln-c-breadcrumbs' + (className ? ' ' + className : '')
    }),
    active ? children : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      { className: 'ln-c-breadcrumbs__item' },
      children
    )
  );
};

BreadcrumbsItem.displayName = 'Breadcrumbs.Item';

BreadcrumbsItem.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

BreadcrumbsItem.defaultProps = {
  className: undefined,
  active: false
};

var Breadcrumbs = {
  Wrapper: BreadcrumbsWrapper,
  Item: BreadcrumbsItem
};

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      onClick = _ref.onClick,
      type = _ref.type,
      title = _ref.title,
      containerElement = _ref.containerElement,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'disabled', 'fullWidth', 'onClick', 'type', 'title', 'containerElement']);

  var props = _extends({}, rest, {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-button', className, {
      'is-disabled': disabled,
      'ln-c-button--full': fullWidth
    }),
    role: 'button',
    title: title,
    onClick: onClick
  });

  if (containerElement === 'button') {
    props = _extends({}, props, {
      disabled: disabled,
      'aria-disabled': disabled || undefined,
      type: type
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(containerElement) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(containerElement, props, children) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(containerElement, props, children);
};

Button.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fullWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['button', 'submit']),
  containerElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element]),
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Button.defaultProps = {
  className: undefined,
  disabled: false,
  fullWidth: false,
  type: 'button',
  containerElement: 'button',
  title: undefined
};

var PrimaryButton = function PrimaryButton(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Button,
    _extends({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-button--primary', props.className)
    }),
    props.children
  );
};

PrimaryButton.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

PrimaryButton.defaultProps = {
  className: undefined
};

var SecondaryButton = function SecondaryButton(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Button,
    _extends({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-button--secondary', props.className)
    }),
    props.children
  );
};

SecondaryButton.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

SecondaryButton.defaultProps = {
  className: undefined
};

var TextButton = function TextButton(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Button,
    _extends({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-button--text-only', props.className)
    }),
    props.children
  );
};

TextButton.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TextButton.defaultProps = {
  className: undefined
};

var Cancel = function Cancel(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    _extends({
      width: '20',
      height: '20'
    }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
        d: 'M15.02 3.707L3.708 15.021a1 1 0 1 0 1.414 1.414L16.435 5.121a1 1 0 1 0-1.414-1.414z'
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
        d: 'M3.707 5.121l11.314 11.314a1 1 0 1 0 1.414-1.414L5.121 3.707a1 1 0 1 0-1.414 1.414z'
      })
    )
  );
};

var CancelIcon = iconHandler(Cancel);

var CancelButton = function CancelButton(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Button,
    props,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CancelIcon, null)
  );
};

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      title = _ref.title,
      rest = objectWithoutProperties(_ref, ['className', 'onClick', 'title']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CancelButton, _extends({}, rest, {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-dismiss'),
    onClick: onClick,
    title: title
  }));
};

CloseButton.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

CloseButton.defaultProps = {
  className: undefined,
  title: 'Close'
};

var Search = function Search(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
        d: 'M23.207 21.793l-7.5-7.5a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414z'
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
        d: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18z'
      })
    )
  );
};

var Search$1 = iconHandler(Search);

var SearchButton = function SearchButton(_ref) {
  var icon$$1 = _ref.icon,
      text = _ref.text,
      inputAction = _ref.inputAction,
      rest = objectWithoutProperties(_ref, ['icon', 'text', 'inputAction']);

  var ButtonElement = inputAction ? Button : PrimaryButton;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    ButtonElement,
    _extends({ type: 'submit', className: 'ln-u-hard-ends' }, rest),
    icon$$1,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      { className: 'ln-u-visually-hidden' },
      text
    )
  );
};

SearchButton.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  text: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  inputAction: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

SearchButton.defaultProps = {
  icon: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Search$1, null),
  text: 'Search',
  inputAction: false
};

// Base

var Wrapper$1 = function Wrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-cta-button-group', 'ln-o-clearfix')
    }),
    children
  );
};

Wrapper$1.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Wrapper$1.defaultProps = {
  className: undefined
};

Wrapper$1.displayName = 'ButtonGroup.Wrapper';

var Primary = function Primary(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-cta-button-group__primary')
    }),
    children
  );
};

Primary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Primary.defaultProps = {
  className: undefined
};

Primary.displayName = 'ButtonGroup.Primary';

var Secondary = function Secondary(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-cta-button-group__secondary')
    }),
    children
  );
};

Secondary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Secondary.defaultProps = {
  className: undefined
};

Secondary.displayName = 'ButtonGroup.Secondary';

var ButtonGroup = {
  Wrapper: Wrapper$1,
  Primary: Primary,
  Secondary: Secondary
};

var Card = function Card(_ref) {
  var className = _ref.className,
      padded = _ref.padded,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ['className', 'padded', 'children']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-card', className, {
        'ln-c-card--soft': padded
      })
    }),
    children
  );
};

Card.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  padded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

Card.defaultProps = {
  className: undefined,
  padded: true
};

var setHasOverlay = (function (visible) {
  var classHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body.classList;

  var className = 'has-overlay';

  if (visible) {
    return classHandler.add(className);
  }

  return classHandler.remove(className);
});

var SiteWrap = function SiteWrap(_ref) {
  var padded = _ref.padded,
      className = _ref.className,
      children = _ref.children,
      large = _ref.large,
      squash = _ref.squash,
      rest = objectWithoutProperties(_ref, ['padded', 'className', 'children', 'large', 'squash']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-o-site-wrap', 'ln-o-clearfix', className, {
        'ln-o-site-wrap--padding': padded,
        'ln-o-site-wrap--large': large,
        'ln-o-site-wrap--squash': squash
      })
    }),
    children
  );
};

SiteWrap.propTypes = {
  padded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  large: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  squash: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

SiteWrap.defaultProps = {
  padded: false,
  large: false,
  squash: false,
  className: undefined
};

var NavigationWrapper = function NavigationWrapper(_ref) {
  var children = _ref.children,
      title = _ref.title,
      button = _ref.button,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'title', 'button', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-navigation-wrapper')
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      SiteWrap,
      { padded: true, large: true, className: 'ln-u-hard-right' },
      button,
      !!title && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h1',
        { className: 'ln-c-navigation-wrapper__title' },
        title
      ),
      !!children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'nav',
        { className: 'ln-c-navigation-wrapper__inner' },
        children
      )
    )
  );
};

NavigationWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  button: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

NavigationWrapper.defaultProps = {
  button: undefined,
  title: undefined,
  className: undefined
};

var Navigation$1 = function Navigation(_ref) {
  var items = _ref.items,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['items', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'ul',
    _extends({}, rest, { className: className.list }),
    items.map(function (Element) {
      if (Element.type === 'li') return Element;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'li',
        { key: Element.props.href || Element.props.to, className: className.item },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(Element, {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Element.props.className, className.link)
        })
      );
    })
  );
};

Navigation$1.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    list: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    item: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    link: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

Navigation$1.defaultProps = {
  items: [],
  className: {
    list: 'ln-c-navigation',
    item: 'ln-c-navigation__item',
    link: 'ln-c-navigation__link'
  }
};

var MenuButton = function MenuButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      rest = objectWithoutProperties(_ref, ['className', 'onClick']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'button',
    _extends({}, rest, {
      className: className,
      'aria-hidden': 'true',
      tabIndex: '-1',
      onClick: onClick
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      { className: 'ln-navigation-toggle' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'ln-c-navigation-toggle__item' })
    )
  );
};

MenuButton.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

MenuButton.defaultProps = {
  className: undefined
};

var Navigation = {
  Wrapper: NavigationWrapper,
  List: Navigation$1
};

var navigationClasses = {
  list: 'ln-c-topbar__list',
  item: 'ln-c-topbar__item',
  link: 'ln-o-bare-link ln-c-topbar__text'
};

var TopBar = function TopBar(_ref) {
  var logo = _ref.logo,
      items = _ref.items,
      meta = _ref.meta,
      className = _ref.className,
      toggle = _ref.toggle,
      hasDivider = _ref.hasDivider,
      rest = objectWithoutProperties(_ref, ['logo', 'items', 'meta', 'className', 'toggle', 'hasDivider']);

  var createOnClickHandle = function createOnClickHandle(onClick) {
    return function (e) {
      toggle(false);

      if (onClick) {
        onClick(e);
      }
    };
  };

  var addOnClickHandler = function addOnClickHandler(menuItem) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(menuItem, { onClick: createOnClickHandle(menuItem.props.onClick) });
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-topbar', !hasDivider && 'ln-c-topbar--hide-divider')
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      SiteWrap,
      { padded: true, large: true },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'ln-o-flag' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'ln-o-flag__body' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Navigation.List, {
            className: navigationClasses,
            items: logo ? [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'li',
              { key: 'logo', className: 'ln-c-topbar__item ln-c-topbar__item--logo' },
              logo
            )].concat(items.map(addOnClickHandler)) : items.map(addOnClickHandler)
          })
        ),
        meta && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'ln-o-flag__component' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'ln-c-topbar__text' },
            meta
          )
        )
      )
    )
  );
};

TopBar.propTypes = {
  logo: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  items: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node),
  meta: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  hasDivider: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

TopBar.defaultProps = {
  logo: undefined,
  items: [],
  meta: undefined,
  className: undefined,
  hasDivider: true
};

var Form = function Form(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onSubmit = _ref.onSubmit,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'onSubmit']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'form',
    _extends({}, rest, { noValidate: true, onSubmit: onSubmit, className: className }),
    children
  );
};

Form.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

Form.defaultProps = {
  className: undefined,
  onSubmit: undefined
};

var LabelInfo = function LabelInfo(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ['className', 'children']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'span',
    _extends({}, rest, { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-label__info', className) }),
    children
  );
};

LabelInfo.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

LabelInfo.defaultProps = {
  className: undefined
};

var DEFAULT_REQUIRED_INDICATOR = '';
var DEFAULT_OPTIONAL_INDICATOR = '(optional)';

var Label = function Label(_ref) {
  var element = _ref.element,
      htmlFor = _ref.htmlFor,
      requiredLabel = _ref.requiredLabel,
      optionalLabel = _ref.optionalLabel,
      children = _ref.children,
      className = _ref.className,
      hidden = _ref.hidden,
      rest = objectWithoutProperties(_ref, ['element', 'htmlFor', 'requiredLabel', 'optionalLabel', 'children', 'className', 'hidden']);

  var Element = element;
  var indicator = void 0;

  if (optionalLabel !== undefined) {
    indicator = optionalLabel === true ? DEFAULT_OPTIONAL_INDICATOR : optionalLabel;
  }

  if (requiredLabel !== undefined) {
    indicator = requiredLabel === true ? DEFAULT_REQUIRED_INDICATOR : requiredLabel;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Element,
    _extends({}, rest, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-label', hidden && 'ln-u-visually-hidden')
    }),
    children,
    indicator && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      LabelInfo,
      null,
      ' ',
      indicator
    )
  );
};

Label.displayName = 'Label';

Label.propTypes = {
  element: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['label', 'legend']),
  htmlFor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  requiredLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  optionalLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  hidden: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Label.defaultProps = {
  element: 'label',
  requiredLabel: undefined,
  optionalLabel: undefined,
  hidden: false,
  className: undefined
};

var FieldInfo = function FieldInfo(_ref) {
  var id = _ref.id,
      children = _ref.children,
      error = _ref.error,
      warning = _ref.warning,
      className = _ref.className,
      displayFirst = _ref.displayFirst,
      rest = objectWithoutProperties(_ref, ['id', 'children', 'error', 'warning', 'className', 'displayFirst']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      id: id,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-field-info', {
        'ln-c-field-info--validation-first': displayFirst,
        'ln-c-field-info--error': error || warning,
        'ln-c-field-info--extra': !error && !warning
      }),
      role: error || warning ? 'alert' : undefined
    }),
    children
  );
};

FieldInfo.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  error: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  warning: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  displayFirst: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

FieldInfo.defaultProps = {
  id: undefined,
  error: false,
  warning: false,
  className: undefined,
  displayFirst: false
};

var FormGroup = function FormGroup(_ref) {
  var element = _ref.element,
      labelElement = _ref.labelElement,
      name = _ref.name,
      required = _ref.required,
      optional = _ref.optional,
      label = _ref.label,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      children = _ref.children,
      className = _ref.className,
      validationFirst = _ref.validationFirst,
      hideLabel = _ref.hideLabel,
      rest = objectWithoutProperties(_ref, ['element', 'labelElement', 'name', 'required', 'optional', 'label', 'error', 'warning', 'info', 'children', 'className', 'validationFirst', 'hideLabel']);

  var Element = element;

  var hasError = !!error;
  var hasWarning = !!warning;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Element,
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-form-group', {
        'has-error': hasError,
        'has-warning': hasWarning
      })
    }),
    !!label && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Label,
      {
        element: labelElement,
        htmlFor: name,
        requiredLabel: required,
        optionalLabel: optional,
        hidden: hideLabel
      },
      label
    ),
    !!info && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      FieldInfo,
      { id: name + 'Info' },
      info
    ),
    (hasError || hasWarning) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      FieldInfo,
      {
        id: name + 'Validation',
        displayFirst: validationFirst,
        error: hasError,
        warning: hasWarning
      },
      error || warning
    ),
    children
  );
};

FormGroup.propTypes = {
  element: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  labelElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  optional: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hideLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  warning: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  info: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  validationFirst: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

FormGroup.defaultProps = {
  element: 'div',
  labelElement: undefined,
  required: undefined,
  optional: undefined,
  label: undefined,
  hideLabel: false,
  info: undefined,
  warning: undefined,
  error: undefined,
  className: undefined,
  validationFirst: false
};

var Input = function Input(_ref) {
  var id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      autoComplete = _ref.autoComplete,
      autoCapitalize = _ref.autoCapitalize,
      required = _ref.required,
      inputMode = _ref.inputMode,
      pattern = _ref.pattern,
      readOnly = _ref.readOnly,
      spellCheck = _ref.spellCheck,
      tabIndex = _ref.tabIndex,
      className = _ref.className,
      invalid = _ref.invalid,
      rest = objectWithoutProperties(_ref, ['id', 'name', 'type', 'placeholder', 'disabled', 'onBlur', 'onChange', 'onFocus', 'value', 'defaultValue', 'checked', 'defaultChecked', 'minLength', 'maxLength', 'min', 'max', 'step', 'autoComplete', 'autoCapitalize', 'required', 'inputMode', 'pattern', 'readOnly', 'spellCheck', 'tabIndex', 'className', 'invalid']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', _extends({}, rest, {
    id: id || name,
    name: name,
    type: type,

    className: className,

    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,

    value: value,
    defaultValue: defaultValue,
    checked: checked,
    defaultChecked: defaultChecked,

    placeholder: placeholder,

    tabIndex: tabIndex,

    autoComplete: autoComplete,
    autoCapitalize: autoCapitalize,

    inputMode: inputMode,
    spellCheck: spellCheck,

    required: required,
    minLength: minLength,
    maxLength: maxLength,
    min: min,
    max: max,
    step: step,
    pattern: pattern,

    readOnly: readOnly,
    disabled: disabled,

    'aria-disabled': disabled || undefined,
    'aria-required': required === false ? required : undefined,
    'aria-invalid': invalid || undefined
  }));
};

Input.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  defaultValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  minLength: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  maxLength: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  autoComplete: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  autoCapitalize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inputMode: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pattern: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(RegExp), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  spellCheck: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['default', true, false]),
  tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

Input.defaultProps = {
  id: undefined,
  type: 'text',
  disabled: false,
  placeholder: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  value: undefined,
  defaultValue: undefined,
  checked: undefined,
  defaultChecked: undefined,
  minLength: undefined,
  maxLength: undefined,
  min: undefined,
  max: undefined,
  step: undefined,
  autoComplete: undefined,
  autoCapitalize: undefined,
  required: undefined,
  inputMode: undefined,
  pattern: undefined,
  readOnly: false,
  spellCheck: undefined,
  tabIndex: undefined,
  className: undefined,
  invalid: undefined
};

var TextInput = function TextInput(_ref) {
  var className = _ref.className,
      props = objectWithoutProperties(_ref, ['className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input, _extends({ className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-text-input', className) }, props));
};

TextInput.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TextInput.defaultProps = {
  className: undefined
};

var propTypes = _extends({}, FormGroup.propTypes);
delete propTypes.children;

var getRequiredFlag = (function (required, optional) {
  return required !== undefined || optional !== undefined ? !!required : undefined;
});

var getDescribedByIds = (function (_ref) {
  var name = _ref.name,
      info = _ref.info,
      error = _ref.error,
      warning = _ref.warning;
  return [info !== undefined && name + "Info", (error !== undefined || warning !== undefined) && name + "Validation"].filter(function (id) {
    return !!id;
  });
});

var getComponentName = (function (component) {
  if (!component) return null;

  var type = component.type || component;

  if (typeof type === 'string') {
    return type;
  }
  if (typeof type === 'function') {
    return type.displayName || type.name;
  }
  return null;
});

var InputGroup = function InputGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasIcon = _ref.hasIcon,
      hasAction = _ref.hasAction,
      hasButton = _ref.hasButton,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'hasIcon', 'hasAction', 'hasButton']);

  var hasIconClass = hasIcon;
  var hasActionClass = hasAction;

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(children, function (child) {
    if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      var componentName = getComponentName(child);
      if (componentName === 'InputIcon') {
        hasIconClass = true;
      }

      if (componentName === 'InputAction') {
        hasActionClass = true;
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-input-group', hasIconClass && 'ln-c-input-group--has-icon', hasActionClass && 'ln-c-input-group--has-action', hasButton && 'ln-c-input-group--has-button', className)
    }),
    children
  );
};

InputGroup.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  hasIcon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hasAction: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hasButton: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

InputGroup.defaultProps = {
  children: undefined,
  className: undefined,
  hasIcon: false,
  hasAction: false,
  hasButton: false
};

var InputIcon = function InputIcon(_ref) {
  var children = _ref.children;

  var element = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-input-group__icon', element.props && element.props.className),
    'aria-hidden': true
  });
};

InputIcon.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};

InputIcon.defaultProps = {
  children: undefined
};

var InputControl = function InputControl(_ref) {
  var children = _ref.children;

  var element = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-input-group__control', element.props && element.props.className) });
};

InputControl.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};

InputControl.defaultProps = {
  children: undefined
};

var InputAction = function InputAction(_ref) {
  var children = _ref.children;

  var element = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-input-group__action', element.props && element.props.className) });
};

InputAction.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};

InputAction.defaultProps = {
  children: undefined
};

var TextInputField = function TextInputField(_ref) {
  var className = _ref.className,
      required = _ref.required,
      requiredLabel = _ref.requiredLabel,
      optional = _ref.optional,
      optionalLabel = _ref.optionalLabel,
      validationFirst = _ref.validationFirst,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      labelElement = _ref.labelElement,
      hasButton = _ref.hasButton,
      icon = _ref.icon,
      action = _ref.action,
      actionFirst = _ref.actionFirst,
      element = _ref.element,
      props = objectWithoutProperties(_ref, ['className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info', 'labelElement', 'hasButton', 'icon', 'action', 'actionFirst', 'element']);

  var requiredFlag = getRequiredFlag(required, optional);
  var describedBy = getDescribedByIds({
    name: props.name, info: info, warning: warning, error: error
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    FormGroup,
    {
      name: props.name,
      required: required,
      optional: optional,
      label: label,
      hideLabel: hideLabel,
      error: error,
      warning: warning,
      info: info,
      className: className,
      validationFirst: validationFirst,
      labelElement: labelElement,
      element: element
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      InputGroup,
      { hasButton: hasButton },
      icon && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        InputIcon,
        null,
        icon
      ),
      action && actionFirst && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        InputAction,
        null,
        action
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        InputControl,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput, _extends({
          required: requiredFlag,
          invalid: error !== undefined ? !!error : undefined,
          'aria-describedby': describedBy.length > 0 ? describedBy.join(' ') : undefined
        }, filterProps(props, ['setValue', 'clearValue', 'setRef', 'hasAction'])))
      ),
      action && !actionFirst && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        InputAction,
        null,
        action
      )
    )
  );
};

TextInputField.propTypes = _extends({}, propTypes, {
  icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  action: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hasButton: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  actionFirst: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
});

TextInputField.defaultProps = {
  icon: undefined,
  action: undefined,
  hasButton: false,
  actionFirst: false
};

var Password$1 = function Password(_ref) {
  var hasToggle = _ref.hasToggle,
      setTextVisibility = _ref.setTextVisibility,
      showText = _ref.showText,
      props = objectWithoutProperties(_ref, ['hasToggle', 'setTextVisibility', 'showText']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: 'ln-c-password' },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput, _extends({}, props, { type: showText ? 'text' : 'password' })),
    hasToggle && setTextVisibility && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      TextButton,
      {
        className: 'ln-c-password__toggle-button',
        onClick: function onClick() {
          return setTextVisibility(!showText);
        }
      },
      showText ? 'Hide' : 'Show',
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'ln-u-visually-hidden' },
        'password'
      )
    )
  );
};

Password$1.propTypes = {
  showText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hasToggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  setTextVisibility: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

Password$1.defaultProps = {
  showText: false,
  hasToggle: false,
  setTextVisibility: undefined
};

var Password = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Password'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('showText', 'setTextVisibility', false))(Password$1);

var DEFAULT_LEVELS = {
  0: {
    className: '',
    caption: 'Too short',
    test: function test() {
      return true;
    }
  },
  1: {
    className: 'is-level-1',
    caption: 'Bad',
    test: function test(value) {
      return value.length > 7;
    }
  },
  2: {
    className: 'is-level-2',
    caption: 'Ok',
    test: function test(value) {
      return value.length > 9;
    }
  },
  3: {
    className: 'is-level-3',
    caption: 'Good',
    test: function test(value) {
      return value.length > 11;
    }
  },
  4: {
    className: 'is-level-4',
    caption: 'Great',
    test: function test(value) {
      return value.length > 13;
    }
  }
};

var getLevel = function getLevel(value, levelMap) {
  var levels = Object.keys(levelMap);
  var reversedLevels = levels.reverse();

  if (value !== undefined) {
    for (var i = 0; i < levels.length; i += 1) {
      if (levelMap[reversedLevels[i]].test(value)) {
        return levelMap[reversedLevels[i]];
      }
    }
  }

  return levelMap[levels[0]];
};

var PasswordField = function (_Component) {
  inherits(PasswordField, _Component);

  function PasswordField(props) {
    classCallCheck(this, PasswordField);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { value: props.value || props.defaultValue || '' };

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  PasswordField.prototype.handleChange = function handleChange(event) {
    this.setState({ value: event.target.value });

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  PasswordField.prototype.render = function render() {
    var _props = this.props,
        levels = _props.levels,
        strengthIndicator = _props.strengthIndicator,
        className = _props.className,
        required = _props.required,
        requiredLabel = _props.requiredLabel,
        optional = _props.optional,
        optionalLabel = _props.optionalLabel,
        validationFirst = _props.validationFirst,
        label = _props.label,
        hideLabel = _props.hideLabel,
        error = _props.error,
        warning = _props.warning,
        info = _props.info,
        props = objectWithoutProperties(_props, ['levels', 'strengthIndicator', 'className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info']);

    var strengthIndicatorId = props.name + 'StrengthIndicator';

    var requiredFlag = getRequiredFlag(required, optional);
    var describedBy = getDescribedByIds({
      name: props.name,
      info: info,
      warning: warning,
      error: error
    }).concat([strengthIndicatorId]);
    var level = getLevel(this.state.value, levels);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      FormGroup,
      {
        name: props.name,
        required: required,
        optional: optional,
        label: label,
        hideLabel: hideLabel,
        error: error,
        warning: warning,
        info: info,
        className: className,
        validationFirst: validationFirst
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Password, _extends({
        required: requiredFlag,
        invalid: error !== undefined ? !!error : undefined,
        'aria-describedby': describedBy.join(' ')
      }, props, {
        value: this.state.value,
        onChange: this.handleChange
      })),
      strengthIndicator && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'ln-c-password-strength-meter ' + level.className },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          {
            id: strengthIndicatorId,
            className: 'ln-c-password-strength-meter__label',
            'aria-live': 'polite',
            'aria-atomic': 'true'
          },
          'Strength:',
          ' ',
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: 'ln-c-password-strength-meter__value' },
            level.caption
          )
        )
      )
    );
  };

  return PasswordField;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

PasswordField.propTypes = _extends({}, propTypes, {
  levels: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  strengthIndicator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
});

PasswordField.defaultProps = {
  levels: DEFAULT_LEVELS,
  strengthIndicator: false
};

var DEFAULT_PLACEHOLDER = 'Please select';

var Select = function Select(_ref) {
  var name = _ref.name,
      options = _ref.options,
      required = _ref.required,
      disabled = _ref.disabled,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      className = _ref.className,
      placeholder = _ref.placeholder,
      defaultValue = _ref.defaultValue,
      readOnly = _ref.readOnly,
      tabIndex = _ref.tabIndex,
      invalid = _ref.invalid,
      rest = objectWithoutProperties(_ref, ['name', 'options', 'required', 'disabled', 'onBlur', 'onChange', 'onFocus', 'value', 'className', 'placeholder', 'defaultValue', 'readOnly', 'tabIndex', 'invalid']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'select',
    _extends({}, rest, {
      id: name,
      name: name,

      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-select', className),

      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,

      value: value,
      defaultValue: defaultValue,

      required: required,

      tabIndex: tabIndex,

      disabled: disabled,
      readOnly: readOnly,

      'aria-disabled': disabled || undefined,
      'aria-required': required === false ? required : undefined,
      'aria-invalid': invalid || undefined
    }),
    placeholder && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'option',
      { value: '' },
      typeof placeholder === 'string' ? placeholder : DEFAULT_PLACEHOLDER
    ),
    options.map(function (option) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'option',
        { key: name + '-' + option.value, value: option.value },
        option.label
      );
    })
  );
};

Select.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  defaultValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

Select.defaultProps = {
  disabled: false,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  value: undefined,
  defaultValue: undefined,
  placeholder: DEFAULT_PLACEHOLDER,
  className: undefined,
  required: undefined,
  readOnly: false,
  tabIndex: undefined,
  invalid: undefined
};

var SelectField = function SelectField(_ref) {
  var className = _ref.className,
      required = _ref.required,
      requiredLabel = _ref.requiredLabel,
      optional = _ref.optional,
      optionalLabel = _ref.optionalLabel,
      validationFirst = _ref.validationFirst,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      props = objectWithoutProperties(_ref, ['className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info']);

  var requiredFlag = getRequiredFlag(required, optional);
  var describedBy = getDescribedByIds({
    name: props.name, info: info, warning: warning, error: error
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    FormGroup,
    {
      name: props.name,
      required: required,
      optional: optional,
      label: label,
      hideLabel: hideLabel,
      error: error,
      warning: warning,
      info: info,
      className: className,
      validationFirst: validationFirst
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Select, _extends({
      required: requiredFlag,
      invalid: error !== undefined ? !!error : undefined,
      'aria-describedby': describedBy.length > 0 ? describedBy.join(' ') : undefined
    }, props))
  );
};

SelectField.propTypes = propTypes;

var FormOption = function FormOption(_ref) {
  var label = _ref.label,
      className = _ref.className,
      fullWidth = _ref.fullWidth,
      type = _ref.type,
      props = objectWithoutProperties(_ref, ['label', 'className', 'fullWidth', 'type']);

  var id = props.value ? props.name + '-' + props.value : props.name;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-form-option', 'ln-c-form-option--' + type, fullWidth && 'ln-c-form-option--full', className)
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input, _extends({
      type: type,
      className: 'ln-c-form-option__input'
    }, props, {
      id: id
    })),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      { className: 'ln-c-form-option__label', htmlFor: id },
      label
    )
  );
};

FormOption.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  fullWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

FormOption.defaultProps = {
  type: 'radio',
  label: undefined,
  className: undefined,
  fullWidth: false,
  value: undefined
};

var getChecked = function getChecked(_ref) {
  var optionGroupValue = _ref.optionGroupValue,
      optionValue = _ref.optionValue,
      optionChecked = _ref.optionChecked;

  var checked = void 0;
  if (optionGroupValue !== undefined) checked = optionValue === optionGroupValue;
  if (optionChecked !== undefined) checked = optionChecked;
  return checked;
};

var FormOptionFieldInput = function FormOptionFieldInput(_ref2) {
  var option = _ref2.option,
      optionGroupValue = _ref2.optionGroupValue,
      props = objectWithoutProperties(_ref2, ['option', 'optionGroupValue']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FormOption, _extends({}, props, {
    label: option.label,
    value: option.value,
    checked: getChecked({
      optionGroupValue: optionGroupValue,
      optionValue: option.value,
      optionChecked: option.checked
    }),
    defaultChecked: option.defaultChecked
  }));
};

FormOptionFieldInput.propTypes = {
  option: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  }).isRequired,
  optionGroupValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

FormOptionFieldInput.defaultProps = {
  optionGroupValue: undefined
};

var FormOptionField = function FormOptionField(_ref3) {
  var className = _ref3.className,
      required = _ref3.required,
      requiredLabel = _ref3.requiredLabel,
      optional = _ref3.optional,
      optionalLabel = _ref3.optionalLabel,
      validationFirst = _ref3.validationFirst,
      label = _ref3.label,
      hideLabel = _ref3.hideLabel,
      error = _ref3.error,
      warning = _ref3.warning,
      info = _ref3.info,
      options = _ref3.options,
      optionType = _ref3.optionType,
      props = objectWithoutProperties(_ref3, ['className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info', 'options', 'optionType']);

  var requiredFlag = getRequiredFlag(required, optional);
  var describedBy = getDescribedByIds({
    name: props.name, info: info, warning: warning, error: error
  });
  var optionGroupValue = props.value !== undefined ? props.value.toString() : undefined;

  var optionInputProps = _extends({}, props, {
    type: optionType,
    required: requiredFlag,
    invalid: error !== undefined ? !!error : undefined,
    'aria-describedby': describedBy.length > 0 ? describedBy.join(' ') : undefined
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    FormGroup,
    {
      element: 'fieldset',
      labelElement: 'legend',
      name: props.name,
      required: required,
      optional: optional,
      label: label,
      hideLabel: hideLabel,
      error: error,
      warning: warning,
      info: info,
      className: className,
      validationFirst: validationFirst
    },
    options.length > 1 ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      List,
      { type: 'bare' },
      options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          ListItem,
          { type: 'bare', key: props.name + '-' + option.value },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FormOptionFieldInput, _extends({}, optionInputProps, {
            option: option,
            optionGroupValue: optionGroupValue
          }))
        );
      })
    ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FormOptionFieldInput, _extends({}, optionInputProps, {
      option: options[0],
      optionGroupValue: optionGroupValue
    }))
  );
};

FormOptionField.propTypes = _extends({}, propTypes, {
  options: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,
  optionType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['radio', 'checkbox'])
});

FormOptionField.defaultProps = {
  optionType: 'radio'
};

var CheckboxField = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('CheckboxField'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])({ optionType: 'checkbox' }))(FormOptionField);

var RadioButtonField = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('RadioButtonField'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])({ optionType: 'radio' }))(FormOptionField);

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      name = _ref.name,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      autoComplete = _ref.autoComplete,
      autoCapitalize = _ref.autoCapitalize,
      required = _ref.required,
      readOnly = _ref.readOnly,
      spellCheck = _ref.spellCheck,
      tabIndex = _ref.tabIndex,
      className = _ref.className,
      invalid = _ref.invalid,
      cols = _ref.cols,
      rows = _ref.rows,
      wrap = _ref.wrap,
      rest = objectWithoutProperties(_ref, ['id', 'name', 'placeholder', 'disabled', 'onBlur', 'onChange', 'onFocus', 'value', 'defaultValue', 'minLength', 'maxLength', 'autoComplete', 'autoCapitalize', 'required', 'readOnly', 'spellCheck', 'tabIndex', 'className', 'invalid', 'cols', 'rows', 'wrap']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('textarea', _extends({}, rest, {
    id: id || name,
    name: name,

    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-text-input ln-c-text-input--textarea', className),

    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,

    value: value,
    defaultValue: defaultValue,

    placeholder: placeholder,

    tabIndex: tabIndex,

    autoComplete: autoComplete,
    autoCapitalize: autoCapitalize,

    spellCheck: spellCheck,

    required: required,
    minLength: minLength,
    maxLength: maxLength,

    readOnly: readOnly,
    disabled: disabled,

    'aria-disabled': disabled || undefined,
    'aria-required': required === false ? required : undefined,
    'aria-invalid': invalid || undefined,

    cols: cols,
    rows: rows,
    wrap: wrap
  }));
};

TextArea.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  defaultValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  minLength: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  maxLength: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  autoComplete: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  autoCapitalize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  spellCheck: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['default', true, false]),
  tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  rows: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  cols: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  wrap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TextArea.defaultProps = {
  id: undefined,
  disabled: false,
  placeholder: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  value: undefined,
  defaultValue: undefined,
  checked: undefined,
  defaultChecked: undefined,
  minLength: undefined,
  maxLength: undefined,
  autoComplete: undefined,
  autoCapitalize: undefined,
  required: undefined,
  readOnly: false,
  spellCheck: undefined,
  tabIndex: undefined,
  className: undefined,
  invalid: undefined,
  rows: undefined,
  cols: undefined,
  wrap: undefined
};

var TextAreaField = function (_Component) {
  inherits(TextAreaField, _Component);

  function TextAreaField(props) {
    classCallCheck(this, TextAreaField);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { value: props.value || props.defaultValue || '' };

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  TextAreaField.prototype.handleChange = function handleChange(event) {
    this.setState({ value: event.target.value });

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  TextAreaField.prototype.render = function render() {
    var _props = this.props,
        characterCount = _props.characterCount,
        className = _props.className,
        required = _props.required,
        requiredLabel = _props.requiredLabel,
        optional = _props.optional,
        optionalLabel = _props.optionalLabel,
        validationFirst = _props.validationFirst,
        label = _props.label,
        hideLabel = _props.hideLabel,
        error = _props.error,
        warning = _props.warning,
        info = _props.info,
        props = objectWithoutProperties(_props, ['characterCount', 'className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info']);

    var counterId = props.name + 'Counter';

    var requiredFlag = getRequiredFlag(required, optional);
    var describedBy = getDescribedByIds({
      name: props.name,
      info: info,
      warning: warning,
      error: error
    }).concat([counterId]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      FormGroup,
      {
        name: props.name,
        required: required,
        optional: optional,
        label: label,
        hideLabel: hideLabel,
        error: error,
        warning: warning,
        info: info,
        className: className,
        validationFirst: validationFirst
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextArea, _extends({
        required: requiredFlag,
        invalid: error !== undefined ? !!error : undefined,
        'aria-describedby': describedBy.join(' ')
      }, props, {
        onChange: this.handleChange,
        value: this.state.value
      })),
      characterCount && props.maxLength && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        { id: counterId, 'aria-live': 'polite', 'aria-atomic': 'true' },
        this.state.value.length,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'ln-u-visually-hidden' },
          ' out of '
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { 'aria-hidden': 'true' },
          ' / '
        ),
        props.maxLength
      )
    );
  };

  return TextAreaField;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

TextAreaField.propTypes = _extends({}, propTypes, {
  characterCount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
});

TextAreaField.defaultProps = {
  characterCount: false
};

var SearchInput = function SearchInput(_ref) {
  var className = _ref.className,
      hasIcon = _ref.hasIcon,
      hasAction = _ref.hasAction,
      hasButton = _ref.hasButton,
      icon$$1 = _ref.icon,
      action = _ref.action,
      props = objectWithoutProperties(_ref, ['className', 'hasIcon', 'hasAction', 'hasButton', 'icon', 'action']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    InputGroup,
    { hasButton: hasButton, className: className },
    hasIcon && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      InputIcon,
      null,
      icon$$1
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      InputControl,
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput, _extends({ type: 'search' }, props))
    ),
    hasAction && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      InputAction,
      null,
      action
    )
  );
};

SearchInput.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  action: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hasButton: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hasAction: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hasIcon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

SearchInput.defaultProps = {
  className: undefined,
  icon: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Search$1, null),
  action: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SearchButton, { inputAction: true }),
  hasButton: false,
  hasAction: false,
  hasIcon: false
};

var FlagWrapper = function FlagWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      respondAt = _ref.respondAt,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'respondAt']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, !respondAt && 'ln-o-flag', respondAt && 'ln-o-flag@' + respondAt)
    }),
    children
  );
};

FlagWrapper.displayName = 'Flag.Wrapper';

FlagWrapper.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  respondAt: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

FlagWrapper.defaultProps = {
  className: undefined,
  respondAt: undefined
};

var FlagBody = function FlagBody(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      alignment = _ref.alignment,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'alignment']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-o-flag__body', (_classnames = {}, _classnames['ln-o-flag__body--' + alignment] = alignment, _classnames))
    }),
    children
  );
};

FlagBody.displayName = 'Flag.Body';

FlagBody.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  alignment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['top', 'bottom'])
};

FlagBody.defaultProps = {
  className: undefined,
  alignment: undefined
};

var FlagComponent = function FlagComponent(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      alignment = _ref.alignment,
      nowrap = _ref.nowrap,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'alignment', 'nowrap']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-o-flag__component', (_classnames = {}, _classnames['ln-o-flag__component--' + alignment] = alignment, _classnames['ln-o-flag__component--nowrap'] = nowrap, _classnames))
    }),
    children
  );
};

FlagComponent.displayName = 'Flag.Component';

FlagComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  alignment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['top', 'bottom']),
  nowrap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

FlagComponent.defaultProps = {
  className: undefined,
  alignment: undefined,
  nowrap: false
};

var Flag = {
  Wrapper: FlagWrapper,
  Body: FlagBody,
  Component: FlagComponent
};

var excludeProps = ['setValue', 'clearValue', 'setRef'];

var SearchField = function SearchField(_ref) {
  var className = _ref.className,
      required = _ref.required,
      requiredLabel = _ref.requiredLabel,
      optional = _ref.optional,
      optionalLabel = _ref.optionalLabel,
      validationFirst = _ref.validationFirst,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      labelElement = _ref.labelElement,
      button = _ref.button,
      element = _ref.element,
      props = objectWithoutProperties(_ref, ['className', 'required', 'requiredLabel', 'optional', 'optionalLabel', 'validationFirst', 'label', 'hideLabel', 'error', 'warning', 'info', 'labelElement', 'button', 'element']);

  var requiredFlag = getRequiredFlag(required, optional);
  var describedBy = getDescribedByIds({
    name: props.name, info: info, warning: warning, error: error
  });

  var inputProps = _extends({}, props, {
    required: requiredFlag,
    invalid: error !== undefined ? !!error : undefined,
    'aria-describedby': describedBy.length > 0 ? describedBy.join(' ') : undefined
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    FormGroup,
    {
      name: props.name,
      required: required,
      optional: optional,
      label: label,
      hideLabel: hideLabel,
      error: error,
      warning: warning,
      info: info,
      className: className,
      validationFirst: validationFirst,
      labelElement: labelElement,
      element: element
    },
    props.hasButton ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Flag.Wrapper,
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Flag.Body,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SearchInput, filterProps(inputProps, excludeProps))
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Flag.Component,
        null,
        button
      )
    ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SearchInput, filterProps(inputProps, excludeProps))
  );
};

SearchField.propTypes = _extends({}, propTypes, {
  button: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
});

SearchField.defaultProps = {
  button: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SearchButton, null)
};

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Card,
    _extends({}, rest, { className: className }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'fieldset',
      null,
      children
    )
  );
};

Fieldset.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Fieldset.defaultProps = {
  children: undefined,
  className: undefined
};

var Legend = function Legend(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fontStyle = _ref.fontStyle,
      heading = _ref.heading,
      headingLevel = _ref.headingLevel,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'fontStyle', 'heading', 'headingLevel']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'legend',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(fontStyle && 'ln-u-' + fontStyle, className),
      role: heading ? 'heading' : undefined,
      'aria-level': heading ? headingLevel || fontStyle && fontStyle.replace(/\D+/g, '') : undefined
    }),
    children
  );
};

Legend.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  fontStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  heading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  headingLevel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
};

Legend.defaultProps = {
  children: undefined,
  className: undefined,
  fontStyle: undefined,
  heading: true,
  headingLevel: undefined
};

var onChangeHandler = function onChangeHandler(_ref) {
  var onChange = _ref.onChange,
      setValue = _ref.setValue;
  return function (e) {
    if (onChange) {
      onChange(e);
    }
    setValue(e.target.value);
  };
};

var getClearActionProps = function getClearActionProps(value, clearValue) {
  return value.length > 0 ? { hasAction: true, action: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CancelButton, { onClick: clearValue, 'aria-label': 'Clear the field' }) } : { hasAction: false, action: undefined };
};

var setFieldGroupElement = function setFieldGroupElement(_ref2) {
  var setRef = _ref2.setRef;
  return {
    // eslint-disable-next-line react/prop-types
    element: function element(_ref3) {
      var children = _ref3.children,
          className = _ref3.className;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { ref: setRef, className: className },
        children
      );
    }
  };
};

var withClear = function withClear(WrappedField) {
  /* istanbul ignore next */
  var WithClear = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('WithClear'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('value', 'setValue', function (_ref4) {
    var defaultValue = _ref4.defaultValue,
        _ref4$value = _ref4.value,
        value = _ref4$value === undefined ? '' : _ref4$value;
    return defaultValue || value;
  }), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])(function () {
    var input = void 0;

    return {
      onChange: onChangeHandler,
      clearValue: function clearValue(_ref5) {
        var setValue = _ref5.setValue;
        return function () {
          setValue('');
          if (input) {
            input.focus();
          }
        };
      },
      setRef: function setRef() {
        return function (field) {
          if (field) {
            input = field.querySelector('input');
          }
        };
      }
    };
  }), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])(function (_ref6) {
    var value = _ref6.value,
        clearValue = _ref6.clearValue;
    return _extends({}, getClearActionProps(value, clearValue));
  }), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withPropsOnChange"])(function () {
    return false;
  }, setFieldGroupElement))(WrappedField);

  return WithClear;
};

var Search$3 = function Search(_ref) {
  var _classnames, _classnames2;

  var className = _ref.className,
      placeholder = _ref.placeholder,
      handleSubmit = _ref.handleSubmit,
      expandable = _ref.expandable,
      value = _ref.value,
      handleChange = _ref.handleChange,
      open = _ref.open,
      toggle = _ref.toggle,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      rest = objectWithoutProperties(_ref, ['className', 'placeholder', 'handleSubmit', 'expandable', 'value', 'handleChange', 'open', 'toggle', 'onBlur', 'onFocus']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Form,
    _extends({}, filterProps(rest, ['changeValue', 'onExpandClick']), {
      onSubmit: handleSubmit,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-search', (_classnames = {
        'ln-c-search--expandable': expandable,
        'is-open': open
      }, _classnames[className] = typeof className === 'string', _classnames[className.form] = !!className.form, _classnames))
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
      type: 'search',
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-search__input', 'ln-c-text-input', (_classnames2 = {}, _classnames2[className.input] = !!className.input, _classnames2)),
      placeholder: placeholder,
      value: value,
      onChange: handleChange,
      onBlur: onBlur,
      onFocus: onFocus
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'button',
      {
        type: 'submit',
        className: 'ln-c-search__submit',
        disabled: !value,
        'aria-disabled': !value || undefined
      },
      'Submit search query'
    ),
    expandable && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'ln-c-search--expandable__toggle',
        onClick: toggle
      },
      'Open Search'
    )
  );
};

Search$3.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    input: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })]),
  placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  expandable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  handleChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

Search$3.defaultProps = {
  className: {},
  placeholder: 'Search',
  expandable: false,
  open: false,
  toggle: undefined,
  onBlur: undefined,
  onFocus: undefined
};

var toggle$1 = function toggle(_ref) {
  var onExpandClick = _ref.onExpandClick,
      open = _ref.open;
  return function () {
    return onExpandClick(!open);
  };
};

var handleChange = function handleChange(_ref2) {
  var onChange = _ref2.onChange,
      changeValue = _ref2.changeValue;
  return function (e) {
    changeValue(e.target.value);

    if (onChange) {
      onChange(e);
    }
  };
};

var handleSubmit = function handleSubmit(_ref3) {
  var onSubmit = _ref3.onSubmit,
      value = _ref3.value;
  return function (e) {
    onSubmit(value);
    e.preventDefault();
  };
};

var Search$2 = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Search'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('value', 'changeValue', ''), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('open', 'onExpandClick', false), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])({
  toggle: toggle$1,
  handleChange: handleChange,
  handleSubmit: handleSubmit
}))(Search$3);

var navigationClasses$1 = {
  list: 'ln-c-icon-nav',
  item: 'ln-c-icon-nav__item',
  link: 'ln-c-icon-nav__link'
};

var searchClasses = {
  form: 'ln-c-icon-nav__form',
  input: 'ln-c-icon-nav__text-input'
};

var IconNavigation = function IconNavigation(_ref) {
  var onSearchSubmit = _ref.onSearchSubmit,
      items = _ref.items,
      rest = objectWithoutProperties(_ref, ['onSearchSubmit', 'items']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Navigation.List, _extends({}, rest, {
    className: navigationClasses$1,
    items: onSearchSubmit ? [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'li',
      { key: 'search', className: 'ln-c-icon-nav__item ln-c-icon-nav__item--fixed' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Search$2, {
        className: searchClasses,
        onSubmit: onSearchSubmit,
        expandable: true
      })
    )].concat(items) : items
  }));
};

IconNavigation.propTypes = {
  onSearchSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  items: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element)
};

IconNavigation.defaultProps = {
  onSearchSubmit: undefined,
  items: []
};

var MainBar = function MainBar(_ref) {
  var logo = _ref.logo,
      toggle = _ref.toggle,
      menuItems = _ref.menuItems,
      iconNav = _ref.iconNav,
      onSearchSubmit = _ref.onSearchSubmit,
      className = _ref.className,
      topBar = _ref.topBar,
      rest = objectWithoutProperties(_ref, ['logo', 'toggle', 'menuItems', 'iconNav', 'onSearchSubmit', 'className', 'topBar']);

  var showIconNav = iconNav.length > 0 || onSearchSubmit;
  var showNavList = menuItems.length > 0;

  var createOnClickHandle = function createOnClickHandle(onClick) {
    return function (e) {
      toggle(false);

      if (onClick) {
        onClick(e);
      }
    };
  };

  var addOnClickHandler = function addOnClickHandler(menuItem) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(menuItem, { onClick: createOnClickHandle(menuItem.props.onClick) });
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Navigation.Wrapper,
    _extends({}, rest, {
      title: logo,
      button: iconNav.length > 0 || menuItems.length > 0 || Object.keys(topBar).length > 0 ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(MenuButton, { className: 'ln-c-header__toggle', onClick: toggle }) : undefined,
      className: className
    }),
    (showIconNav || showNavList) && [showIconNav && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconNavigation, {
      key: 'iconNav',
      items: iconNav.map(addOnClickHandler),
      onSearchSubmit: onSearchSubmit
    }), showNavList > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Navigation.List, { key: 'mainNav', items: menuItems.map(addOnClickHandler) })]
  );
};

MainBar.propTypes = {
  logo: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  menuItems: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  topBar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  iconNav: IconNavigation.propTypes.items,
  onSearchSubmit: IconNavigation.propTypes.onSearchSubmit
};

MainBar.defaultProps = {
  menuItems: [],
  className: undefined,
  topBar: {},
  iconNav: IconNavigation.defaultProps.items,
  onSearchSubmit: IconNavigation.defaultProps.onSearchSubmit
};

var Header$1 = function Header(_ref) {
  var className = _ref.className,
      mainId = _ref.mainId,
      open = _ref.open,
      toggle = _ref.toggle,
      topBar = _ref.topBar,
      logo = _ref.logo,
      iconNav = _ref.iconNav,
      menuItems = _ref.menuItems,
      onSearchSubmit = _ref.onSearchSubmit,
      rest = objectWithoutProperties(_ref, ['className', 'mainId', 'open', 'toggle', 'topBar', 'logo', 'iconNav', 'menuItems', 'onSearchSubmit']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'header',
    _extends({}, filterProps(rest, ['onMenuClick']), {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-header', className, {
        'is-open': open
      })
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'a',
      { href: '#' + mainId, className: 'ln-u-visually-hidden' },
      'Skip Navigation'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button', {
      className: 'ln-c-header__toggle-overlay js-header-toggle',
      title: 'Toggle Menu',
      'aria-hidden': 'true',
      tabIndex: '-1',
      onClick: toggle
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'ln-c-header__inner' },
      Object.keys(topBar).length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TopBar, _extends({}, topBar, {
        toggle: toggle,
        hasDivider: iconNav.length > 0 || menuItems.length > 0
      })),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(MainBar, {
        logo: logo,
        toggle: toggle,
        menuItems: menuItems,
        iconNav: iconNav,
        onSearchSubmit: onSearchSubmit,
        topBar: topBar
      })
    )
  );
};

Header$1.propTypes = _extends({
  mainId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  topBar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(_extends({}, TopBar.propTypes))
}, MainBar.propTypes, {
  iconNav: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element)
});

Header$1.defaultProps = _extends({
  mainId: 'main-content',
  className: undefined,
  topBar: {}
}, MainBar.defaultProps);

var toggle = function toggle(_ref) {
  var onMenuClick = _ref.onMenuClick,
      open = _ref.open;
  return function (forceState) {
    var newState = typeof forceState === 'boolean' ? forceState : !open;

    setHasOverlay(newState);
    return onMenuClick(newState);
  };
};

var Header = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Header'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('open', 'onMenuClick', false), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])({
  toggle: toggle
}))(Header$1);

var MainSection = function MainSection(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      id: 'main-content',
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-main-content')
    }),
    children
  );
};

MainSection.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

MainSection.defaultProps = {
  children: undefined,
  className: undefined
};

var ColleagueLayout = function ColleagueLayout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      mainId = _ref.mainId,
      open = _ref.open,
      toggle = _ref.toggle,
      topBar = _ref.topBar,
      logo = _ref.logo,
      iconNav = _ref.iconNav,
      menuItems = _ref.menuItems,
      onSearchSubmit = _ref.onSearchSubmit,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'mainId', 'open', 'toggle', 'topBar', 'logo', 'iconNav', 'menuItems', 'onSearchSubmit']);

  var headerProps = {
    mainId: mainId,
    open: open,
    toggle: toggle,
    topBar: topBar,
    logo: logo,
    iconNav: iconNav,
    menuItems: menuItems,
    onSearchSubmit: onSearchSubmit
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, { className: className }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Header, headerProps),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      MainSection,
      null,
      children
    )
  );
};
ColleagueLayout.propTypes = _extends({
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
}, Header.propTypes);

ColleagueLayout.defaultProps = {
  children: undefined,
  className: undefined
};

var GridWrapper = function GridWrapper(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      matrix = _ref.matrix,
      reverse = _ref.reverse,
      equalHeight = _ref.equalHeight,
      gutterSize = _ref.gutterSize,
      verticalAlign = _ref.verticalAlign,
      horizontalAlign = _ref.horizontalAlign,
      element = _ref.element,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'matrix', 'reverse', 'equalHeight', 'gutterSize', 'verticalAlign', 'horizontalAlign', 'element']);

  var Element = element;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Element,
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-o-grid', (_classnames = {
        'ln-o-grid--matrix': matrix,
        'ln-o-grid--reverse': reverse,
        'ln-o-grid--equal-height': equalHeight
      }, _classnames['ln-o-grid--gutter-' + gutterSize] = gutterSize, _classnames['ln-o-grid--' + verticalAlign] = verticalAlign, _classnames['ln-u-text-align-' + horizontalAlign] = horizontalAlign, _classnames))
    }),
    children
  );
};

GridWrapper.displayName = 'Grid.Wrapper';

GridWrapper.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  matrix: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  gutterSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  reverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  equalHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  verticalAlign: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['middle', 'bottom']),
  horizontalAlign: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['center', 'right']),
  element: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};

GridWrapper.defaultProps = {
  className: undefined,
  matrix: false,
  gutterSize: undefined,
  reverse: false,
  equalHeight: false,
  verticalAlign: undefined,
  horizontalAlign: undefined,
  element: 'div'
};

var GridItem = function GridItem(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      offsetLeft = _ref.offsetLeft,
      offsetRight = _ref.offsetRight,
      element = _ref.element,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'size', 'offsetLeft', 'offsetRight', 'element']);

  var Element = element;
  var sizeClass = (typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object' ? Object.keys(size).map(function (breakpoint) {
    return breakpoint !== 'default' ? 'ln-u-' + size[breakpoint] + '@' + breakpoint : 'ln-u-' + size[breakpoint];
  }) : 'ln-u-' + size;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Element,
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-o-grid__item', sizeClass, (_classnames = {}, _classnames['ln-u-pull-' + offsetLeft] = offsetLeft, _classnames['ln-u-push-' + offsetRight] = offsetRight, _classnames))
    }),
    children
  );
};

GridItem.displayName = 'Grid.Item';

GridItem.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired,
  offsetLeft: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  offsetRight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  element: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};

GridItem.defaultProps = {
  className: undefined,
  offsetLeft: undefined,
  offsetRight: undefined,
  element: 'div'
};

var Grid = {
  Wrapper: GridWrapper,
  Item: GridItem
};

var Checkbox = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Checkbox'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])({ type: 'checkbox' }))(FormOption);

var RadioButton = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('RadioButton'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])({ type: 'radio' }))(FormOption);

var LoadingIcon = function LoadingIcon(_ref) {
  var className = _ref.className,
      inverted = _ref.inverted,
      rest = objectWithoutProperties(_ref, ['className', 'inverted']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-loading-indicator', inverted && 'ln-c-loading-indicator--inverted')
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'ln-c-loading-indicator__bar' })
  );
};

LoadingIcon.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  inverted: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

LoadingIcon.defaultProps = {
  className: undefined,
  inverted: false
};

var LoadingIndicator = function LoadingIndicator(_ref) {
  var message = _ref.message,
      className = _ref.className,
      inverted = _ref.inverted,
      rest = objectWithoutProperties(_ref, ['message', 'className', 'inverted']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    Flag.Wrapper,
    _extends({}, rest, { className: className }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Flag.Component,
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LoadingIcon, { inverted: inverted })
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Flag.Body,
      null,
      message
    )
  );
};

LoadingIndicator.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  inverted: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

LoadingIndicator.defaultProps = {
  message: 'Please wait, loading...',
  className: undefined,
  inverted: false
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      open = _ref.open,
      handleClose = _ref.handleClose,
      closeContainerElement = _ref.closeContainerElement,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'open', 'handleClose', 'closeContainerElement']);

  if (open) setHasOverlay(true);

  var onClose = function onClose(e) {
    setHasOverlay(false);

    if (handleClose) {
      handleClose(e);
    }

    if (closeContainerElement && closeContainerElement.onClick) {
      closeContainerElement.onClick(e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-modal', {
        'is-open': open
      })
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Flag.Wrapper,
      { className: 'ln-u-fill-height' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Flag.Body,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'ln-c-modal__body' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CloseButton, { onClick: onClose, containerElement: closeContainerElement }),
          children
        )
      )
    )
  );
};

Modal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  handleClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  closeContainerElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element])
};

Modal.defaultProps = {
  className: undefined,
  open: false,
  handleClose: undefined,
  closeContainerElement: undefined
};

var NotificationList = function NotificationList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      open = _ref.open,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'open']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    List,
    _extends({}, rest, {
      type: 'bare',
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-activities', {
        'is-open': open
      })
    }),
    children
  );
};

NotificationList.displayName = 'Notification.List';

NotificationList.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

NotificationList.defaultProps = {
  className: undefined,
  open: false
};

var NotificationItem = function NotificationItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      notification = _ref.notification,
      handleClose = _ref.handleClose,
      open = _ref.open,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'notification', 'handleClose', 'open']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    ListItem,
    _extends({}, rest, {
      type: 'bare',
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-activities__item', {
        'ln-c-activities__item--notification': notification,
        'is-open': notification && open
      })
    }),
    notification && handleClose && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CloseButton, { onClick: handleClose }),
    children
  );
};

NotificationItem.displayName = 'Notification.Item';

NotificationItem.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  notification: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  handleClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

NotificationItem.defaultProps = {
  className: undefined,
  notification: false,
  open: false,
  handleClose: undefined
};

var Notification = {
  List: NotificationList,
  Item: NotificationItem
};

var Section = function Section(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'section',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-o-section')
    }),
    children
  );
};

Section.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

Section.defaultProps = {
  children: undefined,
  className: undefined
};

var ArrowRight = function ArrowRight(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    _extends({
      width: '10',
      height: '18',
      viewBox: '0 0 10 18'
    }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M7.586 9L.293 16.293a1 1 0 0 0 1.414 1.414l8-8a1 1 0 0 0 0-1.414l-8-8A1 1 0 1 0 .293 1.707L7.586 9z'
    })
  );
};

var ArrowRight$1 = iconHandler(ArrowRight);

var colours = {
  success: 'green',
  info: 'blue',
  warning: 'amber',
  danger: 'red',
  none: 'transparent'
};

var StatusCard = function StatusCard(_ref) {
  var _classnames;

  var className = _ref.className,
      link = _ref.link,
      onClick = _ref.onClick,
      status = _ref.status,
      children = _ref.children,
      containerElement = _ref.containerElement,
      rest = objectWithoutProperties(_ref, ['className', 'link', 'onClick', 'status', 'children', 'containerElement']);

  var props = _extends({}, rest, {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-status-card', className, (_classnames = {
      'ln-c-status-card--link': link || onClick
    }, _classnames['ln-c-status-card--' + colours[status]] = colours[status], _classnames)),
    onClick: onClick
  });

  var body = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'ln-c-status-card__content' },
      children
    ),
    (link || onClick) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'ln-c-status-card__chevron' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ArrowRight$1, null)
    )
  );

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(containerElement) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(containerElement, props, body) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(onClick ? 'button' : containerElement, props, body);
};

StatusCard.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  status: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['success', 'info', 'warning', 'danger', 'none']),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  containerElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element])
};

StatusCard.defaultProps = {
  className: undefined,
  link: false,
  onClick: undefined,
  status: undefined,
  containerElement: 'div'
};

var TableCaption = function TableCaption(_ref) {
  var children = _ref.children,
      className = _ref.className,
      visuallyHidden = _ref.visuallyHidden,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'visuallyHidden']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'caption',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-table__caption', className, visuallyHidden && 'ln-u-visually-hidden')
    }),
    children
  );
};

TableCaption.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  visuallyHidden: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

TableCaption.defaultProps = {
  className: undefined,
  visuallyHidden: false
};

var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
      sortLabel = _ref.sortLabel,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'sortLabel', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'thead',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table__header'),
      'aria-label': sortLabel ? 'Sort by' : undefined
    }),
    children
  );
};

TableHeader.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  sortLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TableHeader.defaultProps = {
  children: undefined,
  sortLabel: false,
  className: undefined
};

var TableHeaderRow = function TableHeaderRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'tr',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table__row', 'ln-c-table__header-row')
    }),
    children
  );
};

TableHeaderRow.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TableHeaderRow.defaultProps = {
  children: undefined,
  className: undefined
};

var TableHeaderCell = function TableHeaderCell(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      align = _ref.align,
      onSort = _ref.onSort,
      sortDirection = _ref.sortDirection,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'align', 'onSort', 'sortDirection']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'th',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-table__header-cell', className, (_classnames = {
        'ln-c-table__header-cell--sortable': !!onSort
      }, _classnames['ln-c-table__header-cell--text-align-' + align] = align, _classnames))
    }),
    onSort ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'button',
      {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-table__sort-button', {
          'is-active': !!sortDirection,
          'is-ascending': sortDirection === 'ascending'
        }),
        onClick: function onClick() {
          return onSort(sortDirection === 'ascending');
        }
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'ln-c-table__sort-text', 'aria-label': 'Sort by' },
        children
      )
    ) : children
  );
};

TableHeaderCell.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  onSort: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  sortDirection: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ascending', 'descending']),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  align: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['left', 'right', 'center'])
};

TableHeaderCell.defaultProps = {
  children: undefined,
  onSort: undefined,
  sortDirection: undefined,
  className: undefined,
  align: undefined
};

var TableBody = function TableBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'tbody',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table__body')
    }),
    children
  );
};

TableBody.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};

TableBody.defaultProps = {
  children: undefined,
  className: undefined
};

var TableRow = function TableRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ['children', 'className']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'tr',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table__row')
    }),
    children
  );
};

TableRow.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

TableRow.defaultProps = {
  children: undefined,
  className: undefined
};

var TableCell = function TableCell(_ref) {
  var _classnames;

  var children = _ref.children,
      label = _ref.label,
      className = _ref.className,
      align = _ref.align,
      rest = objectWithoutProperties(_ref, ['children', 'label', 'className', 'align']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'td',
    _extends({}, rest, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table__cell', (_classnames = {}, _classnames['ln-c-table__cell--text-align-' + align] = align, _classnames)),
      'data-label': label
    }),
    children
  );
};

TableCell.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  align: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['left', 'right', 'center'])
};

TableCell.defaultProps = {
  children: undefined,
  label: undefined,
  className: undefined,
  align: undefined
};

var DEFAULT_CELL_DATA_PROPERTY = 'value';

var buildAccessor = function buildAccessor(accessor) {
  if (typeof accessor === 'function') {
    return accessor;
  }

  if (typeof accessor === 'string') {
    return function (row) {
      var _ref;

      return _ref = {}, _ref[DEFAULT_CELL_DATA_PROPERTY] = row[accessor], _ref;
    };
  }

  return function (row) {
    return row;
  };
};

var buildAccessors = function buildAccessors(columns) {
  return columns.reduce(function (acc, curr) {
    acc[curr.name] = buildAccessor(curr.accessor);
    return acc;
  }, {});
};

var buildColClassName = function buildColClassName(columns) {
  return columns.reduce(function (classNames, column) {
    var _babelHelpers$extends;

    return _extends({}, classNames, (_babelHelpers$extends = {}, _babelHelpers$extends[column.name] = _typeof(column.className) === 'object' ? column.className : { th: column.className, td: column.className }, _babelHelpers$extends));
  }, {});
};

var Table = function Table(_ref2) {
  var _classnames;

  var columns = _ref2.columns,
      data = _ref2.data,
      className = _ref2.className,
      responsive = _ref2.responsive,
      labels = _ref2.labels,
      sortable = _ref2.sortable,
      sortData = _ref2.sortData,
      sorted = _ref2.sorted,
      caption = _ref2.caption,
      visuallyHiddenCaption = _ref2.visuallyHiddenCaption,
      fixed = _ref2.fixed,
      rest = objectWithoutProperties(_ref2, ['columns', 'data', 'className', 'responsive', 'labels', 'sortable', 'sortData', 'sorted', 'caption', 'visuallyHiddenCaption', 'fixed']);

  var accessors = buildAccessors(columns);
  var colClassNames = buildColClassName(columns);
  var isSortable = sortable || columns.filter(function (c) {
    return c.sortable;
  }).length > 0;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, filterProps(rest, ['setSorted']), {
      className: 'ln-c-table-container'
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'table',
      {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'ln-c-table', (_classnames = {}, _classnames['ln-c-table--responsive@' + responsive] = typeof responsive === 'string', _classnames['ln-c-table--responsive@md'] = typeof responsive !== 'string' && responsive, _classnames['ln-c-table--no-labels'] = !labels, _classnames['ln-c-table--sorted'] = isSortable, _classnames['ln-c-table--fixed'] = fixed, _classnames))
      },
      caption && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        TableCaption,
        { visuallyHidden: visuallyHiddenCaption },
        caption
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        TableHeader,
        { sortLabel: responsive && isSortable },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          TableHeaderRow,
          null,
          columns.map(function (column) {
            var sortDirection = void 0;
            if (sorted.column === column.name) {
              sortDirection = sorted.ascending ? 'ascending' : 'descending';
            }

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              TableHeaderCell,
              {
                key: column.name,
                sortDirection: sortDirection,
                onSort: column.sortable || column.sortable === undefined && sortable ? function (ascendingActive) {
                  return sortData({
                    column: column.name,
                    accessor: accessors[column.name],
                    ascending: !ascendingActive,
                    sortValue: column.sort || DEFAULT_CELL_DATA_PROPERTY
                  });
                } : undefined,
                align: column.align,
                className: colClassNames[column.name].th
              },
              column.renderHead === undefined ? column.name : column.renderHead
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        TableBody,
        null,
        data.map(function (row) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            TableRow,
            { key: JSON.stringify(row) },
            columns.map(function (column) {
              var cellData = accessors[column.name](row);

              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                TableCell,
                {
                  key: column.name,
                  align: column.align,
                  className: colClassNames[column.name].td,
                  label: responsive && labels && !column.hideLabel ? column.name : undefined
                },
                column.render ? column.render(cellData) : cellData[DEFAULT_CELL_DATA_PROPERTY]
              );
            })
          );
        })
      )
    )
  );
};

Table.propTypes = {
  columns: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    renderHead: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    accessor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
    sort: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
    sortable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
  })).isRequired,
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  responsive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  labels: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sortable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sortData: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  sorted: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    column: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    property: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
    ascending: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  }),
  caption: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  visuallyHiddenCaption: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

Table.defaultProps = {
  className: undefined,
  responsive: false,
  labels: true,
  sortable: false,
  sortData: undefined,
  sorted: {},
  caption: undefined,
  visuallyHiddenCaption: false,
  fixed: false
};

var sortData = function sortData(_ref) {
  var setSorted = _ref.setSorted;
  return function (sortOptions) {
    return setSorted(sortOptions);
  };
};

var sortAlphabetically = function sortAlphabetically(accessor, sortValue, ascending) {
  return function (a, b) {
    var valueA = accessor(a)[sortValue];
    var valueB = accessor(b)[sortValue];

    if (valueA < valueB) {
      return ascending ? -1 : 1;
    }
    if (valueA > valueB) {
      return ascending ? 1 : -1;
    }
    return 0;
  };
};

var sort = function sort(_ref2) {
  var data = _ref2.data,
      sorted = _ref2.sorted;

  if (Object.keys(sorted).length > 0) {
    var sortFunction = typeof sorted.sortValue === 'function' ? sorted.sortValue(sorted.accessor, sorted.ascending) : sortAlphabetically(sorted.accessor, sorted.sortValue, sorted.ascending);

    return {
      data: data.sort(sortFunction)
    };
  }
  return {};
};

var TableWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["setDisplayName"])('Table'), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withState"])('sorted', 'setSorted', {}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])({
  sortData: sortData
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withProps"])(sort))(Table);

var ArrowLeft = function ArrowLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    _extends({
      width: '10',
      height: '18',
      viewBox: '0 0 10 18'
    }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M2.414 9l7.293-7.293A1 1 0 0 0 8.293.293l-8 8a1 1 0 0 0 0 1.414l8 8a1 1 0 1 0 1.414-1.414L2.414 9z'
    })
  );
};

var ArrowLeft$1 = iconHandler(ArrowLeft);

var hasInnerRef = function hasInnerRef(element) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"])(element) && !!element.type.propTypes && !!element.type.propTypes.innerRef;
};

var TabLink = function TabLink(_ref) {
  var _babelHelpers$extends;

  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      containerElement = _ref.containerElement,
      onClick = _ref.onClick,
      setRef = _ref.setRef,
      onFocus = _ref.onFocus,
      rest = objectWithoutProperties(_ref, ['active', 'children', 'className', 'containerElement', 'onClick', 'setRef', 'onFocus']);

  var props = _extends({}, rest, (_babelHelpers$extends = {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-tabs__link', className, {
      'is-active': active
    }),
    role: 'tab',
    'aria-selected': active,
    onClick: onClick
  }, _babelHelpers$extends[hasInnerRef(containerElement) ? 'innerRef' : 'ref'] = setRef ? function (tabLink) {
    setRef(tabLink);
  } : undefined, _babelHelpers$extends.onFocus = onFocus, _babelHelpers$extends));

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(containerElement) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(containerElement, props, children) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(containerElement, props, children);
};

TabLink.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  containerElement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element]),
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  setRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

TabLink.defaultProps = {
  active: false,
  className: undefined,
  containerElement: 'button',
  onClick: undefined,
  setRef: undefined,
  onFocus: undefined
};

var TabList = function TabList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      fill = _ref.fill,
      deep = _ref.deep,
      showPrevArrow = _ref.showPrevArrow,
      showNextArrow = _ref.showNextArrow,
      animateDistance = _ref.animateDistance,
      setTabRef = _ref.setTabRef,
      onArrowClick = _ref.onArrowClick,
      onTabLinkFocus = _ref.onTabLinkFocus,
      rest = objectWithoutProperties(_ref, ['className', 'children', 'fill', 'deep', 'showPrevArrow', 'showNextArrow', 'animateDistance', 'setTabRef', 'onArrowClick', 'onTabLinkFocus']);

  var isResponsive = !fill && __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) > 1 && onArrowClick;
  var transform = isResponsive && animateDistance ? 'translateX(' + animateDistance + '%)' : undefined;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'nav',
    _extends({}, filterProps(rest, ['visibleTabs']), {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ln-c-tabs', className, {
        'ln-c-tabs--fill': fill,
        'ln-c-tabs--deep': deep,
        'has-prev-arrow': showPrevArrow,
        'has-next-arrow': showNextArrow
      })
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'ln-c-tabs__list-wrap' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: 'ln-c-tabs__list',
          role: 'tablist',
          style: { transform: transform }
        },
        isResponsive ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
          /* eslint-disable react/prop-types */
          var props = {
            key: index
          };

          if (child.type === TabLink) {
            props.onFocus = onTabLinkFocus;
            props.setRef = setTabRef;
          }

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, props);
          /* eslint-enable react/prop-types */
        }) : children
      ),
      isResponsive && [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          key: 'arrowPrev',
          className: 'ln-c-tabs__link ln-c-tabs__link--arrow ln-c-tabs__link--arrow-prev',
          tabIndex: '-1',
          onClick: function onClick() {
            return onArrowClick(false);
          }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ArrowLeft$1, null)
      ), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          key: 'arrowNext',
          className: 'ln-c-tabs__link ln-c-tabs__link--arrow ln-c-tabs__link--arrow-next',
          tabIndex: '-1',
          onClick: function onClick() {
            return onArrowClick(true);
          }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ArrowRight$1, null)
      )]
    )
  );
};

TabList.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  deep: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  showPrevArrow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  showNextArrow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animateDistance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  setTabRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onArrowClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onTabLinkFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

TabList.defaultProps = {
  className: undefined,
  fill: false,
  deep: false,
  showPrevArrow: false,
  showNextArrow: false,
  animateDistance: 0,
  setTabRef: undefined,
  onArrowClick: undefined,
  onTabLinkFocus: undefined
};

var getAnimateDistance = function getAnimateDistance(selectedPageIndex, remainingTabs, tabsPerPage) {
  if (selectedPageIndex === undefined) {
    return 0;
  }

  var animateDistance = selectedPageIndex * -100;

  if (remainingTabs < 0) {
    animateDistance += remainingTabs * -1 * (100 / tabsPerPage);
  }

  return animateDistance;
};

var getElementDimensions = function getElementDimensions(element) {
  if (!element.getBoundingClientRect) {
    return {};
  }

  return element.getBoundingClientRect();
};

var findActiveTabLinkIndex = function findActiveTabLinkIndex(children) {
  var index = void 0;
  children.forEach(function (tab, tabIndex) {
    if (tab.props && tab.props.active) {
      index = tabIndex;
    }
  });

  return index;
};

var ARROW_WIDTH = 50;

var Tabs = function (_Component) {
  inherits(Tabs, _Component);

  function Tabs(props) {
    classCallCheck(this, Tabs);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      animateDistance: 0
    };
    _this.tabs = [];
    _this.dimensions = {};

    _this.onArrowClick = _this.onArrowClick.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.onTabLinkFocus = _this.onTabLinkFocus.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.isResponsiveEnabled = _this.isResponsiveEnabled.bind(_this);
    _this.setSelectedTab = _this.setSelectedTab.bind(_this);
    _this.setTabRef = _this.setTabRef.bind(_this);
    _this.setDimensions = _this.setDimensions.bind(_this);
    return _this;
  }

  Tabs.prototype.componentDidMount = function componentDidMount() {
    if (this.isResponsiveEnabled()) {
      this.handleResize();
      window.addEventListener('resize', this.onResize);
    }
  };

  Tabs.prototype.componentWillUnmount = function componentWillUnmount() {
    window.clearTimeout(this.resizeTimer);
    window.removeEventListener('resize', this.onResize);
  };

  Tabs.prototype.onArrowClick = function onArrowClick(next) {
    var modifier = next ? 1 : -1;
    this.setSelectedTab(this.state.selectedIndex + modifier);
  };

  Tabs.prototype.onResize = function onResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.handleResize, 250);
  };

  Tabs.prototype.onTabLinkFocus = function onTabLinkFocus(e) {
    if (this.state.selectedIndex !== undefined) {
      var _getElementDimensions = getElementDimensions(e.target),
          x = _getElementDimensions.x,
          width = _getElementDimensions.width;

      if (x + width >= this.dimensions.wrapper.width) {
        this.setSelectedTab(this.state.selectedIndex + 1);
      } else if (x + width <= this.dimensions.wrapper.x + ARROW_WIDTH) {
        this.setSelectedTab(this.state.selectedIndex - 1);
      }
    }
  };

  Tabs.prototype.setTabRef = function setTabRef(tab) {
    if (tab && !includes(this.tabs, tab)) {
      this.tabs.push(tab);
    }
  };

  Tabs.prototype.setDimensions = function setDimensions() {
    this.dimensions.wrapper = getElementDimensions(this.wrapper);

    if (this.state.selectedIndex === undefined) {
      this.dimensions.lastTab = getElementDimensions(this.tabs[this.tabs.length - 1]);
    }
  };

  Tabs.prototype.setSelectedTab = function setSelectedTab(selectedIndex) {
    var _this2 = this;

    var visibleTabs = this.props.visibleTabs;

    var remainingTabs = selectedIndex !== undefined ? this.tabs.length - (selectedIndex + 1) * visibleTabs : undefined;

    this.setState({ selectedIndex: selectedIndex, remainingTabs: remainingTabs }, function () {
      _this2.setState({
        animateDistance: getAnimateDistance(selectedIndex, remainingTabs, visibleTabs)
      });
    });
  };

  Tabs.prototype.isResponsiveEnabled = function isResponsiveEnabled() {
    return !this.props.fill && this.tabs.length > this.props.visibleTabs;
  };

  Tabs.prototype.handleResize = function handleResize() {
    this.setDimensions();

    if (this.dimensions.wrapper.right < this.dimensions.lastTab.right) {
      var activeIndex = findActiveTabLinkIndex(this.props.children) || 0;
      if (activeIndex > 0) activeIndex = Math.floor(activeIndex / this.props.visibleTabs);
      this.setSelectedTab(activeIndex);
    } else {
      this.setSelectedTab(undefined);
    }
  };

  Tabs.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        selectedIndex = _state.selectedIndex,
        remainingTabs = _state.remainingTabs,
        animateDistance = _state.animateDistance;

    var responsiveProps = {};

    if (this.isResponsiveEnabled()) {
      responsiveProps = {
        showNextArrow: selectedIndex !== undefined && remainingTabs > 0,
        showPrevArrow: selectedIndex !== undefined && selectedIndex > 0,
        animateDistance: animateDistance
      };
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { ref: function ref(wrapper) {
          _this3.wrapper = wrapper;
        } },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TabList, _extends({
        setTabRef: this.setTabRef,
        onArrowClick: this.onArrowClick,
        onTabLinkFocus: this.onTabLinkFocus
      }, responsiveProps, this.props))
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Tabs.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  visibleTabs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
};

Tabs.defaultProps = {
  fill: false,
  visibleTabs: 2
};

var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      rest = objectWithoutProperties(_ref, ['children', 'className', 'active']);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    _extends({}, rest, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, !active && 'ln-u-hidden')
    }),
    children
  );
};

TabPanel.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

TabPanel.defaultProps = {
  children: undefined,
  className: undefined,
  active: true
};




/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(9);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimaryButton = function PrimaryButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({}, props, {
      className: (0, _classnames2.default)('ln-c-button--primary', props.className)
    }),
    props.children
  );
};

PrimaryButton.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};

PrimaryButton.defaultProps = {
  className: undefined
};

exports.default = PrimaryButton;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cancel = __webpack_require__(53);

var _Cancel2 = _interopRequireDefault(_Cancel);

var _Button = __webpack_require__(9);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelButton = function CancelButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    props,
    _react2.default.createElement(_Cancel2.default, null)
  );
};

exports.default = CancelButton;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cancel = function Cancel(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '20'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M15.02 3.707L3.708 15.021a1 1 0 1 0 1.414 1.414L16.435 5.121a1 1 0 1 0-1.414-1.414z'
      }),
      _react2.default.createElement('path', {
        d: 'M3.707 5.121l11.314 11.314a1 1 0 1 0 1.414-1.414L5.121 3.707a1 1 0 1 0-1.414 1.414z'
      })
    )
  );
};

exports.icon = Cancel;
exports.default = (0, _hoc2.default)(Cancel);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M23.207 21.793l-7.5-7.5a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18z'
      })
    )
  );
};

exports.icon = Search;
exports.default = (0, _hoc2.default)(Search);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowDown = function ArrowDown(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '10',
      viewBox: '0 0 18 10'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M9 7.586L1.707.293A1 1 0 0 0 .293 1.707l8 8a1 1 0 0 0 1.414 0l8-8A1 1 0 1 0 16.293.293L9 7.586z'
    })
  );
};

exports.icon = ArrowDown;
exports.default = (0, _hoc2.default)(ArrowDown);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57);
module.exports = __webpack_require__(62);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(58).enable();
  window.Promise = __webpack_require__(60);
}

// fetch() polyfill for making API calls.
__webpack_require__(61);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(29);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(29);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_scss__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_Breadcrumbs_reducers_breadcrumbReducer__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middleware__ = __webpack_require__(229);
// import registerServiceWorker from './registerServiceWorker';
// Set up error logs endpoint
window.Raven&&window.Raven.config(__WEBPACK_IMPORTED_MODULE_10__config__["logEndpoint"],{environment:__WEBPACK_IMPORTED_MODULE_10__config__["env"],release:__WEBPACK_IMPORTED_MODULE_10__config__["buildNumber"]||"latest"}).install();// Set up routes middleware
var _routerForBrowser=Object(__WEBPACK_IMPORTED_MODULE_3_redux_little_router__["e" /* routerForBrowser */])({// The configured routes. Required.
routes:__WEBPACK_IMPORTED_MODULE_8__routes__["a" /* default */],basename:__WEBPACK_IMPORTED_MODULE_10__config__["routerBase"]}),routerReducer=_routerForBrowser.reducer,middleware=_routerForBrowser.middleware,enhancer=_routerForBrowser.enhancer;// Set up and configure store
var store=Object(__WEBPACK_IMPORTED_MODULE_2_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({router:routerReducer,breadcrumbs:__WEBPACK_IMPORTED_MODULE_9__state_Breadcrumbs_reducers_breadcrumbReducer__["a" /* default */]}),Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(enhancer,Object(__WEBPACK_IMPORTED_MODULE_2_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_11__middleware__["a" /* handleLocationChange */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux__["a" /* applyMiddleware */])(middleware),Object(__WEBPACK_IMPORTED_MODULE_2_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_5_redux_thunk___default.a)));// ...after creating store
var initialLocation=store.getState().router;if(initialLocation){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_little_router__["c" /* initializeCurrentLocation */])(initialLocation));}// RENDER APPLICATION
var root=document.getElementById("root");var Main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null));if(root.hasChildNodes()){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["hydrate"])(Main,root);}else{Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(Main,root);}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(13),n=__webpack_require__(16),p=__webpack_require__(30),q=__webpack_require__(17),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(65);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(16),ea=__webpack_require__(0),m=__webpack_require__(66),A=__webpack_require__(13),C=__webpack_require__(17),fa=__webpack_require__(67),ha=__webpack_require__(31),ja=__webpack_require__(68),ka=__webpack_require__(30);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(69);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(70);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var createBrowserRouter = function createBrowserRouter(installer) {
  return function (_ref) {
    var routes = _ref.routes,
        basename = _ref.basename,
        _ref$historyOptions = _ref.historyOptions,
        historyOptions = _ref$historyOptions === undefined ? {} : _ref$historyOptions,
        _ref$history = _ref.history,
        history = _ref$history === undefined ? __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()(_extends({ basename: basename }, historyOptions)) : _ref$history;
    var _history$location = history.location,
        fullPathname = _history$location.pathname,
        search = _history$location.search,
        hash = _history$location.hash,
        _history$location$sta = _history$location.state;
    _history$location$sta = _history$location$sta === undefined ? {} : _history$location$sta;
    var key = _history$location$sta.key,
        state = _history$location$sta.state;

    // Strip the basename from the initial pathname

    var pathname = fullPathname.indexOf(basename) === 0 ? fullPathname.slice(basename.length) : fullPathname;

    var descriptor = basename ? { pathname: pathname, basename: basename, search: search, hash: hash, key: key, state: state } : { pathname: pathname, search: search, hash: hash, key: key, state: state };

    var location = Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])(descriptor);

    return installer({ routes: routes, history: history, location: location });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserRouter(__WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */]));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(20);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(21);

var _PathUtils = __webpack_require__(11);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_merge_queries__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var flow = function flow() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (prev, curr) {
    return function () {
      return curr(prev.apply(undefined, arguments));
    };
  });
};

var resolveQuery = function resolveQuery(_ref) {
  var oldLocation = _ref.oldLocation,
      newLocation = _ref.newLocation,
      options = _ref.options;

  // Merge the old and new queries if asked to persist
  if (options.persistQuery) {
    var mergedQuery = Object(__WEBPACK_IMPORTED_MODULE_1__util_merge_queries__["a" /* default */])(oldLocation.query, newLocation.query);
    return {
      oldLocation: oldLocation,
      newLocation: _extends({}, newLocation, mergedQuery),
      options: options
    };
  }

  return {
    oldLocation: oldLocation,
    newLocation: _extends({}, newLocation, {
      query: newLocation.query
    }),
    options: options
  };
};

var resolveBasename = function resolveBasename(_ref2) {
  var oldLocation = _ref2.oldLocation,
      newLocation = _ref2.newLocation,
      options = _ref2.options;
  var basename = oldLocation.basename;

  if (basename) {
    return {
      oldLocation: oldLocation,
      newLocation: _extends({ basename: basename }, newLocation),
      options: options
    };
  }
  return { oldLocation: oldLocation, newLocation: newLocation, options: options };
};

var resolvePrevious = function resolvePrevious(_ref3) {
  var oldLocation = _ref3.oldLocation,
      newLocation = _ref3.newLocation,
      options = _ref3.options;
  return {
    oldLocation: oldLocation,
    newLocation: _extends({}, newLocation, {
      previous: oldLocation
    }),
    options: options
  };
};

var resolveLocation = flow(resolveQuery, resolveBasename, resolvePrevious);

var locationChangeReducer = function locationChangeReducer(state, action) {
  // No-op the initial route action
  var _state$queue = state.queue,
      queue = _state$queue === undefined ? [] : _state$queue;

  if (state.pathname === action.payload.pathname && state.search === action.payload.search && state.hash === action.payload.hash && !queue.length) {
    return state;
  }

  var queuedLocation = queue[0] || {};
  var newQueue = queue.slice(1);

  // Extract the previous state, but dump the
  // previous state's previous state so that the
  // state tree doesn't keep growing indefinitely
  // eslint-disable-next-line no-unused-vars

  var previous = state.previous,
      _state$routes = state.routes,
      currentRoutes = _state$routes === undefined ? {} : _state$routes,
      oldLocation = _objectWithoutProperties(state, ['previous', 'routes']);

  var _queuedLocation$optio = queuedLocation.options,
      options = _queuedLocation$optio === undefined ? {} : _queuedLocation$optio,
      _queuedLocation$query = queuedLocation.query,
      query = _queuedLocation$query === undefined ? {} : _queuedLocation$query;

  var newLocation = _extends({}, action.payload, { query: query });

  var _resolveLocation = resolveLocation({
    oldLocation: oldLocation,
    newLocation: newLocation,
    options: options
  }),
      resolvedNewLocation = _resolveLocation.newLocation;

  return _extends({}, resolvedNewLocation, { routes: currentRoutes, queue: newQueue });
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$routes = _ref4.routes,
      routes = _ref4$routes === undefined ? {} : _ref4$routes,
      initialLocation = _ref4.initialLocation;

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialLocation, { routes: routes, queue: [] });
    var action = arguments[1];

    if (Object(__WEBPACK_IMPORTED_MODULE_0__types__["m" /* isNavigationActionWithPayload */])(action)) {
      return _extends({}, state, {
        queue: state.queue && state.queue.concat([action.payload])
      });
    }

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__types__["j" /* REPLACE_ROUTES */]) {
      return _extends({}, state, {
        routes: action.payload.routes,
        options: action.payload.options
      });
    }

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__types__["b" /* DID_REPLACE_ROUTES */]) {
      return _extends({}, state, { options: {} });
    }

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__types__["f" /* LOCATION_CHANGED */]) {
      return locationChangeReducer(state, action);
    }

    return state;
  };
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export handleNavigationAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_merge_queries__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* eslint-disable consistent-return */




var unblock = null;

var navigate = function navigate(history, action) {
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__types__["h" /* PUSH */]:
      history.push(action.payload);
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["i" /* REPLACE */]:
      history.replace(action.payload);
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["c" /* GO */]:
      history.go(action.payload);
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["d" /* GO_BACK */]:
      history.goBack();
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["e" /* GO_FORWARD */]:
      history.goForward();
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BLOCK */]:
      unblock = history.block(action.payload);
      break;
    case __WEBPACK_IMPORTED_MODULE_0__types__["k" /* UNBLOCK */]:
      if (unblock) {
        unblock();
      }
      break;
    default:
      break;
  }
};

var handleNavigationAction = function handleNavigationAction(_ref) {
  var next = _ref.next,
      action = _ref.action,
      history = _ref.history,
      query = _ref.query;

  // Synchronously dispatch the original action so that the
  // reducer can add it to its location queue
  var originalDispatch = next(action);

  if ((action.type === __WEBPACK_IMPORTED_MODULE_0__types__["h" /* PUSH */] || action.type === __WEBPACK_IMPORTED_MODULE_0__types__["i" /* REPLACE */]) && action.payload.options && action.payload.options.persistQuery) {
    navigate(history, {
      type: action.type,
      payload: _extends({}, action.payload, Object(__WEBPACK_IMPORTED_MODULE_1__util_merge_queries__["a" /* default */])(query, action.payload.query))
    });
  } else {
    navigate(history, action);
  }

  return originalDispatch;
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref2) {
  var history = _ref2.history;
  return function (_ref3) {
    var getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var query = getState().router.query;

        return Object(__WEBPACK_IMPORTED_MODULE_0__types__["l" /* isNavigationAction */])(action) ? handleNavigationAction({ next: next, action: action, history: history, query: query }) : next(action);
      };
    };
  };
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStoreSubscriber */
/* unused harmony export createHistoryListener */
/* unused harmony export subscribeToStoreAndHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_match_cache__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var createStoreSubscriber = function createStoreSubscriber(getState, dispatch, createMatcher) {
  return function (currentMatcher) {
    var _getState = getState(),
        routes = _getState.routes,
        pathname = _getState.pathname,
        search = _getState.search,
        hash = _getState.hash,
        updateRoutes = _getState.updateRoutes;

    if (updateRoutes) {
      currentMatcher = createMatcher(routes);
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* didReplaceRoutes */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* replace */])({ pathname: pathname, search: search, hash: hash }));
    }

    return currentMatcher;
  };
};

var createHistoryListener = function createHistoryListener(dispatch) {
  return function (currentMatcher, location, action) {
    __WEBPACK_IMPORTED_MODULE_3__util_match_cache__["a" /* default */].clear();

    var match = currentMatcher(location.pathname);
    var payload = _extends({}, location, match, {
      query: __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search || '')
    });

    // Other actions come from the user, so they already have a
    // corresponding queued navigation action.
    if (action === 'POP') {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__types__["g" /* POP */],
        payload: payload
      });
    }

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* locationDidChange */])(payload));
  };
};

var subscribeToStoreAndHistory = function subscribeToStoreAndHistory(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch,
      createMatcher = _ref.createMatcher,
      matchRoute = _ref.matchRoute,
      subscribeToStore = _ref.subscribeToStore,
      subscribeToHistory = _ref.subscribeToHistory;

  var storeSubscriber = createStoreSubscriber(getState, dispatch, createMatcher);
  var historyListener = createHistoryListener(dispatch);

  var currentMatcher = matchRoute;

  // Replace the matcher when replacing routes
  subscribeToStore(function () {
    currentMatcher = storeSubscriber(currentMatcher);
  });

  subscribeToHistory(function (location, action) {
    return historyListener(currentMatcher, location, action);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref2) {
  var history = _ref2.history,
      matchRoute = _ref2.matchRoute,
      createMatcher = _ref2.createMatcher;
  return function (createStore) {
    return function (userReducer, initialState, enhancer) {
      var store = createStore(userReducer, initialState, enhancer);
      var dispatch = store.dispatch,
          subscribeToStore = store.subscribe;
      var subscribeToHistory = history.listen;


      var getState = function getState() {
        var routerState = store.getState().router;
        var _routerState$options = routerState.options;
        _routerState$options = _routerState$options === undefined ? {} : _routerState$options;
        var updateRoutes = _routerState$options.updateRoutes;

        return _extends({}, routerState, { updateRoutes: updateRoutes });
      };

      subscribeToStoreAndHistory({
        getState: getState,
        dispatch: dispatch,
        createMatcher: createMatcher,
        matchRoute: matchRoute,
        subscribeToStore: subscribeToStore,
        subscribeToHistory: subscribeToHistory
      });

      return _extends({}, store, {
        matchRoute: matchRoute
      });
    };
  };
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_create_matcher__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_validate_routes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_flatten_routes__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var reducer = _ref.reducer,
      middleware = _ref.middleware,
      enhancer = _ref.enhancer;
  return function (_ref2) {
    var nestedRoutes = _ref2.routes,
        history = _ref2.history,
        location = _ref2.location,
        _ref2$createMatcher = _ref2.createMatcher,
        createMatcher = _ref2$createMatcher === undefined ? __WEBPACK_IMPORTED_MODULE_0__util_create_matcher__["a" /* default */] : _ref2$createMatcher;

    Object(__WEBPACK_IMPORTED_MODULE_1__util_validate_routes__["a" /* default */])(nestedRoutes);
    var routes = Object(__WEBPACK_IMPORTED_MODULE_2__util_flatten_routes__["a" /* default */])(nestedRoutes);
    var matchRoute = createMatcher(routes);

    return {
      reducer: reducer({
        routes: routes,
        initialLocation: _extends({}, location, matchRoute(location.pathname))
      }),
      middleware: middleware({ history: history }),
      enhancer: enhancer({
        history: history,
        matchRoute: matchRoute,
        createMatcher: createMatcher
      })
    };
  };
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_pattern__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_pattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_pattern__);


var hasTrailingSlash = /\w+\/$/;

var eagerMatcher = function eagerMatcher(routeList) {
  return function (incomingUrl) {
    // Discard query strings
    var pathname = incomingUrl.split('?')[0].replace(hasTrailingSlash, function (path) {
      return path.slice(0, path.length - 1);
    });

    // Find the route that matches the URL
    for (var i = 0; i < routeList.length; i++) {
      var storedRoute = routeList[i];
      var match = storedRoute.pattern.match(pathname);

      if (match) {
        // Return the matched params and user-defined result object
        return {
          route: storedRoute.route,
          params: match,
          result: storedRoute.result
        };
      }
    }

    return null;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (function (routes) {
  var routeList = Object.keys(routes).sort().reverse().map(function (route) {
    return {
      route: route,
      pattern: new __WEBPACK_IMPORTED_MODULE_0_url_pattern___default.a(route),
      result: routes[route]
    };
  });

  return eagerMatcher(routeList);
});

/***/ }),
/* 85 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export README_MESSAGE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__throw_error__ = __webpack_require__(38);


var README_MESSAGE = '\n  See the README for more information:\n  https://github.com/FormidableLabs/redux-little-router#wiring-up-the-boilerplate\n';

/* harmony default export */ __webpack_exports__["a"] = (function (routes) {
  if (!routes) {
    Object(__WEBPACK_IMPORTED_MODULE_0__throw_error__["a" /* default */])('\n      Missing route configuration. You must define your routes as\n      an object where the keys are routes and the values are any\n      route-specific data.\n\n      ' + README_MESSAGE + '\n    ')();
  }

  // eslint-disable-next-line no-magic-numbers
  if (!Object.keys(routes).every(function (route) {
    return route.indexOf('/') === 0;
  })) {
    Object(__WEBPACK_IMPORTED_MODULE_0__throw_error__["a" /* default */])('\n      The route configuration you provided is malformed. Make sure\n      that all of your routes start with a slash.\n\n      ' + README_MESSAGE + '\n    ')();
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createHashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var createHashRouter = function createHashRouter(installer) {
  return function (_ref) {
    var routes = _ref.routes,
        basename = _ref.basename,
        _ref$hashType = _ref.hashType,
        hashType = _ref$hashType === undefined ? 'slash' : _ref$hashType,
        historyOptions = _ref.historyOptions,
        _ref$history = _ref.history,
        history = _ref$history === undefined ? __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory___default()(_extends({ basename: basename, hashType: hashType }, historyOptions)) : _ref$history;

    var descriptor = basename ? _extends({ basename: basename }, history.location) : history.location;

    var location = Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])(descriptor);

    return installer({ routes: routes, history: history, location: location });
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashRouter(__WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */]));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(20);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(21);

var _PathUtils = __webpack_require__(11);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createExpressRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__(15);








var locationForRequest = function locationForRequest(request) {
  var pathname = request.path,
      basename = request.baseUrl,
      query = request.query;

  var descriptor = basename ? { pathname: pathname, basename: basename, query: query } : { pathname: pathname, query: query };
  return Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])(descriptor);
};

var createExpressRouter = function createExpressRouter(installer) {
  return function (_ref) {
    var routes = _ref.routes,
        request = _ref.request,
        _ref$historyOptions = _ref.historyOptions,
        historyOptions = _ref$historyOptions === undefined ? {} : _ref$historyOptions;

    var history = __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory___default()(historyOptions);
    var location = locationForRequest(request);

    return installer({ routes: routes, history: history, location: location });
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (createExpressRouter(__WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */]));

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createHapiRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__(15);








var createHapiRouter = function createHapiRouter(installer) {
  return function (_ref) {
    var routes = _ref.routes,
        request = _ref.request,
        _ref$historyOptions = _ref.historyOptions,
        historyOptions = _ref$historyOptions === undefined ? {} : _ref$historyOptions;

    var history = __WEBPACK_IMPORTED_MODULE_0_history_createMemoryHistory___default()(historyOptions);

    var location = Object(__WEBPACK_IMPORTED_MODULE_1__util_normalize_href__["a" /* default */])({
      pathname: request.path,
      query: request.query
    });

    return installer({ routes: routes, history: history, location: location });
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHapiRouter(__WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */]));

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkWithLocation; });
/* unused harmony export PersistentQueryLink */
/* unused harmony export LinkComponent */
/* unused harmony export PersistentQueryLinkComponent */
/* unused harmony export mapDispatchToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_merge_queries__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_normalize_href__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_stringify_href__ = __webpack_require__(112);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LEFT_MOUSE_BUTTON = 0;

var isNotLeftClick = function isNotLeftClick(e) {
  return e.button && e.button !== LEFT_MOUSE_BUTTON;
};

var hasModifier = function hasModifier(e) {
  return Boolean(e.shiftKey || e.altKey || e.metaKey || e.ctrlKey);
};

var shouldIgnoreClick = function shouldIgnoreClick(_ref) {
  var e = _ref.e,
      target = _ref.target;
  return hasModifier(e) || isNotLeftClick(e) || e.defaultPrevented || target;
};

var handleClick = function handleClick(_ref2) {
  var e = _ref2.e,
      target = _ref2.target,
      href = _ref2.href,
      onClick = _ref2.onClick,
      replaceState = _ref2.replaceState,
      persistQuery = _ref2.persistQuery,
      push = _ref2.push,
      replace = _ref2.replace;

  if (onClick) {
    onClick(e);
  }

  if (shouldIgnoreClick({ e: e, target: target })) {
    return;
  }

  e.preventDefault();

  var navigate = replaceState ? replace : push;
  navigate(href, { persistQuery: persistQuery });
};

// When persisting queries, we need to merge the persisted
// query with the link's new query.
var contextifyHref = function contextifyHref(href, location, persistQuery) {
  if (!persistQuery) {
    return href;
  }

  var mergedQuery = Object(__WEBPACK_IMPORTED_MODULE_4__util_merge_queries__["a" /* default */])(location.query, href.query);

  return _extends({}, href, mergedQuery);
};

var LinkComponent = function (_Component) {
  _inherits(LinkComponent, _Component);

  function LinkComponent(props) {
    _classCallCheck(this, LinkComponent);

    return _possibleConstructorReturn(this, (LinkComponent.__proto__ || Object.getPrototypeOf(LinkComponent)).call(this, props));
  }

  _createClass(LinkComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rawHref = _props.href,
          location = _props.location,
          children = _props.children,
          onClick = _props.onClick,
          target = _props.target,
          activeProps = _props.activeProps,
          replaceState = _props.replaceState,
          persistQuery = _props.persistQuery,
          push = _props.push,
          replace = _props.replace,
          rest = _objectWithoutProperties(_props, ['href', 'location', 'children', 'onClick', 'target', 'activeProps', 'replaceState', 'persistQuery', 'push', 'replace']);

      // Ensure the href has both a search and a query when needed


      var normalizedHref = Object(__WEBPACK_IMPORTED_MODULE_5__util_normalize_href__["a" /* default */])(rawHref);
      var href = contextifyHref(normalizedHref, location, persistQuery);
      var isActive = href.pathname === location.pathname;
      var activeRest = isActive && activeProps || {};

      var clickHandler = function clickHandler(e) {
        return handleClick({
          e: e,
          target: target,
          href: href,
          onClick: onClick,
          replaceState: replaceState,
          persistQuery: persistQuery,
          push: push,
          replace: replace
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          href: Object(__WEBPACK_IMPORTED_MODULE_6__util_stringify_href__["a" /* default */])(href, location.basename),
          onClick: clickHandler,
          target: target
        }, rest, activeRest),
        children
      );
    }
  }]);

  return LinkComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var PersistentQueryLinkComponent = function (_Component2) {
  _inherits(PersistentQueryLinkComponent, _Component2);

  function PersistentQueryLinkComponent() {
    _classCallCheck(this, PersistentQueryLinkComponent);

    return _possibleConstructorReturn(this, (PersistentQueryLinkComponent.__proto__ || Object.getPrototypeOf(PersistentQueryLinkComponent)).apply(this, arguments));
  }

  _createClass(PersistentQueryLinkComponent, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          rest = _objectWithoutProperties(_props2, ['children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        LinkComponent,
        _extends({}, rest, { persistQuery: true }),
        children
      );
    }
  }]);

  return PersistentQueryLinkComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PersistentQueryLinkComponent.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

var mapStateToProps = function mapStateToProps(state) {
  return { location: state.router };
};
var mapDispatchToProps = {
  push: __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* push */],
  replace: __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* replace */]
};
var withLocation = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps);

var LinkWithLocation = withLocation(LinkComponent);
var PersistentQueryLinkWithLocation = withLocation(PersistentQueryLinkComponent);



/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(24);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(17);
var invariant = __webpack_require__(16);
var ReactPropTypesSecret = __webpack_require__(94);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(43);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(107);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(104);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(102);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(45);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(106);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(43);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(44);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(111);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(24);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (href, basename) {
  if (typeof href === 'string') {
    return '' + (basename || '') + href;
  }

  var pathname = href.pathname,
      search = href.search;

  return '' + (basename || '') + pathname + (search || '');
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FragmentComponent */
/* unused harmony export withIdAndContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_getContext__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_getContext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_getContext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withContext__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withContext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_withContext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_pattern__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_pattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url_pattern__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_match_cache__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_generate_id__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_throw_error__ = __webpack_require__(38);



/* eslint-disable react/sort-comp */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withId = function withId(ComposedComponent) {
  return function (_Component) {
    _inherits(WithId, _Component);

    function WithId() {
      _classCallCheck(this, WithId);

      var _this = _possibleConstructorReturn(this, (WithId.__proto__ || Object.getPrototypeOf(WithId)).call(this));

      _this.id = Object(__WEBPACK_IMPORTED_MODULE_8__util_generate_id__["a" /* default */])();
      return _this;
    }

    _createClass(WithId, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ComposedComponent, _extends({}, this.props, { id: this.id }));
      }
    }]);

    return WithId;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);
};

var resolveChildRoute = function resolveChildRoute(parentRoute, currentRoute) {
  var parentIsRootRoute = parentRoute && parentRoute !== '/' && parentRoute !== currentRoute;

  return parentIsRootRoute ? '' + parentRoute + (currentRoute || '') : currentRoute;
};

var resolveCurrentRoute = function resolveCurrentRoute(parentRoute, currentRoute) {
  if (!currentRoute) {
    return null;
  }

  // First route will always be a wildcard
  if (!parentRoute) {
    return currentRoute + '*';
  }

  var currentIsRootRoute = currentRoute === '/';
  var parentIsRootRoute = parentRoute === '/';

  // Only prefix non-root parent routes
  var routePrefix = !parentIsRootRoute && parentRoute || '';

  // Support "index" routes:
  // <Fragment forRoute='/home'>
  //   <Fragment forRoute='/'>
  //   </Fragment>
  // </Fragment>
  var routeSuffix = currentIsRootRoute && !parentIsRootRoute ? '' : currentRoute;

  var wildcard = currentIsRootRoute && parentIsRootRoute ? '' : '*';

  return '' + routePrefix + routeSuffix + wildcard;
};

var shouldShowFragment = function shouldShowFragment(_ref) {
  var forRoute = _ref.forRoute,
      withConditions = _ref.withConditions,
      matcher = _ref.matcher,
      location = _ref.location;

  if (!forRoute) {
    return withConditions && withConditions(location);
  }

  var matchesRoute = matcher && matcher.match(location.pathname);

  return withConditions ? matchesRoute && withConditions(location) : matchesRoute;
};

var FragmentComponent = function (_Component2) {
  _inherits(FragmentComponent, _Component2);

  function FragmentComponent(props) {
    _classCallCheck(this, FragmentComponent);

    var _this2 = _possibleConstructorReturn(this, (FragmentComponent.__proto__ || Object.getPrototypeOf(FragmentComponent)).call(this, props));

    var currentRoute = resolveCurrentRoute(props.parentRoute, props.forRoute);

    _this2.matcher = currentRoute && new __WEBPACK_IMPORTED_MODULE_3_url_pattern___default.a(currentRoute) || null;
    return _this2;
  }

  _createClass(FragmentComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.forRoute !== nextProps.forRoute) {
        Object(__WEBPACK_IMPORTED_MODULE_9__util_throw_error__["a" /* default */])('Updating route props is not yet supported')();
      }

      // When Fragment rerenders, matchCache can get out of sync.
      // Blow it away at the root Fragment on every render.
      if (!this.props.parentId) {
        __WEBPACK_IMPORTED_MODULE_7__util_match_cache__["a" /* default */].clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var matcher = this.matcher;
      var _props = this.props,
          children = _props.children,
          forRoute = _props.forRoute,
          withConditions = _props.withConditions,
          forNoMatch = _props.forNoMatch,
          location = _props.location,
          parentRoute = _props.parentRoute,
          parentId = _props.parentId;


      var shouldShow = shouldShowFragment({
        forRoute: forRoute,
        withConditions: withConditions,
        matcher: matcher,
        location: location
      });

      if (!shouldShow && !forNoMatch) {
        return null;
      }

      var currentRoute = resolveCurrentRoute(parentRoute, forRoute);

      if (parentId) {
        var previousMatch = __WEBPACK_IMPORTED_MODULE_7__util_match_cache__["a" /* default */].get(parentId);
        if (previousMatch && previousMatch !== currentRoute) {
          return null;
        } else {
          __WEBPACK_IMPORTED_MODULE_7__util_match_cache__["a" /* default */].add(parentId, currentRoute);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(children);
    }
  }]);

  return FragmentComponent;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

var withIdAndContext = __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_0_recompose_getContext___default()({
  parentRoute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  parentId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
}), withId, __WEBPACK_IMPORTED_MODULE_1_recompose_withContext___default()({
  parentRoute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  parentId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
}, function (props) {
  return {
    parentRoute: resolveChildRoute(props.parentRoute, props.forRoute),
    parentId: props.id
  };
}));

var mapStateToProps = function mapStateToProps(state) {
  return {
    location: state.router
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps), withIdAndContext)(FragmentComponent));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(46);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(47);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

exports.default = getContext;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(46);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(47);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var WithContext = function (_Component) {
      _inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(_react.Component);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

exports.default = withContext;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Returns a psuedo-unique identifier used by fragments
 * to track match status within MatchCache.
 * @returns {String} id
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var radix = 16;
  var length = 8;
  return (Math.random() * Date.now()).toString(radix).slice(0, length);
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_siteWrap__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_siteWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_siteWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Header__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Content__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Footer__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Page__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_scss__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_siteWrap__["SiteWrap"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_common_Page__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_Content__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_Footer__["a" /* default */],null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SiteWrap = __webpack_require__(124);

Object.defineProperty(exports, 'SiteWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SiteWrap).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SiteWrap = function SiteWrap(_ref) {
  var padded = _ref.padded,
      className = _ref.className,
      children = _ref.children,
      large = _ref.large,
      squash = _ref.squash,
      rest = _objectWithoutProperties(_ref, ['padded', 'className', 'children', 'large', 'squash']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classnames2.default)('ln-o-site-wrap', 'ln-o-clearfix', className, {
        'ln-o-site-wrap--padding': padded,
        'ln-o-site-wrap--large': large,
        'ln-o-site-wrap--squash': squash
      })
    }),
    children
  );
};

SiteWrap.propTypes = {
  padded: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  large: _propTypes2.default.bool,
  squash: _propTypes2.default.bool
};

SiteWrap.defaultProps = {
  padded: false,
  large: false,
  squash: false,
  className: undefined
};

exports.default = SiteWrap;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HeaderMenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumbs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_Header_scss__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_Header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scss_Header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Hero__ = __webpack_require__(130);
var HeaderMenuItem=function HeaderMenuItem(_ref){var text=_ref.text,link=_ref.link;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_little_router__["b" /* Link */],{className:"nav_link",href:link},text));};var Header=function Header(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"header__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react__["b" /* SiteWrap */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"top_bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"menu_toggle",id:"menu_toggle",type:"checkbox"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"menu_toggle",className:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_little_router__["b" /* Link */],{href:"/",className:"logo"},"Privacy Hub Home"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav"},__WEBPACK_IMPORTED_MODULE_3__config__["sections"].map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMenuItem,{key:item.link,link:item.link,text:item.text});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bottom_bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Breadcrumbs__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Hero__["a" /* default */],{image:null})));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumbs__ = __webpack_require__(127);
var mapStateToProps=function mapStateToProps(_ref){var _ref$breadcrumbs=_ref.breadcrumbs,breadcrumbs=_ref$breadcrumbs===undefined?{}:_ref$breadcrumbs;var _breadcrumbs$items=breadcrumbs.items,items=_breadcrumbs$items===undefined?[]:_breadcrumbs$items;return{items:items};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__Breadcrumbs__["a" /* default */]));

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Breadcrumbs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_icons_ArrowRight__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_icons_ArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_icons_ArrowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_little_router__ = __webpack_require__(4);
var Breadcrumbs=function Breadcrumbs(_ref){var items=_ref.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"breadcrumb__wrapper"},items.map(function(_ref2,index){var text=_ref2.text,link=_ref2.link;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"breadcrumb_item",key:index},link?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_little_router__["b" /* Link */],{href:link,className:"breadcrumb_text"},text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"breadcrumb_text"},text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_icons_ArrowRight___default.a,{className:"breadcrumb_arrow"}));}));};/* harmony default export */ __webpack_exports__["a"] = (Breadcrumbs);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
var Hero=function Hero(_ref){var _ref$className=_ref.className,className=_ref$className===undefined?"":_ref$className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero__wrapper "+className});};var mapStateToProps=function mapStateToProps(_ref2){var _ref2$router=_ref2.router,router=_ref2$router===undefined?{}:_ref2$router;var _router$result=router.result,result=_router$result===undefined?{}:_router$result;var _result$className=result.className,className=_result$className===undefined?"home":_result$className;return{className:className};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Hero));

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_PrivacyPolicy__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_CookiePolicy__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_FAQ__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_DataSafe__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_YourRights__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_DataGlance__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotFound__ = __webpack_require__(223);
//Pages
var Content=function Content(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/how-to-keep-your-data-safe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_DataSafe__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/privacy-policy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pages_PrivacyPolicy__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/cookie-policy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pages_CookiePolicy__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/faq"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_FAQ__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/your-rights"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_YourRights__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/your-data-at-a-glance"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_DataGlance__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forRoute:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["a" /* Fragment */],{forNoMatch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NotFound__["a" /* default */],null)))));};/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_button__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SectionCard__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_Home_scss__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_Home_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scss_Home_scss__);
var Home=function Home(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__["Card"],{className:"home__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"center-text"},"Sainsbury's Group Privacy Hub"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"The Privacy Hub"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Welcome to the Privacy Hub \u2014 home to everything you need to know about your data and how we keep it safe. Find out how we collect your personal data and what rights you have over it too."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Wrapper,{verticalAlign:"middle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brands__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Wrapper,{horizontalAlign:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--sainsburys"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--argos"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--habitat"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--tu"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--sainsburys_bank"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:{sm:"1/3",md:"1/6",xs:"1/2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--nectar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"center-text"},"View Sainsbury\u2019s Bank information"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"},"here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"center-text"},"View Nectar\u2019s information"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.nectar.com/about/privacy-and-legal"},"here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"center-text"},"View Facial Recognition Technology privacy information"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/privacy-policy/#facial-recognition-technology"},"here")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{className:"marketing_permissions__wrapper",size:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{className:"marketing_permissions_text center-text",size:{sm:"3/5"}},"Manage your marketing permissions across Sainsbury's Group"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{className:"marketing_permissions_button center-text",size:{sm:"2/5"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:__WEBPACK_IMPORTED_MODULE_4__config__["marketingPermissionsUrl"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_button__["PrimaryButton"],null,"Manage Group marketing permissions")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Wrapper,{className:"section__wrapper",matrix:true,horizontalAlign:"center"},__WEBPACK_IMPORTED_MODULE_4__config__["sections"].map(function(section,item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{key:item,size:{sm:"1/2",md:"1/3"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_SectionCard__["a" /* default */],{section:section,className:"section_card"}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_grid__["Grid"].Item,{size:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"How to contact us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you have a data related query or complaint, you can contact us through the following methods"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Email:")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Letter:")," Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Telephone:")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:0800636262"},"0800 63 62 62")))));};/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Card = function Card(_ref) {
  var className = _ref.className,
      padded = _ref.padded,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['className', 'padded', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classnames2.default)('ln-c-card', className, {
        'ln-c-card--soft': padded
      })
    }),
    children
  );
};

Card.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  padded: _propTypes2.default.bool
};

Card.defaultProps = {
  className: undefined,
  padded: true
};

exports.default = Card;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Button = __webpack_require__(9);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _PrimaryButton = __webpack_require__(51);

Object.defineProperty(exports, 'PrimaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryButton).default;
  }
});

var _SecondaryButton = __webpack_require__(135);

Object.defineProperty(exports, 'SecondaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SecondaryButton).default;
  }
});

var _TextButton = __webpack_require__(136);

Object.defineProperty(exports, 'TextButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextButton).default;
  }
});

var _CancelButton = __webpack_require__(52);

Object.defineProperty(exports, 'CancelButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CancelButton).default;
  }
});

var _CloseButton = __webpack_require__(137);

Object.defineProperty(exports, 'CloseButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloseButton).default;
  }
});

var _SearchButton = __webpack_require__(138);

Object.defineProperty(exports, 'SearchButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(9);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondaryButton = function SecondaryButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({}, props, {
      className: (0, _classnames2.default)('ln-c-button--secondary', props.className)
    }),
    props.children
  );
};

SecondaryButton.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};

SecondaryButton.defaultProps = {
  className: undefined
};

exports.default = SecondaryButton;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(9);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextButton = function TextButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({}, props, {
      className: (0, _classnames2.default)('ln-c-button--text-only', props.className)
    }),
    props.children
  );
};

TextButton.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};

TextButton.defaultProps = {
  className: undefined
};

exports.default = TextButton;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CancelButton = __webpack_require__(52);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ['className', 'onClick', 'title']);

  return _react2.default.createElement(_CancelButton2.default, _extends({}, rest, {
    className: (0, _classnames2.default)(className, 'ln-c-dismiss'),
    onClick: onClick,
    title: title
  }));
};

CloseButton.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string
};

CloseButton.defaultProps = {
  className: undefined,
  title: 'Close'
};

exports.default = CloseButton;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Search = __webpack_require__(54);

var _Search2 = _interopRequireDefault(_Search);

var _Button = __webpack_require__(9);

var _Button2 = _interopRequireDefault(_Button);

var _PrimaryButton = __webpack_require__(51);

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SearchButton = function SearchButton(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      inputAction = _ref.inputAction,
      rest = _objectWithoutProperties(_ref, ['icon', 'text', 'inputAction']);

  var ButtonElement = inputAction ? _Button2.default : _PrimaryButton2.default;

  return _react2.default.createElement(
    ButtonElement,
    _extends({ type: 'submit', className: 'ln-u-hard-ends' }, rest),
    icon,
    _react2.default.createElement(
      'span',
      { className: 'ln-u-visually-hidden' },
      text
    )
  );
};

SearchButton.propTypes = {
  icon: _propTypes2.default.node,
  text: _propTypes2.default.string,
  inputAction: _propTypes2.default.bool
};

SearchButton.defaultProps = {
  icon: _react2.default.createElement(_Search2.default, null),
  text: 'Search',
  inputAction: false
};

exports.default = SearchButton;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var GridWrapper = function GridWrapper(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      matrix = _ref.matrix,
      reverse = _ref.reverse,
      equalHeight = _ref.equalHeight,
      gutterSize = _ref.gutterSize,
      verticalAlign = _ref.verticalAlign,
      horizontalAlign = _ref.horizontalAlign,
      element = _ref.element,
      rest = _objectWithoutProperties(_ref, ['className', 'children', 'matrix', 'reverse', 'equalHeight', 'gutterSize', 'verticalAlign', 'horizontalAlign', 'element']);

  var Element = element;
  return _react2.default.createElement(
    Element,
    _extends({}, rest, {
      className: (0, _classnames3.default)(className, 'ln-o-grid', (_classnames = {
        'ln-o-grid--matrix': matrix,
        'ln-o-grid--reverse': reverse,
        'ln-o-grid--equal-height': equalHeight
      }, _classnames['ln-o-grid--gutter-' + gutterSize] = gutterSize, _classnames['ln-o-grid--' + verticalAlign] = verticalAlign, _classnames['ln-u-text-align-' + horizontalAlign] = horizontalAlign, _classnames))
    }),
    children
  );
};

GridWrapper.displayName = 'Grid.Wrapper';

GridWrapper.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  matrix: _propTypes2.default.bool,
  gutterSize: _propTypes2.default.string,
  reverse: _propTypes2.default.bool,
  equalHeight: _propTypes2.default.bool,
  verticalAlign: _propTypes2.default.oneOf(['middle', 'bottom']),
  horizontalAlign: _propTypes2.default.oneOf(['center', 'right']),
  element: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string])
};

GridWrapper.defaultProps = {
  className: undefined,
  matrix: false,
  gutterSize: undefined,
  reverse: false,
  equalHeight: false,
  verticalAlign: undefined,
  horizontalAlign: undefined,
  element: 'div'
};

exports.default = GridWrapper;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var GridItem = function GridItem(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      offsetLeft = _ref.offsetLeft,
      offsetRight = _ref.offsetRight,
      element = _ref.element,
      rest = _objectWithoutProperties(_ref, ['className', 'children', 'size', 'offsetLeft', 'offsetRight', 'element']);

  var Element = element;
  var sizeClass = (typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object' ? Object.keys(size).map(function (breakpoint) {
    return breakpoint !== 'default' ? 'ln-u-' + size[breakpoint] + '@' + breakpoint : 'ln-u-' + size[breakpoint];
  }) : 'ln-u-' + size;

  return _react2.default.createElement(
    Element,
    _extends({}, rest, {
      className: (0, _classnames3.default)(className, 'ln-o-grid__item', sizeClass, (_classnames = {}, _classnames['ln-u-pull-' + offsetLeft] = offsetLeft, _classnames['ln-u-push-' + offsetRight] = offsetRight, _classnames))
    }),
    children
  );
};

GridItem.displayName = 'Grid.Item';

GridItem.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  offsetLeft: _propTypes2.default.string,
  offsetRight: _propTypes2.default.string,
  element: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string])
};

GridItem.defaultProps = {
  className: undefined,
  offsetLeft: undefined,
  offsetRight: undefined,
  element: 'div'
};

exports.default = GridItem;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_little_router__ = __webpack_require__(4);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var _props$section=props.section,section=_props$section===undefined?{}:_props$section;var link=section.link,text=section.text,heading=section.heading,cta=section.cta,_section$className=section.className,className=_section$className===undefined?"":_section$className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__["Card"],{className:"center-text m0 p0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_image "+className}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"mt1"},heading||text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_little_router__["b" /* Link */],{className:"mb1",href:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react__["a" /* PrimaryButton */],null,cta)));});

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export policyContents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AccordionItem__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__["Card"],{className:"privacy_policy__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"Sainsbury's Group Privacy Policy"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"section_subtext"},"\xA0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We understand that your privacy and the security of your personal data is extremely important. This notice sets out what we do with your personal data, how we secure it, where we collect it from and your rights in it."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This policy applies if you interact with us. This could be in our stores, over the phone, online, via email, through our mobile applications or otherwise by using any of our websites or interacting with us on social media."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you don't want to read all the detail, here are the things we think you'd really want to know:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"The Sainsbury's Group currently includes Sainsbury's Supermarkets, Sainsbury's Bank, Argos, Tu Clothing, Habitat and Nectar."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To find out how Nectar or Sainsbury's Bank process your personal data follow these links:"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.nectar.com/about/privacy-and-legal/privacy-policy/"},"here")," ","and"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"},"here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Your personal data is, where appropriate, shared within the Sainsbury's Group."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We do use a number of third parties to process your personal data on our behalf and some of them are based outside of the United Kingdom."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"You have a number of rights over your personal data. How you can exercise these rights is set out in this notice."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We do send direct marketing, if we're allowed to. And we do this to encourage you to buy our products and services by sending you offers and ideas that we feel will be of benefit to you. If you want us to stop then see the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#keeping-you-informed"},"'Keeping you informed about our products and services'")," ","section below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We do not aim any of our products or services directly at children and we do not knowingly collect personal data of children. Some of our services and products may be age restricted and this will be shown at the point of registration or purchase."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We also use your personal data to show you online advertising on websites across the Sainsbury's Group, on other websites and online media channels. This may be our own marketing, or marketing from selected third parties. If you want us to stop using your data for this purpose, then see"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#using-your-personal-information"},"'Digital Advertising'")," ","below.")),policyContents.map(function(_ref,index){var title=_ref.title,_ref$id=_ref.id,id=_ref$id===undefined?null:_ref$id,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_AccordionItem__["a" /* default */],{title:title},content));}));});var policyContents=[{title:"Who are we?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"When we say \"we\" or \"us\" in this policy, we are referring to the retail companies that form part of the Sainsbury's Group (all with the registered office address 33 Charterhouse Street, London, England, EC1M 6HA). This privacy policy governs the manner in which Sainsbury's Supermarkets Ltd, Argos Limited and Habitat Retail Limited each processes personal data collected from our customers, prospective customers and/or other individuals who interact with us (together \"you\" or \"your\"). To find out how Nectar and Sainsbury's Bank process your personal data you can read their privacy notices which can be found"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.nectar.com/about/privacy-and-legal/privacy-policy/"},"here")," ","and"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"},"here"),"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For the purposes of data protection law, the \"data controller\" (which means the entity which determines the purposes and means of any processing of your personal data) may be any member of the Sainsbury's Group depending on your interactions."))},{title:"What sorts of personal data do we process?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"\n          .personal-data-table { border-collapse: collapse; }\n          .personal-data-table th,\n          .personal-data-table td { padding: 8px; }\n        "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Personal data means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (e.g. anonymous data). We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{border:"1",className:"personal-data-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Category of Data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Examples"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Account data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"This is personal data such as your name, home address, date of birth, email, telephone number, Nectar card number and payment card details.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Transaction data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Information about the goods and services that you buy from us (including for example, what they were, when and where you bought them and how much you paid).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Analytics data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"This is personal data regarding how you interact with us. It includes which offers you engage with, how you interact with and experience our websites and apps, predictions about your interests, shopping habits and characteristics (we call these \"profiled characteristics\").")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Interaction data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"This is the contents of chats, calls and correspondence with our Contact Centre or with chatbots on our websites, and any associated data. Details of the emails and other electronic communications you receive from us, and how you interact with them. For example, whether the communication has been opened, if you have clicked on any links within that communication and the device you used.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Third party data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"This is personal data provided by companies that provide customer information or that is publicly available (e.g. Experian, CACI, Royal Mail). These might be companies that help us verify or update your address, or companies that provide us with information on your modelled household profile. This could be received at an individual or an anonymous level such as information based on your post code.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"CCTV data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Information captured by our CCTV, automatic number plate recognition (ANPR) and body worn recording devices (together \"CCTV\") if you visit any of our premises. It also includes alerts we receive from FRT systems where applicable.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Device data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"This is information from devices you use to access our services, our websites and apps, received via cookies and other similar technologies such as pixels. This could be information such as IP addresses, MAC addresses, unique IDs like advertising IDs, location data, information about your browser, or details contained in URLs used in our communications (e.g. offer links in emails).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Preference Data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Information about whether or not you want to receive marketing and information about your preferences and opinions that you have expressed through surveys, product reviews or within your account.")))))},{title:"Our legal basis for processing your personal data",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Whenever we process your personal data we need something called a \"legal basis\" for what we do. The different legal bases we rely on are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Consent:")," You have told us you are happy for us to process your personal information for a specific purpose (s);"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legitimate interests:")," The processing is necessary for us to conduct our business, but not where our interests are overridden by your interests or rights."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Performance of a contract:")," We must process your personal information in order to be able to provide you with one of our products or services;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Vital interests:")," The processing of your personal information is necessary to protect you or someone else's life;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal obligation:")," We are required to process your personal information by law.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In the limited circumstances that we process any"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\"special category personal data\""),", in addition to one of the legal bases noted above, we also need to ensure that we have a further legal basis for such processing. This will most commonly be one of the following:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Explicit Consent"),": where you have given us your explicit consent to the processing;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Vital Interests:")," the processing is necessary to protect your vital interests or those of another natural person where you are physically or legally incapable of giving consent;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Made public by the data subject:")," processing relates to personal information that you have made public;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal claims and judicial acts"),": the processing is necessary for the establishment, exercise or defence of legal claims; or"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Substantial public interest:")," the processing is necessary for reasons of substantial public interest (e.g. regulatory requirements, preventing or detecting unlawful acts).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"When we refer to ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\"special category personal data\"")," we mean personal data that reveals racial or ethnic origin, political opinions, religious beliefs, philosophical beliefs or trade union membership, genetic data, biometric data (where used for identification purposes), data concerning health, sex life or sexual orientation of an individual."))},{title:"How we use your personal information and our legal basis for doing so",id:"using-your-personal-information",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We may process your personal data in the following ways:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{border:"1",style:{borderCollapse:"collapse",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose of processing, legal basis for processing and personal data types processed")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," To provide our products and services",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We need to use your personal data to make our products and services available to you. This processing may include using your personal data to: deliver products to you; verify your identity and eligibility for products; take payments from you; and ensure you are awarded your Nectar points.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal bases:")," Performance of a contract; Legitimate interests",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Performance of a contract - we process your personal data if we have a contract with you and we have to use your data as a necessary part of that contract. Legitimate interest - once you've purchased a product or stopped receiving a service from us, we keep your data for a period of time afterwards as part of our legitimate interests. For example, your information might be needed to deal with a complaint or a product recall.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," To improve your shopping experience",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We try to understand our customers so we can provide you with a great shopping experience. Understanding how customers use our stores, websites and apps, how they interact with the Sainsbury's Group, where and when they shop and the products and services they buy helps us to do this.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal basis:")," Legitimate interest",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"This processing helps us to serve you better and to improve our service offerings.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Interaction Data; Third Party Data; Device Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Analytics and profiling",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We use your personal data for statistical analysis and to help us understand more about our customers. This includes understanding the products and services you buy, how you shop across the whole Sainsbury's Group, creating profiles about you and grouping you together with other Sainsbury's customers who have similar interests or preferences as you. This helps us to serve you better and to find ways to improve our services, stores, apps, and websites. These profiles also help us to send you offers that are more relevant to you and present you with marketing and digital advertising that is more tailored to your interests and preferences and to help our digital marketing platform partners to try to identify other individuals who share similar preferences. This may include using cookies and similar technologies on our website and apps. For more information, please see the Cookie and Digital Advertising policy available on each of our websites.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal bases:")," Legitimate interest; Consent",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Legitimate interest: This processing helps us to serve you better and to find ways to improve our services, apps and websites. These profiles help us to send you offers that are more relevant to you. Consent: We gather consent to send marketing. You can change your mind at any time.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Interaction Data; Third Party Data; Device Data, Preference Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Safety, security and fraud prevention",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We use your personal data to help provide safe and secure environments for our customers to shop in, our colleagues to work in and for our businesses to be conducted. This processing could also include the tracing and recovering debts. To enable this, we monitor behaviour instore and online and carry out checks to help us ensure that our customers are genuine. We do this to prevent fraud and to help customers use our services appropriately.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal bases:")," Legitimate interests; Legal obligation; Substantial public interest",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Legitimate interest: To keep our premises and offices secure and to protect our commercial interests and confidential information. Legal obligation: We have certain legal obligations to protect our customers and staff. Substantial public interest: If we process any special category data for these purposes our condition for processing this data is that it's necessary for reasons of substantial public interest, namely the prevention or detection of unlawful acts.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Interaction Data; Third Party Data; Device Data, CCTV Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Contacting you",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We use your personal data to contact you. This may be in relation to a service update, an issue you have raised with us, to conduct market research, to ask for your feedback or to send you an e-receipt.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal bases:")," Legitimate interest; Performance of a contract, Consent",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Performance of a Contract: We may contact you to ensure that we comply with the terms of our contract with you (e.g. if we update any contract terms so as to notify you of what has changed) or to send you your receipt if you shop online. Legitimate interest: We may contact you to conduct activities (e.g. obtain feedback on our performance) to support us in improving our products and/or services and to support the training of our employees. Consent: If you ask us to contact you or send you something (such as an e-receipt instore or to be contacted when a product is back in stock)",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Interaction Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Digital advertising",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"When you browse our websites and apps, or certain other websites, apps, or social media platforms, or when you are using certain services on Connected TVs, you may see advertising that is tailored to you. This may be informed by our use of your personal data as explained in the \"Analytics and profiling\" section above. These adverts may be presented to you by us, or by selected third parties that we think you might want to hear from. We also check how you and our other shoppers engage with these types of advertisement (for example, if you click on them, or subsequently make a purchase with us), so we can determine whether to show you more or fewer similar advertisements in future. More information about this is set out in our Cookie and Digital Advertising notice and banner. Importantly, we know that not everyone wants to see the kind of advertising described above, so you can always say no when presented with the Cookie and Digital Advertising banner or by managing your \"cookie\" preferences through our websites and apps by selecting \"required only\".",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal basis:")," Consent",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We gather this consent when presenting you with a banner when you visit our websites and apps. You can opt out at any time.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Third Party Data; Device Data, Preference Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Create data models",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We take personal data and analyse it to look for patterns, trends and characteristics that align with a particular outcome \u2013 for example, items that are often purchased together. We use this analysis to create a framework that maps out these patterns, trends and characteristics on an anonymous basis - we call these frameworks \"data models\" and the process of making them \"data modelling\".",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal basis:")," Legitimate interest",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Analytics Data; Interaction Data; Third Party Data; Device Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Customer service",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"We record or keep a record of most communications between us. This could be in the form of call recordings, transcripts of calls, emails or web chat conversations. We do this to provide a great service to our customers, to develop our business, to prevent fraud, for colleague training, and if something has gone wrong to manage customer issues.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal basis:")," Legitimate interest",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Call recordings, web chat transcripts and other records of communication help us to provide good customer service, train our colleagues and deal with issues that arise.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," Account Data; Transaction Data; Interaction Data.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Purpose:")," Resolving legal claims and disputes",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Occasionally we need to process your personal data to resolve a dispute or a claim and depending on the nature of the dispute it could involve processing any of the personal data types listed above.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Legal basis:")," Legitimate interest; Substantial public interest",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"To fairly resolve disputes and claims that arise from time to time. Substantial public interest: If we process any special category data for this purpose our condition for processing this data is that it's necessary for reasons of substantial public interest, namely the prevention or detection of unlawful acts.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Data types:")," All data types."))))))},{title:"Keeping you informed about our products and services",id:"keeping-you-informed",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We would like to tell you about great offers, ideas, products and services from the Sainsbury's Group and our suppliers that we think you might be interested in. Where we have consent or it is in our legitimate interests to do so, we may do this through the post, by email, text message or phone."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We won't send you marketing messages if you tell us not to, but if you receive a service from us we will still need to send you occasional service-related messages and may still send you emails requesting feedback or surveys (you can always opt out of these via the survey email itself). If you wish to amend your marketing preferences, you can do so by logging into any of your Sainsbury's Group accounts and following the directions, or by logging into our"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://permissions.sainsburys.co.uk/"},"Customer Preference Centre"),"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please note that it can take a little while for all marketing to stop once you either withdraw your consent or tell us you'd like to opt out of marketing. This is because some marketing may have been identified as relevant to your interests and may already be in transit, it cannot therefore be immediately stopped."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you don't want to receive coupons at till in Sainsbury's based on your shopping then let us know by emailing"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk"),". You might still receive coupons but they won't be based on information we have about you."))},{title:"CCTV",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use CCTV across all sites in the Sainsbury's Group for the protection of our colleagues, customers and business. This includes investigating accidents, incidents, criminal activities, and breaches of our policies. CCTV is also in operation in our petrol stations and car parks for these purposes. Some car parks are run by third parties, so please check the local notice. We also use CCTV for the purpose of operational efficiency, such as monitoring the availability of products on our shelves."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Some of our colleagues also wear body worn devices to protect themselves and our customers. These are only activated in high-risk situations such as when there is a threat of violence. Body worn devices record both audio and video."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Occasionally we are asked to share CCTV with the Police or other public or regulatory authorities or individuals or businesses seeking to protect their rights or the rights of others. We only share CCTV if we consider a request to be appropriate and lawful pursuant to the requirements of data protection legislation."))},{title:"Facial Recognition Technology",id:"facial-recognition-technology",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We have implemented FRT in a number of stores for the purposes of protecting our colleagues from harm and aggression, to provide a secure shopping environment for our customers and to prevent and deter criminal activity within our stores. FRT in our stores is provided by Facewatch, you can access their privacy policy"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.facewatch.co.uk/privacy/"},"here"),". As Facewatch is directly collecting and using the images captured by the technology, they act as independent controllers and are the data controller responsible for the processing of personal data by way of facial recognition. We supply details (including CCTV images) of people responsible for unlawful acts within our premises to Facewatch which they, following further checks, may add to a list of subjects of interest. We do not have access to that list of subjects of interest but receive alerts when they enter our stores. Other retailers who use Facewatch FRT also supply details which may be added by Facewatch to the list of subjects of interest. We display clear signage in all stores where facial recognition technology is used."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you have any questions or concerns about our use of this technology, please do not hesitate to contact us by emailing"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk"),". If you would like to get in touch with Facewatch directly you can contact them at"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:dpo@facewatch.co.uk"},"dpo@facewatch.co.uk")))},{title:"Who might we share your personal information with?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We may share your personal information with the following third parties as part of the purposes set out in \"How do we use your personal information?\" above:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"The Sainsbury's Group")," - we may share your personal information with the other companies within the Sainsbury's Group so that we can provide you with a high quality, personalised and tailored service (including relevant marketing) across the Sainsbury's Group and for the purposes that are set out in this privacy policy."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Companies we partner with")," - we work with different companies so that we can provide products and services you require from us or we think you might be interested in. These third parties include:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies that provide insights and analytics services so we can stock the right products, send the relevant marketing campaigns and understand our business and customers better;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Advertising companies, partners and suppliers, or digital media platform partners like Meta, Tiktok, X and Google, who help us target Sainsbury's Group or selected third party partner adverts online and on other media;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Suppliers that deliver products directly to you or that need to conduct a product recall;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Market research partners, who help us to collect and analyse customer behaviour;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies that deploy our marketing campaigns because they need some information to carry out these services;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"NewDay, the company who provide Argos Pay, so they can understand how you use their product and provide more relevant marketing where you have consented. The Argos Pay privacy policy can be found"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://urldefense.com/v3/__https:/portal.newdaycards.com/argospay/privacy-policy__;!!BQ_wX6TuWITc6hG5HA!UMsfNJIkw75fXnmd3sPYhT5dnhV6-f9Hwq_L3llw6o69eX-eet2Zyhy0qNiohOGNJOVd-tNdVDHir1J5y3CjIe6UdRIyf95hcwrctDm1$"},"here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Scheme providers and companies who provide payment solutions who process your information as controllers and processors \u2013 such as Visa, Mastercard and Checkout \u2013in order to manage your account and for your payments to be processed;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Our agents, advisers or others involved in running accounts and services for you and your business or collecting what you or your business owe Group companies."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Third party vendors who help us manage and maintain the Sainsbury's Group IT infrastructure and provide IT security services;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies who deliver products to you that order on our websites;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Where relevant, our professional advisors, such as lawyers and consultants;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Security and fraud prevention companies to ensure the safety and security of our customers, colleagues and business;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies which run our contact centres because they need your personal information to identify and contact you;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies who assess faults and repair products on our behalf;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies who administer competitions for us so they run smoothly;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies that enable us to collect your reviews and comments, both online and offline; and"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies that help us with community and social goals.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you use the services provided by another company to interact with us, such as a virtual assistant or a social media platform, please be aware that your data is also subject to the privacy policies of these companies."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Additionally the WiFi that is available in our stores and offices is provided by a third party. If you decide to use this service then your data is subject to their privacy policy, details of which are provided when you sign up."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Other organisations and individuals")," - we may share your personal information in certain scenarios. For example:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If we're discussing selling or transferring part or all of a Sainsbury's Group business, we may share information about you to prospective purchasers and their advisers - but only so they can evaluate the relevant business; or"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If we are reorganised or sold to another organisation, we may transfer information we hold about you to them so they can continue to provide the Services to you."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If we are required to by law, under any code of practice by which we are bound or where we are asked to do so by a public or regulatory authority;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If we need to do so in order to exercise or protect our legal rights, users, systems and services; or"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"In response to requests from individuals (or their representatives) seeking to protect their rights or the rights of others. We will only share your personal information in response to requests which do not override your privacy interests. For example, we will not share your personal information with individuals who are merely curious about you, but we will share your personal information to e.g. insurers, solicitors, employers etc. which have a legitimate interest in your personal information.")))},{title:"International transfers of personal information",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"From time to time we transfer your personal information to our Sainsbury's Group companies, suppliers or service providers based outside of the United Kingdom for the purposes described in this privacy policy (please see the \"Who might we share your personal information with?\" section above for further details). When we do this, your personal information will continue to be subject to one or more appropriate safeguards set out in the law. These might be the use of model contracts in a form approved by regulators, or having our suppliers sign up to an independent privacy scheme approved by regulators."))},{title:"Your rights",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You have a number of rights under data protection legislation which, in certain circumstances, you may be able to exercise in relation to the personal information we process about you. These include:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right to access a copy of the personal information we hold about you;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right to correction of inaccurate personal information we hold about you;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right to restrict our use of your personal information;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right to be forgotten;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right of data portability; and"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"the right to object to our use of your personal information.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you are seeking to exercise any of these rights, please contact us using the details in the \"Contact Us\" section below. Please note that we will need to verify your identity before we can fulfil any of your rights under data protection law. This helps us to protect the personal information belonging to our customers against fraudulent requests."))},{title:"Automated decision making and profiling",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use automated decision making, including profiling, in certain circumstances, such as when it is in our legitimate interests to do so, or where we have a right to do so because it is necessary for us to enter into, and perform, a contract with you. We use profiling to enable us to give you the best service across the Sainsbury's Group, including specific marketing which we believe you will be interested in."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You have the right not to be subject to a decision based solely on automated processing, including profiling, which has legal effects for you or affects you in another significant way, unless appropriate safeguards are in place. We will put those safeguards in place which means it will be clear if these decisions are taking place, you will have a right to contest them and to have a human review the decision."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you are seeking to exercise this right, please contact us using the details in the \"Contact Us\" section below."))},{title:"How long will we keep your personal information for?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We will keep your personal information for the purposes set out in this privacy policy and in accordance with the law and only for as long as is necessary. In most cases, our retention period will come to an end 7 years after the end of your relationship with us."))},{title:"Security",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We take protecting your personal information seriously and are continuously developing our security systems and processes. Some of the controls we have in place are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We limit physical access to our buildings and user access to our systems to only those that we believe are entitled to be there;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We use technology controls for our information systems, such as firewalls, user verification, strong data encryption, and separation of roles, systems & data;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Systems are proactively monitored through a \"detect and respond\" information security function;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We utilize industry \"good practice\" standards to support the maintenance of a robust information security management system; and"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We enforce a \"need to know\" policy, for access to any data or systems.")))},{title:"Contact us",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you would like to exercise one of your rights as set out in the \"Your rights\" or \"Automated decision making and profiling\" sections above, or you have a question or a complaint about this policy, or the way your personal information is processed, please contact us by one of the following means:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"By email:",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"By post: Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 17th Floor, Arndale House, Manchester, M4 3AL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You also have the right to lodge a complaint with the UK regulator, the Information Commissioner. Please visit ico.org.uk/concerns to find out more.")))},{title:"Policy change",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This privacy policy was most recently updated in April 2026."))}];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AccordionWrapper = __webpack_require__(145);

Object.defineProperty(exports, 'Accordion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccordionWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createIds = exports.handleClick = undefined;

var _recompose = __webpack_require__(25);

var _getUniqueId = __webpack_require__(146);

var _getUniqueId2 = _interopRequireDefault(_getUniqueId);

var _Accordion = __webpack_require__(147);

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(_ref) {
  var setOpenState = _ref.setOpenState;
  return function (currentState) {
    return setOpenState(!currentState);
  };
};

var createIds = function createIds(_ref2) {
  var ids = _ref2.ids;
  return ids || {
    ids: {
      title: (0, _getUniqueId2.default)('ln-accordion-')
    }
  };
};

exports.handleClick = handleClick;
exports.createIds = createIds;
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Accordion'), (0, _recompose.withState)('open', 'setOpenState', function (_ref3) {
  var defaultOpen = _ref3.defaultOpen;
  return !!defaultOpen;
}), (0, _recompose.withHandlers)({ handleClick: handleClick }), (0, _recompose.withPropsOnChange)(function () {
  return false;
}, createIds))(_Accordion2.default);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _lodash = __webpack_require__(50);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (prefix) {
  return (0, _lodash2.default)(prefix);
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _ArrowDown = __webpack_require__(55);

var _ArrowDown2 = _interopRequireDefault(_ArrowDown);

var _filterProps = __webpack_require__(148);

var _filterProps2 = _interopRequireDefault(_filterProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      titleElement = _ref.titleElement,
      open = _ref.open,
      standalone = _ref.standalone,
      ids = _ref.ids,
      handleClick = _ref.handleClick,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'title', 'titleElement', 'open', 'standalone', 'ids', 'handleClick']);

  var Heading = titleElement;

  return _react2.default.createElement(
    'div',
    _extends({}, (0, _filterProps2.default)(rest, ['setOpenState', 'defaultOpen']), {
      className: (0, _classnames2.default)('ln-c-accordion', className, open && 'is-open', standalone && 'ln-c-accordion--standalone')
    }),
    _react2.default.createElement(
      'div',
      { className: 'ln-c-accordion__head' },
      _react2.default.createElement(
        'button',
        {
          className: 'ln-c-accordion__toggle',
          type: 'button',
          onClick: function onClick() {
            return handleClick(open);
          },
          'aria-hidden': true
        },
        _react2.default.createElement(_ArrowDown2.default, { className: 'ln-c-accordion__icon' })
      ),
      _react2.default.createElement(
        Heading,
        { className: 'ln-c-accordion__title', id: ids.title },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      {
        className: 'ln-c-accordion__body',
        role: 'region',
        'aria-labelledby': ids.title
      },
      open && children
    )
  );
};

Accordion.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  title: _propTypes2.default.node.isRequired,
  titleElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  open: _propTypes2.default.bool,
  standalone: _propTypes2.default.bool,
  ids: _propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired
  }).isRequired,
  handleClick: _propTypes2.default.func.isRequired
};

Accordion.defaultProps = {
  className: undefined,
  titleElement: 'h4',
  open: false,
  standalone: false
};

exports.default = Accordion;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayIncludes = __webpack_require__(149);

var _arrayIncludes2 = _interopRequireDefault(_arrayIncludes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, filterList) {
  return Object.keys(props).reduce(function (newProps, prop) {
    var _extends2;

    if ((0, _arrayIncludes2.default)(filterList, prop)) {
      return newProps;
    }
    return _extends({}, newProps, (_extends2 = {}, _extends2[prop] = props[prop], _extends2));
  }, {});
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (arr, searchElement) {
  if (!Array.isArray(arr)) {
    return false;
  }
  return arr.indexOf(searchElement) !== -1;
};

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export policyContents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AccordionItem__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_card__["Card"],{className:"cookie_policy__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"Our Cookie Policy"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"section_subtext"},"\xA0")),policyContents.map(function(_ref,index){var title=_ref.title,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_AccordionItem__["a" /* default */],{key:index,title:title},content);}));});var policyContents=[{title:"What are Cookies?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use the term Cookie to describe cookies and similar technologies such as tags and pixels. Cookies are small data files that websites place on your computer, laptop or mobile device.")},{title:"What do we use cookies and similar technologies for?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To improve the performance of our websites by understanding which parts work well, and which don't."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To enable us to collect information about how you and other people use our websites."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To improve your experience on our websites, for example we use Cookies to remember the products you've put in your basket and to personalise your experience; and"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To deliver relevant online advertising to you both on our websites and elsewhere. This is sometimes done by combining data that we already have about you with the data collected through Cookies. These Cookies are placed by us and selected third parties and enable adverts to be presented to you on our and third party websites."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To measure how effective our online advertising and marketing communications are.")))},{title:"What is Digital Advertising?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"When we say Digital Advertising we are referring to the adverts that you are shown while you are browsing our websites and other sites on the internet. They are set by us or by carefully selected third parties.")},{title:"What types of Cookies do we use?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use the following Cookies:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Strictly Necessary Cookies.")," These are Cookies that are required for the operation of our website. They are necessary for the safety, security and integrity of the site. For example they help support the structure of the pages that are displayed to you, help to improve navigation and allow you to return to pages you have previously visited. This type of Cookie only lasts for the duration of the time you are visiting the website. When you leave the website they are deleted automatically."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Performance and analytical Cookies.")," They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily. The data is aggregated and anonymised, which means we cannot identify you as an individual."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Functionality Cookies.")," These are used to recognise you when you return to our website. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region). These Cookies will remain on your device until you choose to clear it. If you choose to do this, you will need to enter your details each time you visit the site."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Digital Advertising Cookies.")," These Cookies will collect information about your browsing habits and allow us to show you adverts while you are browsing our site and other sites on the internet. We use these Cookies and personal data, including transaction data, to help give you the best experience on our site and to allow us and third parties to customise and measure the effectiveness of the marketing content you see across websites, apps and elsewhere, including social media. This may involve some limited sharing of personal data with third parties.")))},{title:"How to decline Cookies and say no to your personal data being used for Digital Advertising",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You can decline Cookies and stop your data being used for Digital Advertising by saying 'No' when presented with the banner at the start of your journey. And you can manage your preferences at any time by selecting Manage Cookies or Cookie Preferences on our websites."," "))},{title:"Contact us",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you have a question about this policy please contact us by one of the following means:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"By email:"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"By post: Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You also have the right to lodge a complaint with the UK regulator, the Information Commissioner. Go to ico.org.uk/concerns to find out more.")))},{title:"Policy change",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This cookie policy was most recently updated in January 2025. If we make changes to it, then we will take appropriate steps to bring those changes to your attention."))}];

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export faqContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AccordionItem__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__["Card"],{className:"faq__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"FAQ"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"section_subtext"},"Click on one of the most frequently asked, data related, questions below")),faqContent.map(function(_ref,index){var title=_ref.title,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_AccordionItem__["a" /* default */],{key:index,title:title},content);}));});var faqContent=[{title:"Can I access the personal data you hold about me?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, you can ask us for a copy of the personal data we hold about you. Please send your request to"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")," ","or write to the Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Before we send you a copy of your personal data or carry out a request, we\u2019ll need to confirm your identity. This allows us to protect customers\u2019 confidentiality and stop personal data falling into the wrong hands. To confirm who you are we\u2019ll need copies of some identification documents, such as your passport or utility bills."))},{title:"How do I request CCTV images from one of your stores?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"If you want to request CCTV of yourself from our stores please send your request to"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")," ","or write to the Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"We might ask you for more information to help us identify you within the CCTV footage. We keep CCTV footage for up to 31 days, after that it's deleted."))},{title:"How will you send my personal data to me?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We can send you your personal data in a couple of ways:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Via encrypted email:")," Your personal data will be encrypted with a password to protect your confidentiality. You\u2019ll get the password separately via a text message, or a separate email if you don\u2019t have a mobile phone."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"By post:")," We can also send your personal data to your confirmed address. Anything we send by post will be sent recorded delivery.")))},{title:"How do I get personal data that Nectar hold about me?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Please send your request to"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{title:"privacy@sainsburys.co.uk",href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")," ","or write to the Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL.")},{title:"How do I get personal data Sainsbury’s Bank/Argos Financial Services hold about me?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Visit the Sainsbury\u2019s Bank website. You\u2019ll find instructions on how to download and return a Data Request form, visit:"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"},"https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"),";"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Call Sainsbury\u2019s Bank on ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:08085 405060"},"08085 405060")," ","and they\u2019ll help you complete the Data Request form"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Send a letter to Sainsbury\u2019s Bank, PO Box 4955, Worthing, BN11 9ZA. Please include a copy of your Data Request form with your letter. This will help us find the data you are looking for and get back to you as soon as we can.")))},{title:"Who do you share my data with?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We only share your data with Sainsbury\u2019s Group and with trusted third parties. For more information see our"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/privacy-policy"},"Privacy Policy"),"."))},{title:"Why do you keep my data for a certain length of time?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We never hang on to your personal data for longer than we need to. We only keep it for the purposes in accordance with our privacy policy and in accordance with the law and relevant regulations. For more information see our ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/privacy-policy"},"Privacy Policy"),"."))},{title:"How can I opt out of receiving marketing?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you want to opt out from Sainsbury\u2019s Group marketing, visit our"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:__WEBPACK_IMPORTED_MODULE_4__config__["marketingPermissionsUrl"]},"Group Marketing Permissions Centre"),". That\u2019s where you can tell us which services you wish to hear from and which ones to stop hearing from. You can also call us on"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:0800636262"},"0800 63 62 62")," to update your marketing choices."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please note that once you opt out, we\u2019ll stop sending you marketing communications & offers."))},{title:"How do I change my Nectar marketing permissions?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You can manage your Nectar permissions:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"In the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:__WEBPACK_IMPORTED_MODULE_4__config__["marketingPermissionsUrl"]},"Group Marketing Permissions Centre")," ","by ticking/un-ticking the Nectar box"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Visit your Nectar online account"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Contact the Nectar helpline on"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:03448110811"},"0344 811 0811"),".")))},{title:"I don’t remember giving permissions directly to Sainsbury’s Group companies. Is there any other way I could have been opted in/out of Sainsbury’s Group marketing communication?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Sainsbury\u2019s, Sainsbury\u2019s Bank, Tu Clothing and Argos are all members of Nectar Loyalty Scheme. When you register with Nectar you may allow Nectar to send you marketing about its partners. So, if you allowed Nectar and its partners to communicate with you in the past, they\u2019ll be able to talk to you about these partner companies."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you want to change any marketing permissions, visit the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:__WEBPACK_IMPORTED_MODULE_4__config__["marketingPermissionsUrl"]},"Group Marketing Permissions Centre")," ","and un-tick the companies you don\u2019t want to hear from. This will override any Nectar marketing permissions relating to the companies you un-tick, and you\u2019ll stop hearing from them."))},{title:"How can I get in touch with the Data Protection Officer?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You can contact the Data Protection Officer by emailing"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")," ","or write to the Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL."))}];

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DataSafe */
/* unused harmony export tabContents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Tabs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_tab_images_how_to_spot_a_phishing_email_jpg__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_tab_images_how_to_spot_a_phishing_email_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_tab_images_how_to_spot_a_phishing_email_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_suspicious_text_jpg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_suspicious_text_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_suspicious_text_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_protect_devices_jpg__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_protect_devices_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_protect_devices_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_strong_password_jpg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_strong_password_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_strong_password_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_social_media_scam_jpg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_social_media_scam_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_social_media_scam_jpg__);
var DataSafe=function DataSafe(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"How to keep your data safe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"section_subtext"},"Learn more about how you can keep your data safe at home")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Tabs__["a" /* default */],{items:tabContents}));};var tabContents=[{title:"Social media scams",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Social media has become a part of everyday life for a lot of us, so it\u2019s important to know how to protect yourself against scams whilst using it."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If an offer looks too good to be true then it might not be legitimate. Do a little research before clicking on it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Look out for links that look official, but direct you to a fake login page"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If someone you know has shared something with you, check with them that they actually recommended it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Check the spelling in the URL as misspelled brand names can send you somewhere completely different"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t always rely on the secure padlock icon in the address bar. It only means the web traffic is private, but doesn\u2019t guarantee that you can trust the company"))),image:__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_social_media_scam_jpg___default.a},{title:"Phishing - emails",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Phishing is when fraudsters try to steal personal data, like bank details, by impersonating someone trustworthy via a malicious email. By pretending to be a legitimate person or company, the fraudsters trick you into handing over personal details or visiting an insecure website."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Spotting a phishing email:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Authority"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Is the email claiming to be from someone official?")," For example: your bank, a government organisation, your doctor? Fraudsters often pretend to be important people/organisations to trick people to do what they want."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Urgency"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Does the email state that you have a limited amount of time to act?"," "),"Fraudsters look to threaten you with fines and negative consequences if you don\u2019t act within their stated time frame."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Emotion"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Does the email make you feel happy, excited, curious, or worried?"," "),"Fraudsters often use emotive language to entice you to want to find out more."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Scarcity"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Is the email offering something in short supply?")," \u2013 for example concert tickets that are sold out. Fraudsters often exploit fear of missing out and trick victims."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Current events"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Are you expecting to see a message like this?")," Fraudsters exploit current events to trick you to click on links. Perhaps it\u2019s time for you to receive your tax refunds? Criminals may imitate HMRC, tricking you to click on links.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"What to do if you receive a suspicious email?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t click on any links, open any attachments, or forward the email to anyone else."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t reply to the email or use any contact details contained within it."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If you are unsure whether the email is legitimate, get in touch with the company separately to confirm."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Note: Sainsbury\u2019s will never contact you via email asking for your personal information such as credit card information.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"What if I receive an unusual email from one of Sainsbury\u2019s brands?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you receive a phishing email from any of Sainsbury\u2019s brands you can forward this to the following mailboxes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Sainsbury\u2019s:"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:scams@sainsburys.co.uk"},"scams@sainsburys.co.uk")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Argos: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:scams@argos.co.uk"},"scams@argos.co.uk"))),image:__WEBPACK_IMPORTED_MODULE_3__assets_images_tab_images_how_to_spot_a_phishing_email_jpg___default.a},{title:"SMiShing – suspicious text messages",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"SMiShing is when fraudsters try to get hold of your data like usernames, passwords and payment card details by pretending to be someone legitimate via text message."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The text message may include links to websites that are infected with malware or the link will ask you for personal data."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Points to remember if you receive an unusual SMS:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Companies/banks do not send text messages asking for personal information"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"If you receive a suspicious text message, don\u2019t click on any links, download, or open any attachments."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Delete the text message and do not reply."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Sainsbury\u2019s would never ask for personal data in an SMS or email message. If you receive a message and are unsure, please call us on our official telephone number.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Reporting a SMiSh?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you receive any unusual messages, forward this message to 7726, this will enable your service provider to investigate the origin of the message and take action if it\u2019s fraudulent. This service is free of charge.")),image:__WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_suspicious_text_jpg___default.a},{title:"Creating a strong password",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Creating a strong password is crucial to ensure basic security of your accounts. Below are top tips to create a strong password."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Consider using a phrase or three random words."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t use the same password for all your accounts, you could risk having all your accounts hacked if a website is breached."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t use people\u2019s names, as these are easily cracked using common hacking tools."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Avoid using passwords that can be guessed after research on your online presence such as social media accounts. For example, pet names"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Avoid writing down passwords or sharing with anyone. If you find remembering your passwords difficult, consider using a secure password manager to store your passwords."))),image:__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_strong_password_jpg___default.a},{title:"Managing your digital footprint",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Social Media has become a large part of everyday life, so it is important to know how to protect yourself online from scams."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"It\u2019s important that you review your privacy settings online, to review who has access to your social media accounts."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"What is your digital footprint?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Your digital footprint is all the stuff you leave behind as you use the Internet. Comments on social media, app use and email records \u2013 it\u2019s part of your online history and can potentially be seen by other people or tracked in a database."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Below are some tips to manage your digital footprint"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Try typing your name in a search engine, if you come across your social media profile and it is on public, you may want to review your privacy settings."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Create strong passwords, three random words, this is easier to remember and harder to break. Ensure you don\u2019t reuse your passwords across accounts."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Take control: often the content online may not be reflective of how we truly are. For example, we may be tagged in a post we have nothing to do with. In such cases un-tag, yourself from posts you no longer want to be associated with."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Enable two factor authentication (2FA) on your accounts: having strong passwords alone is not enough to secure your online accounts. By enabling 2FA on your accounts you are providing an extra layer of security as you are required to verify your identity and confirm you are who you say you are. Click"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.ncsc.gov.uk/cyberaware/home#action-4"},"here")," ","for more advice from the NCSC on how to set up 2FA on your accounts.")))},{title:"Protecting your devices",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"It is important you protect yourself from online attacks. Below are some tips to prevent malware infecting your devices."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"When using smart devices only download and install programs from websites and app stores you trust \u2013 for example Apple or Android App Store."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Only buy trusted and well known, subscription-based programs."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Read security information, privacy statements and license agreements when you install software."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Don\u2019t click \u2018OK\u2019 or \u2018I Agree\u2019 on pop-up windows, unless you know what you\u2019re signing up for."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Ensure you update your devices and software on a regular basis. They may contain security updates that help protect your devices from cyber criminals.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Useful links"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"The ICO (Information Commissioner\u2019s Office) upholds information rights in the public interest, promoting openness by public bodies and data privacy for individuals."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://ico.org.uk/for-the-public/"},"https://ico.org.uk/for-the-public/")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Cyberaware is a UK Government resource focussed on making \u201Cgood cyber security habits second nature.\u201D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.cyberaware.gov.uk/"},"https://www.cyberaware.gov.uk/")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Get Safe Online offer easy to understand advice on how to protect your online self."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.getsafeonline.org/"},"https://www.getsafeonline.org/"))),image:__WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_protect_devices_jpg___default.a}];/* harmony default export */ __webpack_exports__["a"] = (DataSafe);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Accessibility = __webpack_require__(154);

Object.defineProperty(exports, 'Accessibility', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Accessibility).default;
  }
});

var _Account = __webpack_require__(155);

Object.defineProperty(exports, 'Account', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Account).default;
  }
});

var _ArrowDown = __webpack_require__(55);

Object.defineProperty(exports, 'ArrowDown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowDown).default;
  }
});

var _ArrowLeft = __webpack_require__(156);

Object.defineProperty(exports, 'ArrowLeft', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowLeft).default;
  }
});

var _ArrowRight = __webpack_require__(48);

Object.defineProperty(exports, 'ArrowRight', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowRight).default;
  }
});

var _ArrowUp = __webpack_require__(157);

Object.defineProperty(exports, 'ArrowUp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowUp).default;
  }
});

var _ArrowUpDown = __webpack_require__(158);

Object.defineProperty(exports, 'ArrowUpDown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowUpDown).default;
  }
});

var _AwardWinning = __webpack_require__(159);

Object.defineProperty(exports, 'AwardWinning', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AwardWinning).default;
  }
});

var _Bag = __webpack_require__(160);

Object.defineProperty(exports, 'Bag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bag).default;
  }
});

var _Basket = __webpack_require__(161);

Object.defineProperty(exports, 'Basket', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Basket).default;
  }
});

var _Calendar = __webpack_require__(162);

Object.defineProperty(exports, 'Calendar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Calendar).default;
  }
});

var _Cancel = __webpack_require__(53);

Object.defineProperty(exports, 'Cancel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cancel).default;
  }
});

var _ClickAndCollect = __webpack_require__(163);

Object.defineProperty(exports, 'ClickAndCollect', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ClickAndCollect).default;
  }
});

var _Comment = __webpack_require__(164);

Object.defineProperty(exports, 'Comment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Comment).default;
  }
});

var _Delete = __webpack_require__(165);

Object.defineProperty(exports, 'Delete', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Delete).default;
  }
});

var _Delivery = __webpack_require__(166);

Object.defineProperty(exports, 'Delivery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Delivery).default;
  }
});

var _Dislike = __webpack_require__(167);

Object.defineProperty(exports, 'Dislike', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dislike).default;
  }
});

var _Download = __webpack_require__(168);

Object.defineProperty(exports, 'Download', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Download).default;
  }
});

var _Edit = __webpack_require__(169);

Object.defineProperty(exports, 'Edit', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Edit).default;
  }
});

var _Favourites = __webpack_require__(170);

Object.defineProperty(exports, 'Favourites', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Favourites).default;
  }
});

var _Freshness = __webpack_require__(171);

Object.defineProperty(exports, 'Freshness', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Freshness).default;
  }
});

var _Geolocation = __webpack_require__(172);

Object.defineProperty(exports, 'Geolocation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Geolocation).default;
  }
});

var _GridView = __webpack_require__(173);

Object.defineProperty(exports, 'GridView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridView).default;
  }
});

var _Home = __webpack_require__(174);

Object.defineProperty(exports, 'Home', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Home).default;
  }
});

var _Info = __webpack_require__(175);

Object.defineProperty(exports, 'Info', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Info).default;
  }
});

var _LandlinePhone = __webpack_require__(176);

Object.defineProperty(exports, 'LandlinePhone', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LandlinePhone).default;
  }
});

var _Like = __webpack_require__(177);

Object.defineProperty(exports, 'Like', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Like).default;
  }
});

var _List = __webpack_require__(178);

Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _ListView = __webpack_require__(179);

Object.defineProperty(exports, 'ListView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListView).default;
  }
});

var _Measurement = __webpack_require__(180);

Object.defineProperty(exports, 'Measurement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Measurement).default;
  }
});

var _Menu = __webpack_require__(181);

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _Messages = __webpack_require__(182);

Object.defineProperty(exports, 'Messages', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Messages).default;
  }
});

var _Minus = __webpack_require__(183);

Object.defineProperty(exports, 'Minus', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Minus).default;
  }
});

var _MobilePhone = __webpack_require__(184);

Object.defineProperty(exports, 'MobilePhone', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MobilePhone).default;
  }
});

var _More = __webpack_require__(185);

Object.defineProperty(exports, 'More', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_More).default;
  }
});

var _NewWindow = __webpack_require__(186);

Object.defineProperty(exports, 'NewWindow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NewWindow).default;
  }
});

var _Nfc = __webpack_require__(187);

Object.defineProperty(exports, 'Nfc', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Nfc).default;
  }
});

var _Notification = __webpack_require__(188);

Object.defineProperty(exports, 'Notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Notification).default;
  }
});

var _OverflowMenu = __webpack_require__(189);

Object.defineProperty(exports, 'OverflowMenu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverflowMenu).default;
  }
});

var _Plus = __webpack_require__(190);

Object.defineProperty(exports, 'Plus', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plus).default;
  }
});

var _Print = __webpack_require__(191);

Object.defineProperty(exports, 'Print', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Print).default;
  }
});

var _Recipe = __webpack_require__(192);

Object.defineProperty(exports, 'Recipe', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Recipe).default;
  }
});

var _Scan = __webpack_require__(193);

Object.defineProperty(exports, 'Scan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Scan).default;
  }
});

var _Search = __webpack_require__(54);

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Search).default;
  }
});

var _Settings = __webpack_require__(194);

Object.defineProperty(exports, 'Settings', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Settings).default;
  }
});

var _StoreLocation = __webpack_require__(195);

Object.defineProperty(exports, 'StoreLocation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StoreLocation).default;
  }
});

var _StoreLocation2 = __webpack_require__(196);

Object.defineProperty(exports, 'StoreLocation1', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StoreLocation2).default;
  }
});

var _StoreLocation3 = __webpack_require__(197);

Object.defineProperty(exports, 'StoreLocation10', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StoreLocation3).default;
  }
});

var _Tick = __webpack_require__(198);

Object.defineProperty(exports, 'Tick', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tick).default;
  }
});

var _Time = __webpack_require__(199);

Object.defineProperty(exports, 'Time', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Time).default;
  }
});

var _Trolley = __webpack_require__(200);

Object.defineProperty(exports, 'Trolley', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Trolley).default;
  }
});

var _Upload = __webpack_require__(201);

Object.defineProperty(exports, 'Upload', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Upload).default;
  }
});

var _VoiceSearch = __webpack_require__(202);

Object.defineProperty(exports, 'VoiceSearch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VoiceSearch).default;
  }
});

var _ZoomIn = __webpack_require__(203);

Object.defineProperty(exports, 'ZoomIn', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ZoomIn).default;
  }
});

var _ZoomOut = __webpack_require__(204);

Object.defineProperty(exports, 'ZoomOut', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ZoomOut).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accessibility = function Accessibility(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '17',
      height: '25',
      viewBox: '0 0 17 25'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1)'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M11.586 17l2.207 2.207a1 1 0 0 0 1.414-1.414l-2.5-2.5A1 1 0 0 0 12 15H7.847l-1.36-8.164a1 1 0 1 0-1.973.328l1.5 9A1 1 0 0 0 7 17h4.586z'
      }),
      _react2.default.createElement('circle', {
        cx: '6',
        cy: '2',
        r: '2'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M6.5 12H10a1 1 0 0 0 0-2H6.5a1 1 0 0 0 0 2zm-3.61.076C.555 13.042-1 15.29-1 17.826c0 3.45 2.851 6.239 6.357 6.239 2.685 0 5.056-1.649 5.969-4.086a1 1 0 1 0-1.873-.702c-.621 1.658-2.247 2.788-4.096 2.788C2.946 22.065 1 20.162 1 17.827c0-1.714 1.056-3.242 2.654-3.903a1 1 0 0 0-.764-1.848z'
      })
    )
  );
};

exports.icon = Accessibility;
exports.default = (0, _hoc2.default)(Accessibility);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account = function Account(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M11 8c1.658 0 3-1.342 3-3s-1.342-3-3-3-3 1.342-3 3 1.342 3 3 3zm0 2c-2.762 0-5-2.237-5-5s2.238-5 5-5 5 2.237 5 5-2.238 5-5 5zm0 4c-4.652 0-9 2.5-9 5.5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5c0-3-4.348-5.5-9-5.5zm0-2c4.59 0 11 2.512 11 7.5a2.5 2.5 0 0 1-2.5 2.5h-17A2.5 2.5 0 0 1 0 19.5C0 14.512 6.41 12 11 12z'
    })
  );
};

exports.icon = Account;
exports.default = (0, _hoc2.default)(Account);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeft = function ArrowLeft(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '10',
      height: '18',
      viewBox: '0 0 10 18'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M2.414 9l7.293-7.293A1 1 0 0 0 8.293.293l-8 8a1 1 0 0 0 0 1.414l8 8a1 1 0 1 0 1.414-1.414L2.414 9z'
    })
  );
};

exports.icon = ArrowLeft;
exports.default = (0, _hoc2.default)(ArrowLeft);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowUp = function ArrowUp(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '10',
      viewBox: '0 0 18 10'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M9 2.414L1.707 9.707A1 1 0 0 1 .293 8.293l8-8a1 1 0 0 1 1.414 0l8 8a1 1 0 1 1-1.414 1.414L9 2.414z'
    })
  );
};

exports.icon = ArrowUp;
exports.default = (0, _hoc2.default)(ArrowUp);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowUpDown = function ArrowUpDown(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement('path', {
      d: 'M12.18 20.95l-6.22-6.3a.98.98 0 0 0-1.4 0 1 1 0 0 0 0 1.42l6.92 7c.39.39 1.01.39 1.4 0l6.91-7a1 1 0 0 0 0-1.42.98.98 0 0 0-1.4 0l-6.21 6.3zm0-18.18l-6.22 6.3a.98.98 0 0 1-1.4 0 1 1 0 0 1 0-1.42l6.92-7a.98.98 0 0 1 1.4 0l6.91 7a1 1 0 0 1 0 1.42.98.98 0 0 1-1.4 0l-6.21-6.3z',
      stroke: 'none',
      fillRule: 'nonzero'
    })
  );
};

exports.icon = ArrowUpDown;
exports.default = (0, _hoc2.default)(ArrowUpDown);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AwardWinning = function AwardWinning(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '21',
      viewBox: '0 0 22 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M16 8V2.019c0-.007-.417-.013-1.25-.018H6.02C6.011 2 6.005 3.906 6 7.717 5.95 11.192 8.12 14 10.777 14 13.31 14 16 10.241 16 8zm-5.21 8c-3.924 0-6.856-3.827-6.789-8.284v-5.35A2.358 2.358 0 0 1 6.351 0h9.299C16.948 0 18 1.06 18 2.366V8c.001 3.271-3.355 8-7.21 8z'
      }),
      _react2.default.createElement('path', {
        d: 'M3.843 2C1.708 2 0 3.803 0 6s1.708 4 3.843 4a3.71 3.71 0 0 0 1.583-.354 1 1 0 1 0-.852-1.81A1.707 1.707 0 0 1 3.843 8C2.837 8 2 7.116 2 6s.837-2 1.843-2a1 1 0 1 0 0-2zM16.56 9.623a3.668 3.668 0 0 0 1.62.377C20.304 10 22 8.196 22 6c0-2.196-1.696-4-3.82-4a1 1 0 1 0 0 2c.99 0 1.82.882 1.82 2 0 1.118-.83 2-1.82 2-.259 0-.509-.059-.74-.172a1 1 0 0 0-.88 1.795zM12 20v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M8 21h6a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2z'
      })
    )
  );
};

exports.icon = AwardWinning;
exports.default = (0, _hoc2.default)(AwardWinning);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bag = function Bag(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M4.52 18.79c.11.7.72 1.21 1.43 1.21h11.98c.71 0 1.32-.51 1.43-1.21L21.14 8H2.74l1.78 10.79zM1.56 6h20.76a1 1 0 0 1 .98 1.16l-1.97 11.96a3.44 3.44 0 0 1-3.4 2.88H5.95a3.44 3.44 0 0 1-3.4-2.88L.58 7.16A1 1 0 0 1 1.56 6z'
      }),
      _react2.default.createElement('path', {
        d: 'M17 6A5 5 0 0 0 7 6a1 1 0 1 0 2 0 3 3 0 0 1 6 0 1 1 0 0 0 2 0z'
      })
    )
  );
};

exports.icon = Bag;
exports.default = (0, _hoc2.default)(Bag);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Basket = function Basket(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '23',
      viewBox: '0 0 22 23'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M3.505 9a1.444 1.444 0 0 0-1.425 1.68l1.5 9.11c.115.698.718 1.21 1.425 1.21h11.99c.707 0 1.31-.512 1.425-1.21l1.5-9.11A1.444 1.444 0 0 0 18.496 9H3.505zm0-2h14.99a3.444 3.444 0 0 1 3.399 4.004l-1.5 9.111a3.444 3.444 0 0 1-3.4 2.885H5.006a3.444 3.444 0 0 1-3.398-2.885l-1.5-9.11A3.444 3.444 0 0 1 3.504 7z'
      }),
      _react2.default.createElement('path', {
        d: 'M16.831 6.915L14.82 1.262a1 1 0 1 0-1.884.67l2.01 5.653a1 1 0 1 0 1.885-.67zm-9.778.67l2.011-5.653a1 1 0 0 0-1.884-.67L5.169 6.915a1 1 0 0 0 1.884.67z'
      })
    )
  );
};

exports.icon = Basket;
exports.default = (0, _hoc2.default)(Basket);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = function Calendar(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '23',
      viewBox: '0 0 22 23'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M3 5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3zm0-2h16a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3z'
      }),
      _react2.default.createElement('path', {
        d: 'M6 1v5a1 1 0 1 0 2 0V1a1 1 0 1 0-2 0zm8 0v5a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0zM9.134 16.5a1 1 0 0 0 1.732 1l4.046-7a1 1 0 0 0-.866-1.5H8a1 1 0 1 0 0 2h4.313l-3.179 5.5z'
      })
    )
  );
};

exports.icon = Calendar;
exports.default = (0, _hoc2.default)(Calendar);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClickAndColleck = function ClickAndColleck(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '23',
      viewBox: '0 0 22 23'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M12.152 21h-6.91c-.769 0-1.587-.751-1.737-1.665L2.024 10.34C1.892 9.541 2.3 9 2.924 9h16.15c.628 0 1.034.536.902 1.339l-.6 2.545a1 1 0 1 0 1.947.457l.613-2.611C22.274 8.693 20.993 7 19.075 7H2.925C1.008 7-.273 8.7.05 10.665l1.482 8.995C1.836 21.508 3.459 23 5.242 23h6.91a1 1 0 0 0 0-2z'
      }),
      _react2.default.createElement('path', {
        d: 'M15.563 14.997l3.48 1.042a1.222 1.222 0 0 1 .257 2.231l-.173.099-1.682 1.748-.113.213a1.222 1.222 0 0 1-2.253-.234l-1.04-3.588a1.222 1.222 0 0 1 1.524-1.511z'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M16.4 18.762l3.667 3.706a1 1 0 1 0 1.422-1.407l-3.667-3.706a1 1 0 1 0-1.422 1.407zm.431-11.847L14.82 1.262a1 1 0 1 0-1.884.67l2.01 5.653a1 1 0 1 0 1.885-.67zm-9.778.67l2.011-5.653a1 1 0 0 0-1.884-.67L5.169 6.915a1 1 0 0 0 1.884.67z'
      })
    )
  );
};

exports.icon = ClickAndColleck;
exports.default = (0, _hoc2.default)(ClickAndColleck);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Comment = function Comment(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M11.071 16H18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3.061l1.98 2.67 2.03-2.67zM4 0h14a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4h-5.937l-3.042 4-2.967-4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'
      }),
      _react2.default.createElement('circle', {
        cx: '7',
        cy: '9',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '11',
        cy: '9',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '15',
        cy: '9',
        r: '1'
      })
    )
  );
};

exports.icon = Comment;
exports.default = (0, _hoc2.default)(Comment);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Delete = function Delete(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M7 10v7a1 1 0 0 0 2 0v-7a1 1 0 1 0-2 0zm6 0v7a1 1 0 0 0 2 0v-7a1 1 0 0 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M2.062 9.992l-.06 7.498A4.474 4.474 0 0 0 6.439 22h9.086A4.474 4.474 0 0 0 20 17.526l-.035-7.53a1 1 0 0 0-2 .009l.035 7.51A2.476 2.476 0 0 1 15.525 20h-9.05a2.478 2.478 0 0 1-2.474-2.494l.06-7.498a1 1 0 1 0-2-.016zM1 7h20a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2z'
      }),
      _react2.default.createElement('path', {
        d: 'M7 5V4h1v1H7zm0 1a1 1 0 0 1-1-1l.002-2h.128A4.001 4.001 0 0 1 10.002.001L12.017 0a4 4 0 0 1 4 4v.075l-.018.944a1 1 0 1 1-2-.038l.018-.944V4a2 2 0 0 0-1.998-2l-2.016.002a2 2 0 0 0-2 1.999v1A1.005 1.005 0 0 1 6.998 6z'
      })
    )
  );
};

exports.icon = Delete;
exports.default = (0, _hoc2.default)(Delete);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Delivery = function Delivery(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '21',
      viewBox: '0 0 22 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1 1)'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M19 9.733l-4.169-4.377a1 1 0 0 1 1.449-1.379L21 8.933v2.845A3.222 3.222 0 0 1 17.778 15H2.222A3.222 3.222 0 0 1-1 11.778V2.222A3.222 3.222 0 0 1 2.222-1H10a3.222 3.222 0 0 1 3.222 3.222v7.111a1 1 0 0 1-2 0v-7.11C11.222 1.546 10.675 1 10 1H2.222C1.547 1 1 1.547 1 2.222v9.556C1 12.453 1.547 13 2.222 13h15.556c.675 0 1.222-.547 1.222-1.222V9.733z'
      }),
      _react2.default.createElement('circle', {
        cx: '16',
        cy: '18',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '4',
        cy: '18',
        r: '2'
      })
    )
  );
};

exports.icon = Delivery;
exports.default = (0, _hoc2.default)(Delivery);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dislike = function Dislike(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '24',
      viewBox: '0 0 22 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M5 14H2.294A.294.294 0 0 1 2 13.706V4.294C2 4.132 2.132 4 2.294 4H5v10zm-2.706 2H7V2H2.294A2.294 2.294 0 0 0 0 4.294v9.412A2.294 2.294 0 0 0 2.294 16z'
      }),
      _react2.default.createElement('path', {
        d: 'M7 3.778c3.83-.934 7.084-1.12 9.756-.571 1.792.367 2.68 1.059 3.038 2.01.184.489.223.949.199 1.746-.007.238-.009.28-.009.377V13c0 .738-1.043 2-1.684 2H13a1 1 0 0 0-1 1v4.447a.294.294 0 0 1-.207.28l-1.14.356a1.277 1.277 0 0 1-1.574-.767L7 14.817V3.777zM18.3 17c1.838 0 3.684-2.233 3.684-4V7.34c0-.068.001-.106.008-.317.031-1.041-.025-1.712-.327-2.511-.613-1.628-2.073-2.765-4.507-3.264-3.179-.652-6.982-.384-11.413.785A1 1 0 0 0 5 3v12a1 1 0 0 0 .065.354l2.143 5.669a3.277 3.277 0 0 0 4.041 1.97l1.14-.356A2.294 2.294 0 0 0 14 20.447V17h4.3z'
      })
    )
  );
};

exports.icon = Dislike;
exports.default = (0, _hoc2.default)(Dislike);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Download = function Download(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '21',
      viewBox: '0 0 20 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M9 1v14a1 1 0 0 0 2 0V1a1 1 0 1 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M4.707 9.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 1 0-1.414-1.414L10 14.586 4.707 9.293zM1 21h18a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2z'
      })
    )
  );
};

exports.icon = Download;
exports.default = (0, _hoc2.default)(Download);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = function Edit(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        strokeWidth: '2'
      },
      _react2.default.createElement('path', {
        d: 'M1.518 18.24l.03 4.28 4.206-.032L22.192 6.05a1 1 0 0 0 0-1.414l-2.828-2.828a1 1 0 0 0-1.414 0L1.518 18.24z'
      }),
      _react2.default.createElement('path', {
        strokeLinecap: 'square',
        d: 'M16 4l3.536 3.536'
      })
    )
  );
};

exports.icon = Edit;
exports.default = (0, _hoc2.default)(Edit);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favourites = function Favourites(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '20',
      viewBox: '0 0 24 20'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M12 5.402L9.906 3.34c-1.81-1.785-4.756-1.787-6.565-.004a4.472 4.472 0 0 0 .003 6.392l8.21 8.094a.642.642 0 0 0 .888 0l8.21-8.094a4.47 4.47 0 0 0 .003-6.392c-1.806-1.78-4.756-1.78-6.565.004L12 5.402zm.687-3.487c2.588-2.55 6.789-2.551 9.374-.003a6.47 6.47 0 0 1-.004 9.24l-8.21 8.094a2.642 2.642 0 0 1-3.696 0l-8.21-8.094a6.472 6.472 0 0 1-.003-9.24c2.588-2.55 6.785-2.549 9.373.003l.688.678.688-.678z'
    })
  );
};

exports.icon = Favourites;
exports.default = (0, _hoc2.default)(Favourites);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Freshness = function Freshness(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '21',
      viewBox: '0 0 22 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        strokeLinecap: 'round',
        strokeWidth: '2'
      },
      _react2.default.createElement('path', {
        strokeLinejoin: 'round',
        d: 'M1.062 1.268S2.468 12.53 4.907 15.786c2.438 3.257 6.957 4.566 10.2 2.107 3.24-2.458 4.982-7.585 2.249-10.775-1.668-1.945-4.89-2.23-9.114-3.31-4.224-1.082-7.18-2.54-7.18-2.54z'
      }),
      _react2.default.createElement('path', {
        d: 'M10.09 10.99c.78 1.833 3.127 4.823 10.178 5.464'
      })
    )
  );
};

exports.icon = Freshness;
exports.default = (0, _hoc2.default)(Freshness);

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Geolocation = function Geolocation(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1 1)'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0 2a8 8 0 1 1 0-16 8 8 0 0 1 0 16z'
      }),
      _react2.default.createElement('circle', {
        cx: '10',
        cy: '10',
        r: '2'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M9 18v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-2 0zM9 0v2a1 1 0 1 0 2 0V0a1 1 0 0 0-2 0zM2 9H0a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2zm18 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z'
      })
    )
  );
};

exports.icon = Geolocation;
exports.default = (0, _hoc2.default)(Geolocation);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridView = function GridView(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '6',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '12',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        y: '6',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '6',
        y: '6',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '12',
        y: '6',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        y: '12',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '6',
        y: '12',
        rx: '1'
      }),
      _react2.default.createElement('rect', {
        width: '4',
        height: '4',
        x: '12',
        y: '12',
        rx: '1'
      })
    )
  );
};

exports.icon = GridView;
exports.default = (0, _hoc2.default)(GridView);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = function Home(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '22',
      viewBox: '0 0 20 22'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M6 15.944C6 13.887 7.377 12 10 12c2.624 0 4 1.883 4 3.944V20h2.244C17.23 20 18 19.256 18 18.368V9.887c0-.436-.311-1.161-.645-1.484l-6.092-5.901a1.84 1.84 0 0 0-2.526 0l-6.092 5.9C2.308 8.73 2 9.447 2 9.888v8.481C2 19.26 2.767 20 3.756 20H6v-4.056zM3.756 22C1.68 22 0 20.382 0 18.368V9.887c0-.987.53-2.22 1.253-2.92l6.092-5.902c1.467-1.42 3.843-1.42 5.31 0l6.092 5.901C19.468 7.665 20 8.908 20 9.886v8.482C20 20.376 18.321 22 16.244 22H12v-6.056c0-.671-.351-1.944-2-1.944s-2 1.28-2 1.944V22H3.756z'
    })
  );
};

exports.icon = Home;
exports.default = (0, _hoc2.default)(Home);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Info = function Info(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '11',
      height: '21',
      viewBox: '0 0 11 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1)'
      },
      _react2.default.createElement('circle', {
        cx: '4',
        cy: '2',
        r: '2'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M0 19a1 1 0 0 0 0 2h9c1.333 0 1.333-2 0-2H4.5l1 1V8a1 1 0 0 0-1-1H0a1 1 0 1 0 0 2h3.5v10H0z'
      })
    )
  );
};

exports.icon = Info;
exports.default = (0, _hoc2.default)(Info);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandlinePhone = function LandlinePhone(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '19',
      height: '23',
      viewBox: '0 0 19 23'
    }, props),
    _react2.default.createElement('path', {
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '2',
      d: 'M7.985 20.029s-1.933-1.815-4.002-5.399c1.846 3.198 4.002 5.399 4.002 5.399 1.311 1.386 3.406 1.911 5.853.498l2.803-1.618c.562-.325.764-1.03.459-1.56l-1.616-2.798c-.31-.537-1.027-.7-1.593-.374l-3.266 1.885s-.891-.462-2.737-3.66c-1.846-3.197-1.79-4.18-1.79-4.18l3.266-1.885c.566-.326.783-1.03.473-1.567L8.22 1.97c-.306-.53-1.018-.707-1.58-.383l-2.802 1.62C1.391 4.619.798 6.697 1.343 8.525c0 0 .793 2.907 2.64 6.105-2.07-3.584-2.64-6.105-2.64-6.105'
    })
  );
};

exports.icon = LandlinePhone;
exports.default = (0, _hoc2.default)(LandlinePhone);

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Like = function Like(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '24',
      viewBox: '0 0 22 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M5 10H2.294a.294.294 0 0 0-.294.294v9.412c0 .162.132.294.294.294H5V10zM2.294 8H7v14H2.294A2.294 2.294 0 0 1 0 19.706v-9.412A2.294 2.294 0 0 1 2.294 8z'
      }),
      _react2.default.createElement('path', {
        d: 'M7 9.183v11.04c3.83.933 7.084 1.118 9.756.57 1.736-.356 2.63-1.14 3.02-2.29.21-.62.256-1.203.231-2.126A11.605 11.605 0 0 1 20 16v-6c0-.443-.788-1-1.7-1H13a1 1 0 0 1-1-1V3.553a.294.294 0 0 0-.207-.28l-1.14-.356a1.277 1.277 0 0 0-1.574.767L7 9.183zM14 7h4.3c1.898 0 3.7 1.275 3.7 3v6c0 .066 0 .09.007.324.03 1.143-.03 1.92-.338 2.823-.619 1.824-2.082 3.107-4.511 3.605-3.179.652-6.982.384-11.413-.785A1 1 0 0 1 5 21V9a1 1 0 0 1 .065-.354l2.143-5.669a3.277 3.277 0 0 1 4.041-1.97l1.14.356A2.294 2.294 0 0 1 14 3.553V7z'
      })
    )
  );
};

exports.icon = Like;
exports.default = (0, _hoc2.default)(Like);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '22',
      viewBox: '0 0 18 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M4 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h10a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'
      }),
      _react2.default.createElement('path', {
        d: 'M5 8h8a1 1 0 0 0 0-2H5a1 1 0 1 0 0 2zm0 4h8a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2zm0 4h8a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z'
      })
    )
  );
};

exports.icon = List;
exports.default = (0, _hoc2.default)(List);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListView = function ListView(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '16',
      viewBox: '0 0 18 16'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M7 15h10a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2zm0-6h10a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2zm0-6h10a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2z'
      }),
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '14',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '8',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '2',
        r: '2'
      })
    )
  );
};

exports.icon = ListView;
exports.default = (0, _hoc2.default)(ListView);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Measurement = function Measurement(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '23',
      viewBox: '0 0 24 23'
    }, props),
    _react2.default.createElement('path', {
      fill: 'none',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '2',
      d: 'M16.233 1.198l6.188 6.187L7.779 22.026 1.592 15.84z'
    }),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M8.716 8.716l1.767 1.767a1 1 0 0 0 1.415-1.414L10.13 7.302a1 1 0 1 0-1.414 1.414zM5.18 12.251l2.652 2.652a1 1 0 0 0 1.414-1.414l-2.652-2.652a1 1 0 0 0-1.414 1.414zm7.071-7.071l2.652 2.652a1 1 0 1 0 1.414-1.414l-2.652-2.652a1 1 0 1 0-1.414 1.414z'
    })
  );
};

exports.icon = Measurement;
exports.default = (0, _hoc2.default)(Measurement);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '14',
      viewBox: '0 0 18 14'
    }, props),
    _react2.default.createElement('path', {
      d: 'M1 14h16a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2zm0-6h16a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zm0-6h16a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2z',
      stroke: 'none',
      fillRule: 'nonzero'
    })
  );
};

exports.icon = Menu;
exports.default = (0, _hoc2.default)(Menu);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Messages = function Messages(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '18',
      viewBox: '0 0 22 18'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h15a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 18.5 2h-15zm0-2h15A3.5 3.5 0 0 1 22 3.5v11a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 0 14.5v-11A3.5 3.5 0 0 1 3.5 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M1.53 2.944l6.702 6.943a3.5 3.5 0 0 0 4.949.088c.044-.043.044-.043.087-.088l6.702-6.943a1 1 0 1 0-1.44-1.388l-6.7 6.942-.038.038a1.5 1.5 0 0 1-2.121-.038L2.97 1.556a1 1 0 1 0-1.44 1.388z'
      })
    )
  );
};

exports.icon = Messages;
exports.default = (0, _hoc2.default)(Messages);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Minus = function Minus(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '2',
      viewBox: '0 0 22 2'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M1 2h20a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2z'
    })
  );
};

exports.icon = Minus;
exports.default = (0, _hoc2.default)(Minus);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobilePhone = function MobilePhone(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '14',
      height: '22',
      viewBox: '0 0 14 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M2 2.993v16.014c0 .548.446.993.995.993h8.01a1 1 0 0 0 .995-.993V2.993A.995.995 0 0 0 11.005 2h-8.01A1 1 0 0 0 2 2.993zm-2 0A3 3 0 0 1 2.995 0h8.01A2.995 2.995 0 0 1 14 2.993v16.014A3 3 0 0 1 11.005 22h-8.01A2.995 2.995 0 0 1 0 19.007V2.993z'
      }),
      _react2.default.createElement('path', {
        d: 'M0 6h14V4H0zm0 11h14v-2H0z'
      })
    )
  );
};

exports.icon = MobilePhone;
exports.default = (0, _hoc2.default)(MobilePhone);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var More = function More(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '4',
      viewBox: '0 0 16 4'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'rotate(90 8 8)'
      },
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '14',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '8',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '2',
        r: '2'
      })
    )
  );
};

exports.icon = More;
exports.default = (0, _hoc2.default)(More);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewWindow = function NewWindow(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '20',
      viewBox: '0 0 20 20'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M10.707 10.707l8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414z'
      }),
      _react2.default.createElement('path', {
        d: 'M13 2h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2zm3 10.667v3.666c0 .92-.746 1.667-1.667 1.667H3.667C2.747 18 2 17.254 2 16.333V5.667C2 4.747 2.746 4 3.667 4h3.666a1 1 0 1 0 0-2H3.667A3.667 3.667 0 0 0 0 5.667v10.666A3.667 3.667 0 0 0 3.667 20h10.666A3.667 3.667 0 0 0 18 16.333v-3.666a1 1 0 1 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M18 1v6a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0z'
      })
    )
  );
};

exports.icon = NewWindow;
exports.default = (0, _hoc2.default)(NewWindow);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nfc = function Nfc(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '24',
      viewBox: '0 0 18 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M2.772 16.292c.644-1.137.985-2.4.985-3.724a7.627 7.627 0 0 0-1.26-4.207 1 1 0 0 0-1.67 1.103c.6.908.929 1.987.929 3.104 0 .974-.25 1.899-.725 2.738a1 1 0 1 0 1.74.986zm3.916 2.314c1.026-1.728 1.587-3.826 1.587-6.038 0-2.413-.668-4.714-1.863-6.506a1 1 0 1 0-1.664 1.11c.971 1.456 1.527 3.37 1.527 5.396 0 1.858-.466 3.602-1.307 5.016a1 1 0 1 0 1.72 1.022z'
      }),
      _react2.default.createElement('path', {
        d: 'M10.074 21.041c1.72-2.097 2.718-5.173 2.718-8.473 0-3.55-1.158-6.848-3.106-8.93a1 1 0 0 0-1.46 1.366c1.58 1.69 2.566 4.497 2.566 7.564 0 2.856-.853 5.483-2.265 7.205a1 1 0 0 0 1.547 1.268z'
      }),
      _react2.default.createElement('path', {
        d: 'M14.108 23.112c2.189-2.67 3.465-6.602 3.465-10.824 0-4.544-1.479-8.757-3.957-11.405a1 1 0 0 0-1.46 1.366c2.11 2.256 3.417 5.978 3.417 10.039 0 3.779-1.13 7.26-3.012 9.556a1 1 0 0 0 1.547 1.268z'
      })
    )
  );
};

exports.icon = Nfc;
exports.default = (0, _hoc2.default)(Nfc);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = function Notification(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '22',
      viewBox: '0 0 18 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M17.603 16.202C18.368 16.781 17.96 18 17 18H1c-.963 0-1.37-1.227-.597-1.802.042-.031.158-.136.324-.322.302-.337.61-.771.902-1.314.864-1.604 1.39-3.752 1.39-6.527C3.02 4.704 5.706 2 9.023 2c3.317 0 6.004 2.704 6.004 6.035 0 2.777.518 4.927 1.37 6.533.288.542.59.977.888 1.314.164.185.277.29.318.32zm-2.973-.697c-1.007-1.899-1.603-4.37-1.603-7.47C13.027 5.805 11.232 4 9.023 4c-2.21 0-4.004 1.805-4.004 4.035 0 3.101-.606 5.575-1.629 7.475a10.31 10.31 0 0 1-.28.49h11.8c-.093-.156-.186-.32-.28-.495z'
      }),
      _react2.default.createElement('path', {
        d: 'M5 18a4 4 0 1 0 8 0 1 1 0 0 0-2 0 2 2 0 1 1-4 0 1 1 0 0 0-2 0zM8 1v2a1 1 0 1 0 2 0V1a1 1 0 1 0-2 0z'
      })
    )
  );
};

exports.icon = Notification;
exports.default = (0, _hoc2.default)(Notification);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverflowMenu = function OverflowMenu(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '4',
      height: '16',
      viewBox: '0 0 4 16'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'rotate(90 2 2)'
      },
      _react2.default.createElement('circle', {
        cx: '2',
        cy: '2',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '8',
        cy: '2',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '14',
        cy: '2',
        r: '2'
      })
    )
  );
};

exports.icon = OverflowMenu;
exports.default = (0, _hoc2.default)(OverflowMenu);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Plus = function Plus(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M10 1v20a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M1 12h20a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2z'
      })
    )
  );
};

exports.icon = Plus;
exports.default = (0, _hoc2.default)(Plus);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Print = function Print(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '18',
      viewBox: '0 0 22 18'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1 2)'
      },
      _react2.default.createElement('circle', {
        cx: '15',
        cy: '9',
        r: '1'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M7.158 0C6.518 0 6 .518 6 1.158V4h8V1.158C14 .518 13.482 0 12.842 0H7.158zm0-2h5.684A3.158 3.158 0 0 1 16 1.158V6H4V1.158A3.158 3.158 0 0 1 7.158-2z'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M2.413 11.165a1 1 0 0 1 1.002 1l.003.73.002.316.005.668c0 .205-.068.123.084.12h12.959c.225.004.112.132.112-.115l-.005-.66-.003-.318a121.04 121.04 0 0 1-.003-.741 1 1 0 0 1 1.003-1l1.422.004-.023-3.893c0-.588-.657-1.276-1.319-1.276H2.38C1.7 6 1 6.708 1 7.273l.01 3.896 1.403-.004zm16.162 2.043l.005.667c0 1.313-.73 2.143-2.125 2.125H3.523c-1.355.018-2.098-.881-2.098-2.112 0-.15-.003-.39-.005-.663v-.057l-1.404.004a1 1 0 0 1-1.003-.998L-1 7.276C-1 5.608.592 4 2.38 4h15.272c1.788 0 3.32 1.603 3.32 3.27L21 12.166a1 1 0 0 1-1.003 1.006l-1.423-.004v.04z'
      })
    )
  );
};

exports.icon = Print;
exports.default = (0, _hoc2.default)(Print);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recipe = function Recipe(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '19',
      height: '22',
      viewBox: '0 0 19 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M2.802 10.942l.198.266v8.542c0 .138.112.25.25.25h11.5a.25.25 0 0 0 .25-.25v-8.299l.319-.296A5.316 5.316 0 0 0 17 7.25C17 4.344 14.723 2 11.929 2c-1.657 0-3.182.828-4.13 2.202l-.39.565-.669-.162a3.738 3.738 0 0 0-.883-.105C3.733 4.5 2 6.284 2 8.5c0 .898.285 1.748.802 2.442zM1 11.854A6.08 6.08 0 0 1 0 8.5c0-3.307 2.616-6 5.857-6 .233 0 .465.014.694.042C7.877.949 9.825 0 11.929 0 15.84 0 19 3.252 19 7.25a7.33 7.33 0 0 1-2 5.053v7.447A2.25 2.25 0 0 1 14.75 22H3.25A2.25 2.25 0 0 1 1 19.75v-7.896z'
      }),
      _react2.default.createElement('path', {
        d: 'M6 13v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-2 0zm4 0v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-2 0z'
      })
    )
  );
};

exports.icon = Recipe;
exports.default = (0, _hoc2.default)(Recipe);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scan = function Scan(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '18',
      viewBox: '0 0 24 18'
    }, props),
    _react2.default.createElement('path', {
      d: 'M5 6v6a1 1 0 0 0 2 0V6a1 1 0 1 0-2 0zm4 0v6a1 1 0 0 0 2 0V6a1 1 0 0 0-2 0zm4 0v6a1 1 0 0 0 2 0V6a1 1 0 0 0-2 0zm4 0v6a1 1 0 0 0 2 0V6a1 1 0 0 0-2 0zM2 2h3a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V2zm20 0h-3a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V2zM2 16h3a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 2 0v3zm20 0h-3a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0v3z',
      stroke: 'none',
      fillRule: 'nonzero'
    })
  );
};

exports.icon = Scan;
exports.default = (0, _hoc2.default)(Scan);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Settings = function Settings(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '22',
      viewBox: '0 0 24 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M10.37 4.379a1 1 0 0 1-.669.962 6.625 6.625 0 0 0-2.02 1.132 1 1 0 0 1-1.095.114L4.405 5.454c-.017-.009-.065.005-.075.022L2.947 7.814l2.106 1.093a1 1 0 0 1 .523 1.069 5.648 5.648 0 0 0 .042 2.253 1 1 0 0 1-.486 1.089l-2.06 1.16 1.475 2.3c.01.015.051.025.072.013l2.138-1.203a1 1 0 0 1 1.098.077 6.67 6.67 0 0 0 2.062 1.065 1 1 0 0 1 .701.936L10.662 20c0 .002 1.003-.013 3.01-.046l-.043-2.334a1 1 0 0 1 .67-.962 6.625 6.625 0 0 0 2.02-1.132 1 1 0 0 1 1.095-.114l2.181 1.133c.017.009.065-.005.075-.022l1.383-2.338-2.106-1.093a1 1 0 0 1-.523-1.069 5.648 5.648 0 0 0-.042-2.253 1 1 0 0 1 .486-1.089l2.06-1.16-1.475-2.3c-.01-.015-.051-.025-.072-.013l-2.138 1.203a1 1 0 0 1-1.098-.077 6.668 6.668 0 0 0-2.062-1.065 1 1 0 0 1-.701-.936l-.04-2.163c-.002-.082-.105-.174-.27-.17l-2.743.044.042 2.334zM8.329 2.08A1.997 1.997 0 0 1 10.296.045L13.04 0c1.235-.02 2.28.913 2.302 2.134l.028 1.474c.505.206.989.458 1.443.752l1.587-.894a2.064 2.064 0 0 1 2.738.676l1.51 2.358a1.93 1.93 0 0 1-.695 2.74l-1.491.84a7.69 7.69 0 0 1 .029 1.56l1.54.801a1.928 1.928 0 0 1 .771 2.715l-1.41 2.386a2.072 2.072 0 0 1-2.72.779l-1.62-.843a8.625 8.625 0 0 1-1.41.797l.03 1.644a1.994 1.994 0 0 1-1.954 2.036l-3.031.05a2 2 0 0 1-2.025-1.967l-.03-1.646a8.668 8.668 0 0 1-1.444-.752l-1.587.894a2.064 2.064 0 0 1-2.738-.676L1.352 15.5a1.93 1.93 0 0 1 .695-2.74l1.491-.84a7.69 7.69 0 0 1-.029-1.56l-1.54-.801a1.928 1.928 0 0 1-.771-2.715l1.41-2.386a2.072 2.072 0 0 1 2.72-.779l1.62.843a8.625 8.625 0 0 1 1.41-.797l-.03-1.644z'
      }),
      _react2.default.createElement('path', {
        d: 'M12 15a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'
      })
    )
  );
};

exports.icon = Settings;
exports.default = (0, _hoc2.default)(Settings);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreLocation = function StoreLocation(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '24',
      viewBox: '0 0 18 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M10.438 22.824a2.222 2.222 0 0 1-3.132-.256C2.451 16.85 0 12.368 0 9c0-5.288 3.87-9 9-9s9 3.712 9 9c0 3.369-2.451 7.85-7.306 13.568a2.222 2.222 0 0 1-.256.256zM16 9c0-4.164-2.956-7-7-7-4.044 0-7 2.836-7 7 0 2.758 2.261 6.891 6.83 12.274.08.094.22.105.314.026C13.739 15.89 16 11.758 16 9z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'
      })
    )
  );
};

exports.icon = StoreLocation;
exports.default = (0, _hoc2.default)(StoreLocation);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreLocation1 = function StoreLocation1(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '24',
      viewBox: '0 0 18 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M10.687 22.994a2.111 2.111 0 0 1-3.374 0C2.448 16.53 0 11.69 0 8.332 0 3.14 3.72 0 9 0c5.28 0 9 3.14 9 8.332 0 3.357-2.448 8.197-7.313 14.662zM16 8.332C16 4.327 13.243 2 9 2S2 4.327 2 8.332c0 2.79 2.293 7.323 6.911 13.46a.111.111 0 0 0 .156.022C13.707 15.654 16 11.12 16 8.332z'
      }),
      _react2.default.createElement('path', {
        d: 'M8.99 5.61L6.97 6.83l.52.9c.06.11.15.12.27.05l.7-.41v3.49H7.43V12h3.71v-1.14h-.94V5.83c0-.18-.06-.22-.25-.22h-.96z'
      })
    )
  );
};

exports.icon = StoreLocation1;
exports.default = (0, _hoc2.default)(StoreLocation1);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreLocation10 = function StoreLocation10(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '24',
      viewBox: '0 0 18 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M10.687 22.994a2.111 2.111 0 0 1-3.374 0C2.448 16.53 0 11.69 0 8.332 0 3.14 3.72 0 9 0c5.28 0 9 3.14 9 8.332 0 3.357-2.448 8.197-7.313 14.662zM16 8.332C16 4.327 13.243 2 9 2S2 4.327 2 8.332c0 2.79 2.293 7.323 6.911 13.46a.111.111 0 0 0 .156.022C13.707 15.654 16 11.12 16 8.332z'
      }),
      _react2.default.createElement('path', {
        d: 'M6.11 5.61L4.09 6.83l.52.9c.06.11.15.12.27.05l.7-.41v3.49H4.55V12h3.71v-1.14h-.94V5.83c0-.18-.06-.22-.25-.22h-.96zm7.66 3.23c0 1.98-.75 3.28-2.55 3.28-1.8 0-2.57-1.3-2.57-3.28 0-1.98.76-3.29 2.56-3.29s2.56 1.31 2.56 3.29zm-1.82 0c0-1.44-.2-1.98-.74-1.98s-.74.54-.74 1.98.21 1.97.75 1.97.73-.53.73-1.97z'
      })
    )
  );
};

exports.icon = StoreLocation10;
exports.default = (0, _hoc2.default)(StoreLocation10);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tick = function Tick(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '16',
      viewBox: '0 0 18 16'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      fillRule: 'nonzero',
      d: 'M.285 11.51l3.505 3.58a2.6 2.6 0 0 0 3.927-.243L17.796 1.606A1 1 0 0 0 16.204.394L6.126 13.636a.6.6 0 0 1-.906.056L1.715 10.11a1 1 0 1 0-1.43 1.4z'
    })
  );
};

exports.icon = Tick;
exports.default = (0, _hoc2.default)(Tick);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Time = function Time(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M12 5.5a1 1 0 0 0-2 0v6l4.8 3.6a1 1 0 0 0 1.2-1.6l-4-3v-5z'
      }),
      _react2.default.createElement('path', {
        d: 'M11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 2C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11z'
      })
    )
  );
};

exports.icon = Time;
exports.default = (0, _hoc2.default)(Time);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trolley = function Trolley(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '23',
      viewBox: '0 0 22 23'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1 1)'
      },
      _react2.default.createElement('circle', {
        cx: '16',
        cy: '20',
        r: '2'
      }),
      _react2.default.createElement('circle', {
        cx: '6',
        cy: '20',
        r: '2'
      }),
      _react2.default.createElement('path', {
        fillRule: 'nonzero',
        d: 'M2.304 5.57l1.907 8.309A1.445 1.445 0 0 0 5.62 15h10.567c.673 0 1.257-.465 1.408-1.12l1.16-5.046a2.667 2.667 0 0 0-2.598-3.264H2.304zm0 0h-1.26a1 1 0 0 1 0-2h15.112a4.667 4.667 0 0 1 4.548 5.713l-1.16 5.045A3.444 3.444 0 0 1 16.185 17H5.62a3.444 3.444 0 0 1-3.357-2.674L-.975.224a1 1 0 1 1 1.95-.448l1.33 5.794z'
      })
    )
  );
};

exports.icon = Trolley;
exports.default = (0, _hoc2.default)(Trolley);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Upload = function Upload(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '21',
      viewBox: '0 0 20 21'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M9 2v14a1 1 0 0 0 2 0V2a1 1 0 1 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M10 2.414l5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L10 2.414zM1 21h18a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2z'
      })
    )
  );
};

exports.icon = Upload;
exports.default = (0, _hoc2.default)(Upload);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoiceSearch = function VoiceSearch(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '23',
      viewBox: '0 0 16 23'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M8 2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2zm0-2a4 4 0 0 1 4 4v6a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4z'
      }),
      _react2.default.createElement('path', {
        d: 'M0 11c0 3.903 3.613 7 8 7 4.387 0 8-3.097 8-7a1 1 0 0 0-2 0c0 2.724-2.655 5-6 5s-6-2.276-6-5a1 1 0 1 0-2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 22v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0z'
      }),
      _react2.default.createElement('path', {
        d: 'M5 23h6a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z'
      })
    )
  );
};

exports.icon = VoiceSearch;
exports.default = (0, _hoc2.default)(VoiceSearch);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZoomIn = function ZoomIn(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M23.207 21.793l-7.5-7.5a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18z'
      }),
      _react2.default.createElement('path', {
        d: 'M5.5 10h7a1 1 0 0 0 0-2h-7a1 1 0 1 0 0 2z'
      }),
      _react2.default.createElement('path', {
        d: 'M8 5.5v7a1 1 0 0 0 2 0v-7a1 1 0 1 0-2 0z'
      })
    )
  );
};

exports.icon = ZoomIn;
exports.default = (0, _hoc2.default)(ZoomIn);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.icon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoc = __webpack_require__(1);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZoomOut = function ZoomOut(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M23.207 21.793l-7.5-7.5a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18z'
      }),
      _react2.default.createElement('path', {
        d: 'M5.5 10h7a1 1 0 0 0 0-2h-7a1 1 0 1 0 0 2z'
      })
    )
  );
};

exports.icon = ZoomOut;
exports.default = (0, _hoc2.default)(ZoomOut);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/how_to_spot_a_phishing_email.d742c99d.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/suspicious_text.ed8f0e42.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/protect_devices.d87f5798.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/strong_password.641fd054.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/social_media_scam.31b18a95.jpg";

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export YourRights */
/* unused harmony export tabContents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Tabs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_rights_glance_jpg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_rights_glance_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_rights_glance_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_rights_contact_jpg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_rights_contact_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_rights_contact_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_manage_marketing_permissions_jpg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_manage_marketing_permissions_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_manage_marketing_permissions_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_cctv_use_jpg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_cctv_use_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_cctv_use_jpg__);
var YourRights=function YourRights(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_luna_react_components_card__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"Your rights"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"section_subtext"},"Learn more about your data rights and how you can exercise any of your rights")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tabs__["a" /* default */],{items:tabContents}));};var tabContents=[{title:"Your Rights at a Glance",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Access"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right to access a copy of the personal data we hold about you in most circumstances. This is sometimes called a \u2018Subject Access Request\u2019.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Correction of inaccurate personal data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right to have inaccurate personal data that we hold about you corrected. You can always amend your details in your account settings or contact us to let us know what needs changing.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Restriction of processing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right to request that we restrict how we process your personal data in certain circumstances such as if the data has been unlawfully processed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Erasure"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right to have personal data erased. This is also known as the \u2018right to be forgotten\u2019. However this right is not absolute and only applies in certain circumstances.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Portability"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You can request a copy of the personal data you have provided to us in a structured, commonly used and machine readable format.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Object"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right to object to our processing of your personal data based on legitimate interests and to direct marketing.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"m0"},"Automated processing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"You have the right not to be subject to decisions based solely on automated processing, including profiling, which significantly affects you."))),image:__WEBPACK_IMPORTED_MODULE_4__assets_images_tab_images_rights_glance_jpg___default.a},{title:"Contact us or ask a question",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you want to exercise any of your rights or ask us a question, please email"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk")," ","or write to the Data Protection Officer at Privacy Team, Sainsbury's Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If any of your personal data is inaccurate or out of date, please call the Sainsbury\u2019s Careline on ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:0800636262"},"0800 63 62 62")," ","and we\u2019ll correct it."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Before we send you a copy of your personal data or carry out a request, we\u2019ll need to confirm your identity. This allows us to protect customers\u2019 confidentiality and stop personal data falling into the wrong hands. To confirm who you are we\u2019ll need copies of some identification documents, such as your passport or utility bills."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For more information please visit"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/"},"https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/"))),image:__WEBPACK_IMPORTED_MODULE_5__assets_images_tab_images_rights_contact_jpg___default.a},{title:"CCTV use & requests",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use CCTV across all sites in the Sainsbury\u2019s Group for the protection of our colleagues, customers and business. This includes investigating accidents, incidents, criminal activities and breaches of our policies."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"CCTV and ANPR cameras are also in operation in our petrol stations and car parks for these purposes but some of our car parks are run by third parties, so please check the local notice."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Colleagues in some of our stores also wear body-worn cameras for additional protection."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We keep CCTV footage on our systems for up to 31 days, it is then deleted. Where accidents, incidents, criminal activities or breaches of our policies are recorded CCTV footage may be kept for a longer period of time."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Occasionally we share CCTV with public or regulatory authorities or in response to requests from individuals seeking to protect their rights or the rights of others. We will only share your personal information where appropriate."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you want to request CCTV footage of yourself from one of our stores, contact us at"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:privacy@sainsburys.co.uk"},"privacy@sainsburys.co.uk"))),image:__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_cctv_use_jpg___default.a},{title:"Control your marketing permissions",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We\u2019d love to stay in touch with you about our great products, services and offers. For example, we might want to tell you about a brand-new range or send you bonus Nectar points on products you buy."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Visit our"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:__WEBPACK_IMPORTED_MODULE_2__config__["marketingPermissionsUrl"]},"Group Marketing Permissions Centre")," ","where you will be able to tell us about the services that you are most interested in hearing about as well as letting us know that that you no longer want to her from us.")),image:__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_manage_marketing_permissions_jpg___default.a}];/* harmony default export */ __webpack_exports__["a"] = (YourRights);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rights_glance.2876e566.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rights_contact.407418ad.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/manage_marketing_permissions.7a07032d.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cctv_use.1436d6e6.jpg";

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DataGlance */
/* unused harmony export tabContents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luna_react_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Tabs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scss_DataGlance_scss__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scss_DataGlance_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scss_DataGlance_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_personal_data_sharing_jpg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_personal_data_sharing_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_personal_data_sharing_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_personal_data_we_hold_jpg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_personal_data_we_hold_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_personal_data_we_hold_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_tab_images_what_is_personal_data_jpg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_tab_images_what_is_personal_data_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_tab_images_what_is_personal_data_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_tab_images_how_we_keep_your_data_secure_jpg__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_tab_images_how_we_keep_your_data_secure_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_tab_images_how_we_keep_your_data_secure_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_tab_images_how_we_use_your_personal_data_jpg__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_tab_images_how_we_use_your_personal_data_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_tab_images_how_we_use_your_personal_data_jpg__);
var DataGlance=function DataGlance(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_luna_react_components_card__["Card"],{className:"data_glance__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_header center-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"section_title"},"Your data at a glance"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section_subtext"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Learn more about how we collect, hold and protect your data."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Visit our ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/privacy-policy"},"Privacy Policy")," for more information."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Tabs__["a" /* default */],{items:tabContents}));};var tabContents=[{title:"Who are we?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Sainsbury\u2019s Group includes Sainsbury\u2019s Supermarkets, Argos, Tu Clothing, Habitat, Nectar Loyalty Limited, Sainsbury\u2019s Bank and Argos Financial Services. You would provide us with your data when visiting any of our services below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brands__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Wrapper,{matrix:true,horizontalAlign:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--sainsburys"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.sainsburys.co.uk/"},"Sainsbury's"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--argos"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.argos.co.uk/"},"Argos"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--habitat"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.habitat.co.uk/"},"Habitat"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--tu"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://tuclothing.sainsburys.co.uk/"},"Tu Clothing"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--sainsburys_bank"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.sainsburysbank.co.uk/"},"Sainsbury's Bank"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--afs"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.argos.co.uk/webapp/wcs/stores/servlet/CreditAndInsuranceView?langId=110&storeId=10151"},"Argos Financial Services"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_luna_react_components_grid__["Grid"].Item,{className:"brand center-text",size:{xs:"1/2",sm:"1/3",md:"1/4"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brand_logo brand_logo--nectar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"brand_name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.nectar.com/"},"Nectar"))))))},{title:"What is personal data?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Personal data is any information that identifies someone and any information related to them. For example, your name or account numbers identify you, and your interactions with us are related to you."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"All of that is your personal data.")),image:__WEBPACK_IMPORTED_MODULE_8__assets_images_tab_images_what_is_personal_data_jpg___default.a},{title:"What personal data do we hold?",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We hold different personal data about you depending on your relationship with us. Such as:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"The information that you provide to us when you open accounts or place orders"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Records of the communications between us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Information about the services that we provide to you and how you use them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Information required to make decisions about applications you have made for financial services products we offer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Account login details for our services"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"A record of your marketing preferences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"CCTV images, if you visit our premises")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Information from other sources such as specialist companies that provide customer information and information that is publicly available")),image:__WEBPACK_IMPORTED_MODULE_7__assets_images_tab_images_personal_data_we_hold_jpg___default.a},{title:"How we use your personal data",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We use your personal data for different purposes and this depends on our relationship with you. It includes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To provide you with our products and services, such as using your address so we can make a delivery to you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To personalise your shopping experience"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To help provide safe and secure environments for our colleagues to work in, our customers to shop in and for our businesses to be conducted"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"For statistical analysis and to help us understand more about our customers"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"To contact you for marketing purposes, market research, in relation to your accounts, your purchases or about questions you have raised with us"))),image:__WEBPACK_IMPORTED_MODULE_10__assets_images_tab_images_how_we_use_your_personal_data_jpg___default.a},{title:"Who we share your personal data with",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Where appropriate we share personal data with the Sainsbury's Group and with our trusted service providers. In limited circumstances we may share your information with other parties, such as, if we are required to do so by law or where we are asked by a public or regulatory authority."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We may also share your information if we need to exercise or protect our legal rights, users, systems and services or the rights of others")),image:__WEBPACK_IMPORTED_MODULE_6__assets_images_tab_images_personal_data_sharing_jpg___default.a},{title:"How we keep your personal data safe",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We\u2019re serious about protecting your personal data and we\u2019re always developing our security systems and processes. Some of the controls we have in place include;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Limiting user access to our systems"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Technology controls such as firewalls"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Strong data encryption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Proactive monitoring of our systems"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We limit physical access to our buildings"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"We enforce a \u201Cneed to know\u201D policy for access to any data."))),image:__WEBPACK_IMPORTED_MODULE_9__assets_images_tab_images_how_we_keep_your_data_secure_jpg___default.a}];/* harmony default export */ __webpack_exports__["a"] = (DataGlance);

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/personal_data_sharing.6b251122.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/personal_data_we_hold.065fe752.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/what_is_personal_data.6878fb74.jpg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/how_we_keep_your_data_secure.080b00ef.jpg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/how_we_use_your_personal_data.706fb4a0.jpg";

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotFound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_little_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotFound=function(_React$Component){_inherits(NotFound,_React$Component);function NotFound(){_classCallCheck(this,NotFound);return _possibleConstructorReturn(this,(NotFound.__proto__||Object.getPrototypeOf(NotFound)).apply(this,arguments));}_createClass(NotFound,[{key:"componentDidMount",value:function componentDidMount(){var _props$onMount=this.props.onMount,onMount=_props$onMount===undefined?function(){}:_props$onMount;onMount();}},{key:"render",value:function render(){return null;}}]);return NotFound;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["d" /* replace */])("/"));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,mapDispatchToProps)(NotFound));

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_little_router__ = __webpack_require__(4);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"footer__wrapper mt2 p1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"footer__nav"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"footer__nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/",className:"footer__nav_link"},"Privacy Hub")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"footer__nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/privacy-policy",className:"footer__nav_link"},"Privacy Policy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"footer__nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_little_router__["b" /* Link */],{href:"/cookie-policy",className:"footer__nav_link"},"Cookie Policy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"footer__nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.sainsburys.co.uk/accessibility",rel:"noopener noreferrer",target:"_blank",className:"footer__nav_link"},"Accessibility")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"footer__nav_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.sainsburys.co.uk/terms",rel:"noopener noreferrer",target:"_blank",className:"footer__nav_link"},"Terms & Conditions"))));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page"},children);});

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BREADCRUMB_LIST */
var BREADCRUMB_LIST=[{text:"Sainsbury's Privacy Hub",link:"/"}];var tagLine="Sainsbury's Privacy Hub";var routes={"/":{title:"Home | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Home"}]),className:"home"},"/privacy-policy":{title:"Privacy Policy | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Privacy Policy"}]),className:"privacy_policy"},"/cookie-policy":{title:"Cookie Policy | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Cookie Policy"}]),className:"cookie_policy"},"/how-to-keep-your-data-safe":{title:"How to keep your data safe | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"How to keep your data safe"}]),className:"data_safety"},"/your-rights":{title:"Your Rights | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Your Rights"}]),className:"your_rights"},"/your-data-at-a-glance":{title:"Your data at a glance | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Your data at a glance"}]),className:"data_glance"},"/faq":{title:"Frequently Asked Questions | "+tagLine,breadcrumbs:[].concat(BREADCRUMB_LIST,[{text:"Frequently Asked Questions"}]),className:"faq"}};/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
var initialState={items:void 0};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var type=action.type,payload=action.payload;var newState={};switch(type){case"ROUTER_LOCATION_CHANGED":var _payload$result=payload.result,result=_payload$result===undefined?{}:_payload$result;var _result$breadcrumbs=result.breadcrumbs,breadcrumbs=_result$breadcrumbs===undefined?[]:_result$breadcrumbs;newState=Object.assign({},state,{items:breadcrumbs});break;default:newState=Object.assign({},state);break;}return newState;});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleLocationChange; });
var handleLocationChange=function handleLocationChange(store){return function(next){return function(action){var type=action.type,payload=action.payload;if(type==="ROUTER_PUSH"){window.scrollTo(0,0);}if(type==="ROUTER_LOCATION_CHANGED"){var _payload$result=payload.result,result=_payload$result===undefined?{}:_payload$result;var _result$title=result.title,title=_result$title===undefined?"":_result$title;if(title){document.title=title;}var menuToggle=document.getElementById("menu_toggle");if(menuToggle){menuToggle.checked=false;}}next(action);};};};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c303917c.js